/* eslint-disable indent */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { Cliente } from 'src/app/models/cliente';
import { FormaDePagamento } from 'src/app/models/forma-de-pagamento';
import { CondicaoDePagamento } from 'src/app/models/condicao-de-pagamento';
import { ItemDesc, ItemPedido, Pedido } from 'src/app/models/pedido';
import { Fileira } from 'src/app/models/fileira';
import { Produto, ProdutoKit } from 'src/app/models/produto';
import { MatDialog } from '@angular/material';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { GlobalService } from 'src/app/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PedidoService } from 'src/app/services/pedido.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FormaDePagamentoService } from 'src/app/services/forma-de-pagamento.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { CondicaoDePagamentoService } from 'src/app/services/condicao-de-pagamento.service';
import { EnderecoService } from 'src/app/services/endereco.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { Overlay } from '@angular/cdk/overlay';
import swal from 'sweetalert2';
import { ClientesModalComponent } from 'src/app/modals/clientes-modal/clientes-modal.component';
import { opcoesOrientacao, opcoesTelhado } from 'src/app/globals';
import { CadastrarEstruturaComponent } from '../cadastrar-estrutura/cadastrar-estrutura.component';
import {
  EtapaDoPedido,
  OrigemGI,
  StatusDoPedido,
  TipoCalculoPedido,
  TipoEnderecoEntrega,
  TipoVendaFormaPag,
  TipoFiltroProduto,
  TipoVoucher
} from 'src/app/models/enum';
import { DetalheProdutoModalComponent } from 'src/app/modals/detalhe-produto-modal/detalhe-produto-modal.component';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { Ibge } from 'src/app/models/ibge';
import { ViaCepService } from './../../services/via-cep.service';
import { IbgeService } from 'src/app/services/ibge.service';
import { ViaCep } from 'src/app/models/viacep';
import { MASKS } from 'ng-brazil';
import { Comissao } from 'src/app/models/comissao';
import { ComissaoService } from './../../services/comissao.service';
import { ComissoesModalComponent } from 'src/app/modals/comissoes-modal/comissoes-modal.component';
import { LogAcessoService } from './../../services/log-acesso.service';
import { PlatformLocation } from '@angular/common';
import { AnexoModalComponent } from './../../modals/anexo-modal/anexo-modal.component';
import { DetalheEstruturaModalComponent } from 'src/app/modals/detalhe-estrutura-modal/detalhe-estrutura-modal.component';
import { LayoutModalComponent } from 'src/app/modals/layout-modal/layout-modal.component';
import { PremissasService } from 'src/app/services/premissas.service';
import { Frete } from 'src/app/models/frete';
import { FreteService } from 'src/app/services/frete.service';
import { VendaEntrega } from 'src/app/models/venda-entrega';
import { VendaEnderecoModalComponent } from 'src/app/modals/venda-endereco-modal/venda-endereco-modal.component';
import { MotivoPerdaOrcModalComponent } from 'src/app/modals/motivo-perda-orc-modal/motivo-perda-orc-modal.component';
import { VendaDiretaModalComponent } from 'src/app/modals/venda-direta-modal/venda-direta-modal.component';
import { InserirValorModalComponent } from 'src/app/modals/inserir-valor-modal/inserir-valor-modal.component';
import { SelecionarVoucherModalComponent } from 'src/app/modals/selecionar-voucher-modal/selecionar-voucher-modal.component';
import { Voucher } from 'src/app/models/voucher';
import { DescargaService } from 'src/app/services/descarga.service';
import { Descarga } from 'src/app/models/descarga';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { FornecedorEstruturaService } from 'src/app/services/fornecedor-estrutura.service';
import { VendaResposta } from 'src/app/models/venda-resposta';
import { QuestionarioService } from 'src/app/services/questionario.service';
import { VendaPergunta } from 'src/app/models/venda-pergunta';
import { SeguroService } from 'src/app/services/seguro.service';
import { Seguro } from 'src/app/models/seguro';
import { ServicoEntrega } from 'src/app/models/servico-entrega';
import { VendaSeguro } from 'src/app/models/venda-seguro';
import { AlterarValorSeguroModalComponent } from 'src/app/modals/alterar-valor-seguro-modal/alterar-valor-seguro-modal.component';
import { ServicoEntregaService } from 'src/app/services/servico-entrega.service';
import { DescontoIndividualModalComponent } from 'src/app/modals/desconto-individual-modal/desconto-individual-modal.component';
import { MultiFormaPagamentoModalComponent } from 'src/app/modals/multi-forma-pagamento-modal/multi-forma-pagamento-modal.component';
import { InvalidoEstoqueMinimo } from 'src/app/models/invalido-estoque-minimo';
import { ObservacoesModalComponent } from 'src/app/modals/observacoes-modal/observacoes-modal.component';
import { PedidoAnexoComponent } from '../pedido-anexo/pedido-anexo.component';
import { PedidoApelidoModalComponent } from 'src/app/modals/pedido-apelido-modal/pedido-apelido-modal.component';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { TrocarDeLoteModalComponent } from 'src/app/modals/trocar-de-lote-modal/trocar-de-lote-modal.component';
import { PremissasOrcPed } from 'src/app/models/premissas-orc-ped';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { EstruturasPersonalizadas } from 'src/app/models/estruturas-personalizadas';
import { ProdutoBloqueado } from 'src/app/models/produto-bloqueado';
import { PremissasUsuario } from 'src/app/models/premissas-usuario';
import { EstoqueProdutoModalComponent } from 'src/app/modals/estoque-produto-modal/estoque-produto-modal.component';
import { PrecificacaoUFService } from 'src/app/services/precificacao-uf.service';
import { PrecificacaoUF } from 'src/app/models/precificacao-uf';
import { LogsVendaCupomModalComponent } from 'src/app/modals/logs-venda-cupom-modal/logs-venda-cupom-modal.component';
import { DadosCalculo } from 'src/app/models/dados-calculo';
import { MargemLucroComponent } from 'src/app/margem-lucro/margem-lucro.component';
import { AnaliseDescontoService } from 'src/app/services/analise-desconto.service';
import { FaixaDescargaCifService } from 'src/app/services/faixa-descarga-cif.service';
import { FaixaDescargaCIF } from 'src/app/models/faixa-descarga-cif';
import { ProdutosV2ModalComponent } from '../../modals/produtos-v2-modal/produtos-v2-modal.component';
import { QuillCounterModule } from 'src/app/quill-editor/quill-counter-module';
import Quill from 'quill';
import { Fornecedor } from 'src/app/models/fornecedor';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { IndicadorAnaliseDescontoService } from '../../services/indicador-analise-desconto.service';
import { VendaFormaPag } from 'src/app/models/venda-forma-pag';
import { VoucherService } from 'src/app/services/voucher.service';
import { MultiFormaPagamentoComponent } from 'src/app/multi-forma-pagamento/multi-forma-pagamento.component';
import { ProdutosModalComponent } from '../../modals/produtos-modal/produtos-modal.component';
import { PedidoLista } from '../../models/pedido-lista';
import { VendaItemLotesModalComponent } from '../../modals/venda-item-lotes-modal/venda-item-lotes-modal.component';
import { NovaSimulacaoModalComponent } from 'src/app/modals/nova-simulacao-modal/nova-simulacao-modal.component';
import { GiFinSimulacaoModel } from 'src/app/dominio/gi-fin-simulacao-model';
import { SimulacaoService } from 'src/app/financiamento/services/simulacao-service';
import { VendaDiretaComponent } from 'src/app/venda-direta/venda-direta/venda-direta.component';
import { VendaEntregaComponent } from 'src/app/venda-entrega/venda-entrega/venda-entrega.component';

// jquery
declare const $: any;

Quill.register('modules/counter', QuillCounterModule);

@Component({
  selector: 'app-cadastrar-pedido',
  templateUrl: './cadastrar-pedido.component.html',
  styleUrls: ['./cadastrar-pedido.component.scss']
})
export class CadastrarPedidoComponent implements OnInit, AfterViewInit, OnDestroy {
  // variáveis

  premissas: PremissasOrcPed = new PremissasOrcPed();
  premissasSistema = new PremissasSistema();
  premissasUsuario = new PremissasUsuario();

  naoValidarPedido = true;

  idPedido: string;
  editavel = true;
  editando = false;
  pegouFranquia = false;
  cliente: Cliente;
  vendedores = [];
  vendedorSelecionado = undefined;
  formasDePagamento: FormaDePagamento[] = [];
  formaDePagamentoRepasse: boolean = false;
  condicoesDePagamento: Array<{ disabled?: boolean } & CondicaoDePagamento> = [];
  pedido: Pedido = new Pedido();
  fileiras: Fileira[] = [];
  novaFileira: Fileira = new Fileira();
  orientacoes = ['Paisagem', 'Retrato'];
  tabIndex = 0;
  itens: ItemPedido[] = [];
  descontoMaximo = 0;
  limiteDescontoUsuarioLogado = 0;
  comissao: Comissao;
  respostas: VendaResposta[] = [];
  respostasOriginais: VendaResposta[] = [];
  idCupomDuplicado;

  primeiraAlteracao = true;
  buscouClienteFaturamento = false;

  // formas de pagamento
  formasPagamento: VendaFormaPag[] = [];

  itemSemLote = false;

  percentualOriginal = 0;

  percentualCupomDesconto = null;
  valorCupomDesconto = null;

  dadosVendaDireta = { clienteFaturamento: undefined };
  // editandoVendaDireta = false;

  textoCupomAplicado = '';
  textoCupomExcluido = '';

  podeAlterarVendedor = false;

  editandoEnderecoEntrega = false;

  descontoFrete = 0;

  tipoCupomDesconto = 0;

  valorParaFormasPagamento = 0;
  private subtotalPagamentoInicializado = false;

  tabAlvo = 0;
  duplicando = false;
  validaDesconto = false;
  StatusDoPedido = StatusDoPedido;
  podeExcluir = false;
  qtdPainelSugestao = 0;
  alterou = false;
  clienteFaturamento = new Cliente();

  transportadoras: Cliente[] = [];

  produtoEstruturaBloqueado = false;
  IntegVerVlServico = false;

  public MASKS = MASKS;

  tiposDePessoa = [
    { id: 1, nome: 'FÍSICA' },
    { id: 0, nome: 'JURÍDICA' }
  ];
  tiposDeCliente = [
    { id: false, nome: 'Integrador' },
    { id: true, nome: 'Cliente Final' }
  ];
  tiposDeEnderecoEntrega = [
    { id: TipoEnderecoEntrega.Integrador, nome: 'Integrador' },
    { id: TipoEnderecoEntrega.VendaDireta, nome: 'Cliente Final' },
    { id: TipoEnderecoEntrega.Personalizado, nome: 'Personalizado' }
  ];
  tiposDeDesconto = [
    { id: 0, nome: 'Desconto' },
    { id: 1, nome: 'Acréscimo' }
  ];
  tiposDeValor = [
    { id: 0, nome: 'Percentual' },
    { id: 1, nome: 'Valor' }
  ];

  integrador = false;

  freteManual = false;

  percentualFreteAvulso;

  alterouNaTela = false;

  podeConfirmarPedido = false;

  customPatterns = {
    V: { pattern: new RegExp('(,|[0-9]|-|\\.)') },
    0: { pattern: new RegExp('[0-9]') }
  };

  comboSimOuNao = [
    { id: 'N', descricao: 'Não' },
    { id: 'S', descricao: 'Sim' }
  ];

  estados = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO'
  ];
  estadoSelecionado = undefined;
  cidades: Ibge[] = [];
  cidadeSelcionado = undefined;

  nomeVendedor = '';
  lider = '';
  calculadoraMargem = {
    visivel: false,
    custoProdutos: 0,
    margem: 0,
    valorMinimo: 0,
    descontoMaximo: 0,
    descontoMaximoPerc: 0
  };

  verCustos = undefined;

  texto = 'Pedido';

  podeEditarCancelarPedido = true;

  configurouLayout = false;
  tipo: number;
  localizacao = 1;
  frete: Frete;
  fretes: Frete[] = [];
  fretesOriginais: Frete[] = [];
  tipoFrete: any;
  concordarTermos = false;
  valorTaxaCond = 0;
  taxaCondicao = 0;
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();
  enderecoEntregaCompleto: string;
  pesoBruto = 0;
  valorLiquido = 0;
  potencia = 0;
  valorKwp = 0;

  novaQuantidadePaineis;
  podeRecalcularEstrutura = false;

  descargas: Descarga[] = [];
  faixasDescarga: FaixaDescargaCIF[] = [];
  faixa: FaixaDescargaCIF = new FaixaDescargaCIF();
  desabilitaDescargaCIF: boolean = false;
  verTextoTipoCIF: string;
  desabilitaTipoCIF: boolean = false;
  freteDigitado = false;

  freteManualInicial = false;

  perguntas: VendaPergunta[] = [];
  perguntasOriginais: VendaPergunta[] = [];

  questionarioAberto = false;

  usarServicoEntrega = false;
  seguros: Seguro[] = [];
  segurosOriginais: Seguro[] = [];

  servicosEntrega: ServicoEntrega[] = [];
  servicoEntrega;
  valorServicoEntrega;

  valorSeguro = 0;

  segurosObrigatorios: VendaSeguro[] = [];
  segurosManuais: VendaSeguro[] = [];
  segurosObrigatoriosRemovidos: VendaSeguro[] = [];

  permissoesPedidoFuncionario = {
    podeEditarFrete: false,
    podeEditarServicoEntrega: false,
    podeEditarSeguro: false,
    podeDescontoIndividual: false,
    podeVerTotaisMonitores: false
  };

  valorServicoEntregaEditado = false;

  valorProjetoLiquido = 0;

  estoqueLoteOk = true;

  limDescVendedorPedido = 0;

  exibirEstoque = false;

  itensComposicao: ProdutoKit[] = [];

  usuarioLogado: UsuarioLogado;

  administrador = false;

  mostraMsgEnderecoAdicional: boolean = false;
  podeVerEstoque = false;

  valorArredondamento;

  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  podeCalcular = false;

  private calculoNormalEmAndamento = false;
  private calculoNormalPendente = false;
  private recalcularFreteManualCalculoPendente = false;
  private promessaCalculoNormal: Promise<any> = Promise.resolve();

  private nivelAgrupamentoCalculos = 0;
  private calculoAgrupadoPendente = false;
  private recalculoFreteAgrupadoPendente = false;
  private recalcularFreteManualAgrupado = false;
  private recalculoPosClampDescontoPendente = false;

  precificacoesUF: PrecificacaoUF[] = [];

  descAcresPrecificacaoUF: PrecificacaoUF;

  produtosBloqueados = [];

  usuarioPodeCancelar = false;

  textoUltLogDispEstoque: string = '';

  suporte = false;

  validandoPedido = false;

  lojaDeProdutos: boolean = false;

  descontoDaAnalise;

  podeVerSubstituicao: boolean = false;

  possuiAnaliseDescontoEmAndamento = false;

  larguraTela: number;
  verModalidades: boolean = false;

  tipoCIFFlag: number = null;

  cidadeOriginal;
  ibgeEntrega: Ibge;

  cdSelecionado: Fornecedor;

  podeAlterarCD = false;

  cor = '';

  jsonItensBanco: string = '';

  podeAplicarVoucher = false;

  usandoArredondamento = false;

  alterouValorProdutos = false;

  mostrarValoresServico = false;

  mostrarTotaisFixos = false;

  private observer?: IntersectionObserver;

  // aceita modelos vindos do serviço de simulação (GiFinSimulacaoModel) ou respostas de cupom (SimulacaoVendaCupomResponse)
  infoSimulacaoPedido: GiFinSimulacaoModel | null = null;

  @ViewChild('margemLucro', { static: false }) margemLucro: MargemLucroComponent;
  @ViewChild('multiFormaPagamentoComp', { static: false }) multiFormaPagamentoComp: MultiFormaPagamentoComponent;
  @ViewChild('vendaDiretaComp', { static: false }) vendaDiretaComp: VendaDiretaComponent;
  @ViewChild('vendaEntregaComp', { static: false }) vendaEntregaComp: VendaEntregaComponent;
  @ViewChild('totais', { static: false }) totais!: ElementRef;

  constructor(
    private hierarquiaService: CRMHierarquiaUsuarioService,
    public dialog: MatDialog,
    private funcionarioService: FuncionarioService,
    private comissaoService: ComissaoService,
    private globalService: GlobalService,
    private viaCepService: ViaCepService,
    private ibgeService: IbgeService,
    private route: ActivatedRoute,
    private router: Router,
    private pedidoService: PedidoService,
    private clienteService: ClienteService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private formadePagamentoService: FormaDePagamentoService,
    public utilitarioService: UtilitarioService,
    private condicaoDePagamentoService: CondicaoDePagamentoService,
    private enderecoService: EnderecoService,
    private produtoService: ProdutoService,
    private overlay: Overlay,
    private relatorioService: RelatorioService,
    private logAcessoService: LogAcessoService,
    private platformLocation: PlatformLocation,
    private premissasService: PremissasService,
    private freteService: FreteService,
    private descargaService: DescargaService,
    private fornecedorEstruturaService: FornecedorEstruturaService,
    private questionarioService: QuestionarioService,
    private seguroService: SeguroService,
    private servicoEntregaService: ServicoEntregaService,
    private precificacaoUFService: PrecificacaoUFService,
    private analiseDescontoService: AnaliseDescontoService,
    private faixaDescargaService: FaixaDescargaCifService,
    private fornecedorService: FornecedorService,
    private indicadorService: IndicadorAnaliseDescontoService,
    private voucherService: VoucherService,
    private simulacaoService: SimulacaoService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    const state = this.router.getCurrentNavigation().extras.state;

    if (state && state.avisar) {
      swal({
        title: 'Atenção!!!',
        text: 'Revise sua venda!!!',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      });
    }

    if (this.route.snapshot.paramMap.get('id')) {
      this.idPedido = this.route.snapshot.paramMap.get('id');
    }

    if (state && state.duplicando) {
      this.duplicando = true;
      this.idPedido = state.idCupom;
      this.idCupomDuplicado = this.idPedido;
    }

    if (state && state.tipo) {
      this.tipo = state.tipo;
    }

    if (state && state.descontoDaAnalise) {
      this.descontoDaAnalise = state.descontoDaAnalise;
    }
  }

  async buscarPremissasOrcPed() {
    try {
      this.carregandoService.mostra('buscarPremissasOrcPed');
      this.premissas = await this.premissasService.consultarPremissasOrcPed().toPromise();

      this.premissas.confirmarSemValidar = this.premissas.confirmarSemValidar && this.tipo === 1;

      if (this.premissas.usarServicoEntrega) {
        await this.buscarServicosEntrega();
      }

      this.premissas.naoCalcularFrete = !this.premissas.kitProntoFrete;
      this.premissas.naoCalcularDesconto = !this.premissas.kitProntoDesconto;

      if (this.premissas.camposQuestionariosObrigatorio) {
        this.questionarioAberto = true;
      }

      if (this.premissas.podeAlterarValorFinal) {
        this.buscarValorArredondamento();
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasOrcPed');
    }
  }

  async buscarCD() {
    try {
      this.carregandoService.mostra('buscarCD');
      this.cdSelecionado = await this.fornecedorService.consultarPorIdFornecedor(this.pedido.idFornecedor).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarCD');
    }
  }

  buscarValorArredondamento() {
    this.carregandoService.mostra('buscarValorArredondamento');
    this.premissasService.consultarValorArredondamento().subscribe(
      (f) => {
        this.valorArredondamento = f.valor;
        this.carregandoService.esconde('buscarValorArredondamento');
      },
      (erro) => {
        this.carregandoService.esconde('buscarValorArredondamento');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async atualizaMultiFormasPagamento(naoAtualizaTaxa?) {
    if (!naoAtualizaTaxa) {
      await this.atualizarTaxaDeCondicao();
    }
  }

  async alterouValorServico() {
    await this.executarAlteracoesEmLote(async () => {
      this.alterou = true;
      this.alterouNaTela = true;

      if (this.multiFormaPagamentoComp) {
        this.changeDetectorRef.detectChanges();
        this.multiFormaPagamentoComp.recarregarFormasPagamentoPrimeiraForma();
      }

      await this.atualizaValores();
      await this.recalculaFreteManual();
    });
  }

  async alterouLocalizacao() {
    await this.executarAlteracoesEmLote(async () => {
      this.alterou = true;
      this.alterouNaTela = true;

      await this.atualizaValores();

      if (this.premissasSistema.excluirCupomDescontoAoMudarLocalizacao && this.pedido.cupomDesconto != null) {
        await this.excluirCupomDesconto();
      }
    });
  }

  // atualiza o tabIndex
  proximaTab() {
    this.tabIndex++;
    if (this.tabIndex === 2) {
      this.margemLucro.calcularValoresCalculadoraMargem();
    }
  }

  tabAnterior() {
    this.tabIndex--;
    if (this.tabIndex === 2) {
      this.margemLucro.calcularValoresCalculadoraMargem();
    }
  }

  async alterouValorDoFrete(frete: Frete = new Frete()) {
    if ((this.premissas.pVendEditarFrete || this.freteManual) && this.pedido.tipoFrete === 0) {
      this.pedido.tipoLocalizacao = 1;
      this.freteDigitado = true;
      this.alterou = true;

      if (frete !== null && frete !== undefined && frete.valorFrete !== 0) {
        if (this.verModalidades) {
          const valorOriginal = this.fretesOriginais.find((f) => f.id === frete.id).valorFrete;

          if (valorOriginal !== frete.valorFrete) {
            this.pedido.frete = Number(frete.valorFrete);
            this.verModalidades = false;
          } else {
            this.freteDigitado = false;
            this.alterou = false;
          }
        }
      }

      await this.atualizaValores();

      if (this.premissasSistema.excluirCupomDescontoAoMudarValorFrete) {
        await this.excluirCupomDesconto(false);
      }
    }
  }

  buscarPermissoesFuncionario() {
    this.carregandoService.mostra('buscarPermissoesFuncionario');
    this.funcionarioService.consultarPermissoesPedido().subscribe(
      (f) => {
        this.permissoesPedidoFuncionario = f;

        this.carregandoService.esconde('buscarPermissoesFuncionario');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPermissoesFuncionario');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async alterouExibirEstoque() {
    if (this.exibirEstoque) {
      await this.buscarEstoque();
    }
  }

  async buscarEstoque() {
    try {
      this.carregandoService.mostra('buscarEstoque');

      const estoque = await this.produtoService
        .buscarEstoque(
          this.itens.map((p) => p.produto),
          this.pedido.idFornecedor === null || this.pedido.idFornecedor === undefined ? null : this.pedido.idFornecedor,
          this.pedido.idCupom
        )
        .toPromise();

      this.itens.forEach((p) => {
        const estoqueDoProduto = estoque.find((e) => e.idProduto === p.produto);

        if (estoqueDoProduto) {
          p.produtoTela.qtEstoque = estoqueDoProduto.qtEstoque;
          p.produtoTela.qtReserva = estoqueDoProduto.qtReserva;
        } else {
          p.produtoTela.qtEstoque = 0;
          p.produtoTela.qtReserva = 0;
        }
      });

      this.carregandoService.esconde('buscarEstoque');
    } catch (erro) {
      this.carregandoService.esconde('buscarEstoque');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarItensComposicao() {
    try {
      this.carregandoService.mostra('buscarItensComposicao');

      if (this.itens.some((p) => p.produtoTela.familia === 7)) {
        this.itensComposicao = await this.produtoService
          .buscarComposicoes(
            this.itens.filter((p) => p.produtoTela.familia === 7).map((p) => p.produto),
            this.pedido.idFornecedor,
            this.pedido.idCupom
          )
          .toPromise();
      } else {
        this.itensComposicao = [];
      }

      this.carregandoService.esconde('buscarItensComposicao');
    } catch (erro) {
      this.carregandoService.esconde('buscarItensComposicao');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarSeguros() {
    try {
      this.carregandoService.mostra('buscarSeguros');
      let idCupom = null;

      if (!this.duplicando && !(this.pedido.flag === 4 && this.pedido.status === 0)) {
        idCupom = this.pedido.idCupom;
      }

      let seguros = await this.seguroService.consultarLista(idCupom).toPromise();

      if (this.pedido.origemGI === 2) {
        seguros = seguros.filter((p) => p.apareceAvulso);
      } else if (this.pedido.origemGI === 3) {
        seguros = seguros.filter((p) => p.apareceLojaProduto);
      }

      this.seguros = seguros;
      this.segurosOriginais = JSON.parse(JSON.stringify(this.seguros));
    } catch (err) {
      this.notificacaoService.erro(err);
    } finally {
      this.carregandoService.esconde('buscarSeguros');
    }
  }

  async buscarPossuiAnaliseDescontoEmAndamento() {
    try {
      this.carregandoService.mostra('possuiAnaliseDescontoEmAndamento');
      this.possuiAnaliseDescontoEmAndamento = await this.analiseDescontoService
        .consultarPossuiAnaliseEmAndamento(this.pedido.idCupom)
        .toPromise();
    } catch (err) {
      this.notificacaoService.erro(err);
    } finally {
      this.carregandoService.esconde('possuiAnaliseDescontoEmAndamento');
    }
  }

  async buscarServicosEntrega() {
    try {
      this.carregandoService.mostra('buscarServicoEntrega');
      this.servicosEntrega = await this.servicoEntregaService.consultarListaServicosEntrega().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarServicoEntrega');
    }
  }

  buscarFaixasDescarga() {
    this.carregandoService.mostra('buscarFaixaDescargaCif');
    this.faixaDescargaService.consultarFaixas().subscribe(
      async (dados) => {
        this.faixasDescarga = dados;

        if (this.faixasDescarga != null && this.faixasDescarga.length > 0) {
          if (this.itens != null && this.itens.length > 0) {
            this.itens.forEach((it) => {
              if (it.produtoTela.familia === 2) {
                this.faixa = this.faixasDescarga.find((f) => it.qt >= f.de && it.qt <= f.ate);

                if (this.faixa == null || this.faixa === undefined) {
                  this.desabilitaDescargaCIF = true;
                  this.pedido.tipoCIF = 0;
                } else {
                  this.desabilitaDescargaCIF = false;
                }
              } else if (it.produtoTela.familia === 7) {
                it.produtoTela.composicao.forEach((c) => {
                  if (c.produtoMP.familia === 2) {
                    this.faixa = this.faixasDescarga.find((f) => c.qt * it.qt >= f.de && c.qt * it.qt <= f.ate);

                    if (this.faixa == null || this.faixa === undefined) {
                      this.desabilitaDescargaCIF = true;
                      this.pedido.tipoCIF = 0;
                    } else {
                      this.desabilitaDescargaCIF = false;
                    }
                  }
                });
              }
            });
          }
        } else {
          this.desabilitaDescargaCIF = true;
        }

        this.carregandoService.esconde('buscarFaixaDescargaCif');
        this.avaliarMensagemDescarga();
      },
      (err) => {
        this.carregandoService.esconde('buscarFaixaDescargaCif');
        this.notificacaoService.erro(err);
      }
    );
  }

  validaFaixaDescarga() {
    if (this.faixasDescarga != null && this.faixasDescarga.length > 0) {
      if (this.itens != null && this.itens.length > 0) {
        this.itens.forEach((it) => {
          if (it.produtoTela.familia === 2) {
            this.faixa = this.faixasDescarga.find((f) => it.qt >= f.de && it.qt <= f.ate);

            if (this.faixa == null || this.faixa === undefined) {
              this.desabilitaDescargaCIF = true;
              this.pedido.tipoCIF = 0;
            } else {
              this.desabilitaDescargaCIF = false;
            }
          } else if (it.produtoTela.familia === 7) {
            it.produtoTela.composicao.forEach((c) => {
              if (c.produtoMP.familia === 2) {
                this.faixa = this.faixasDescarga.find((f) => c.qt * it.qt >= f.de && c.qt * it.qt <= f.ate);

                if (this.faixa == null || this.faixa === undefined) {
                  this.desabilitaDescargaCIF = true;
                  this.pedido.tipoCIF = 0;
                } else {
                  this.desabilitaDescargaCIF = false;
                }
              }
            });
          }
        });
      }

      this.avaliarMensagemDescarga();
    } else {
      this.desabilitaDescargaCIF = true;
    }
  }

  avaliarMensagemDescarga() {
    this.verTextoTipoCIF = null;

    if (!this.premissasSistema.usaDescargaCif) return;

    if (this.pedido.tipoFrete === 1) return;

    if (!this.faixa) {
      this.desabilitaTipoCIF = true;
      this.pedido.tipoCIF = 0;
      this.verTextoTipoCIF = 'Responsabilidade de descarga total do integrador.';

      return;
    }

    const ate = this.faixa.ate;

    if (ate > 144) {
      this.desabilitaTipoCIF = true;
      this.pedido.tipoCIF = 0;
      this.tipoCIFFlag = 0;
      this.verTextoTipoCIF = 'Responsabilidade de descarga total do integrador.';
      this.alteraFrete();
      return;
    }

    this.desabilitaTipoCIF = false;
    if (this.pedido.tipoCIF == null) return;

    switch (ate) {
      case 36:
        this.verTextoTipoCIF =
          this.pedido.tipoCIF === 0
            ? 'Responsabilidade de descarga total do integrador.'
            : 'Caso haja necessidade de empilhadeira ou transbordo o custo adicional será de responsabilidade do integrador.';
        break;

      case 72:
      case 144:
        this.verTextoTipoCIF =
          this.pedido.tipoCIF === 0
            ? 'Responsabilidade de descarga total do integrador.'
            : 'Caso haja necessidade de empilhadeira ou transbordo o custo adicional será de responsabilidade do integrador.';
        break;

      default:
        break;
    }
  }

  async buscarPedido() {
    try {
      this.carregandoService.mostra('buscaPedido');

      // const orc = await this.pedidoService
      //   .consultarCompleto(this.idPedido, this.duplicando, false, false, true, this.duplicando)
      //   .toPromise();

      const buscarItens = () =>
        this.pedidoService
          .bC_Itens(
            this.idPedido,
            this.duplicando,
            false, // buscarEstoque
            false, // buscarFoto
            this.duplicando
          )
          .toPromise();

      // Estas chamadas começam imediatamente.
      const pedidoPromise = this.pedidoService
        .bC_Pedido(this.idPedido, this.duplicando, false, this.duplicando)
        .toPromise();

      const fileirasPromise = this.pedidoService.bC_Fileiras(this.idPedido, false).toPromise();

      const enderecoPromise = this.pedidoService.bC_EnderecoDeEntrega(this.idPedido).toPromise();

      const respostasPromise = this.pedidoService.bC_Respostas(this.idPedido).toPromise();

      const limDescPromise = this.pedidoService.bC_LimDesc(this.idPedido).toPromise();

      /*
       * Quando vendaProgramada estiver habilitada, precisamos aguardar
       * BC_Pedido para descobrir se o pedido é um orçamento.
       *
       * Nos demais casos, BC_Itens começa imediatamente.
       */
      const itensPromise = this.premissas.vendaProgramada
        ? pedidoPromise.then((pedido) => {
            // BC_Pedido já terminou neste ponto.
            return buscarItens();
          })
        : buscarItens();

      const [venda, itens, fileiras, enderecoDeEntrega, respostas, limDesc] = await Promise.all([
        pedidoPromise,
        itensPromise,
        fileirasPromise,
        enderecoPromise,
        respostasPromise,
        limDescPromise,
        this.buscarPerguntasEntrega()
      ]);

      const orc = {
        venda,
        itens,
        fileiras,
        enderecoDeEntrega,
        respostas,
        limDesc
      };

      if (this.duplicando) {
        this.editavel = true;
      } else {
        if (
          this.integrador &&
          orc.venda.status === StatusDoPedido.Ativo &&
          (orc.venda.ordemEtapa <= 1 || orc.venda.ordemEtapa === 38)
        ) {
          this.editavel = true;
        } else if (
          !this.integrador &&
          orc.venda.status === StatusDoPedido.Ativo &&
          (orc.venda.ordemEtapa === 0 ||
            orc.venda.ordemEtapa === 10 ||
            orc.venda.ordemEtapa === 19 ||
            orc.venda.ordemEtapa === 38)
        ) {
          this.editavel = true;
        } else {
          this.editavel = false;
        }

        if (orc.venda.orcamento && orc.venda.tipoIntegracao === 1) {
          this.editavel = false;
        }
      }

      this.respostasOriginais = orc.respostas;
      this.pedido = orc.venda;
      this.percentualOriginal = this.pedido.percentual;

      if (this.pedido.idEtapa == null && !this.premissasSistema.habilitaOrcamento) {
        this.notificacaoService.erro('Acesso restrito!');
        this.router.navigate(['/']);
      }

      this.pedido.multiFormaPagamento = this.premissas.podeUsarMultiFormaPagamento;

      if (this.pedido.vendaDireta) {
        this.definirDadosVendaDireta();
      }

      if (
        this.premissas.pCentroDistribuicao &&
        this.premissasSistema.habilitarCDPorCidade &&
        this.pedido.idFornecedor
      ) {
        await this.buscarCD();
      }

      if (this.premissas.usarSeguro) {
        await this.buscarSeguros();
      } else {
        this.premissas.usarSeguro = false;
      }

      if (this.premissas.pDispEstoque && this.pedido.origemGI === 3) {
        this.premissas.pDispEstoque = false;
      }

      this.segurosObrigatoriosRemovidos = [...this.pedido.seguros.filter((p) => p.obrigatorioRemovido)];
      this.pedido.seguros = [...this.pedido.seguros.filter((p) => !p.obrigatorioRemovido)];

      this.valorServicoEntregaEditado = this.pedido.servicoEntregaManual;

      this.percentualCupomDesconto = this.pedido.cupomDesconto;
      this.valorCupomDesconto = this.pedido.cupomDescontoValor;
      this.tipoCupomDesconto = this.pedido.tipoCupomDesconto;

      this.freteManual = this.pedido.freteManual;
      this.freteManualInicial = this.pedido.freteManual;
      this.freteDigitado = this.pedido.freteManual;

      if (this.pedido.flag === 1 || this.pedido.status !== StatusDoPedido.Ativo) {
        this.valorLiquido = this.pedido.valorServicoLiquido;
      }

      await this.atualizaMultiFormasPagamento();

      if (this.pedido.orcamento) {
        this.tipo = 0;
      }

      let valorServicoOriginal = this.pedido.valorServico;
      let valorProjetoOriginal = this.pedido.valorProjeto;

      this.enderecoDeEntrega = orc.enderecoDeEntrega;

      this.cidadeOriginal = this.enderecoDeEntrega.ibge.toString();
      this.ibgeEntrega = this.enderecoDeEntrega.ibge
        ? await this.ibgeService.buscarCidadePorCodIGBE(this.enderecoDeEntrega.ibge.toString()).toPromise()
        : undefined;

      this.gerarEnderecoEntregaCompleto();

      this.valorTaxaCond = this.pedido.taxaDA;

      if (Number(this.pedido.valorDa) < 0) {
        this.pedido.valorDa = Number(this.pedido.valorDa) * -1;
      } else {
        this.pedido.valorDa = Number(this.pedido.valorDa);
      }

      this.valorSeguro = this.pedido.valorSeguro;
      this.limDescVendedorPedido = orc.limDesc;

      this.podeExcluir =
        this.pedido.status === StatusDoPedido.Ativo &&
        ((this.integrador && this.pedido.flag === 4) || (!this.integrador && this.podeEditarCancelarPedido));

      this.itens = [];
      this.fileiras = orc.fileiras;

      this.fileiras.forEach((forn: any) => {
        if (forn.idFornecedorEstrutura !== null && forn.idFornecedorEstrutura !== undefined) {
          forn.logo$ = this.fornecedorEstruturaService
            .consultarImagemPorId(forn.idFornecedorEstrutura)
            .map((m) =>
              m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('')
            )
            .toPromise();
          forn.logo$.then((p) => {
            forn.buscouImagem = true;
          });
        }
      });

      this.calcularQtdPaineis();

      this.fileiras.forEach((f) => {
        f.opcaoOrientacao = opcoesOrientacao.find((p) => p.id === f.orientacao);
        f.opcaoTelhado = opcoesTelhado.find((p) => p.id === f.telhado);
      });
      this.configurouLayout =
        this.fileiras.length > 0 && this.pedido.painelProduto !== undefined && this.pedido.painelProduto !== null;

      this.vendedorSelecionado = this.pedido.vendedor;

      if (this.integrador && (!this.idPedido || this.duplicando)) {
        // buscarCliente pode trocar o vendedor neste fluxo.
        await this.buscarNomeVendedor();
        await this.buscarLimDescVendedor();
        await this.buscarCliente();
      } else {
        const buscarDescontoEmParalelo = !this.premissasUsuario.atualizaDadosReceitaIntegrador;
        const consultasClienteVendedor = [
          this.buscarNomeVendedor(),
          this.buscarLimDescVendedor(),
          this.buscarCliente(!buscarDescontoEmParalelo)
        ];

        if (buscarDescontoEmParalelo) {
          consultasClienteVendedor.push(this.buscarDescontoMaximo(this.pedido.cliente));
        }

        await Promise.all(consultasClienteVendedor);
      }

      this.itens = orc.itens;
      this.ordenaProdutos();

      this.jsonItensBanco = JSON.stringify(
        this.itens.map((p) => {
          return { idProduto: p.produto, qt: p.qt };
        })
      );

      this.lojaDeProdutos =
        this.pedido.origemGI === 3 && (await this.premissasService.consultarUsarLojaProdutos().toPromise()).valor;

      for (const it of this.itens) {
        it.produtoTela.descricaoAtual = it.det1;

        if (this.pedido.flag === 4 && this.pedido.status === StatusDoPedido.Ativo) {
          await this.atualizaValorProduto(
            it,
            this.pedido.valorTotalFixo !== null &&
              this.pedido.valorTotalFixo !== undefined &&
              this.pedido.valorTotalFixo > 0,
            false
          );
        }

        // if (this.lojaDeProdutos && it.produtoTela.multiplo && it.produtoTela.valorMultiplo > 0) {
        //   it.qt = it.produtoTela.valorMultiplo * it.qt;
        // }
      }

      if (
        this.pedido.status === StatusDoPedido.Ativo &&
        (this.pedido.flag === 4 || this.duplicando) &&
        this.itens.some((p) => p.produtoTela.familia === 2 || p.produtoTela.familia === 3)
      ) {
        for (const item of this.itens.filter((p) => p.produtoTela.familia === 2 || p.produtoTela.familia === 3)) {
          await this.atualizaValorProduto(
            item,
            this.pedido.valorTotalFixo !== null &&
              this.pedido.valorTotalFixo !== undefined &&
              this.pedido.valorTotalFixo > 0,
            false
          );
        }
      }

      if (this.pedido.status !== StatusDoPedido.Ativo || (this.pedido.flag === 1 && !this.duplicando)) {
        this.pedido.percentual = Number(((this.pedido.valorDa * 100) / this.pedido.valorTotal).toFixed(2));
        this.pedido.valorFinal = Number(this.pedido.valorTotalCalculado);
        // if (this.pedido.da === 0) {
        //   this.pedido.valorFinal = Number((this.pedido.valorTotal - Number(this.pedido.valorDa) + Number(this.pedido.frete) + Number(this.pedido.valorServico)).toFixed(2));
        // } else {
        //   this.pedido.valorFinal = Number((this.pedido.valorTotal + Number(this.pedido.valorDa) + Number(this.pedido.frete) + Number(this.pedido.valorServico)).toFixed(2));
        // }
      }

      if (
        this.pedido.formasPagamento === null ||
        this.pedido.formasPagamento === undefined ||
        this.pedido.formasPagamento.length === 0
      ) {
        this.pedido.formasPagamento = [];

        const novaForma = new VendaFormaPag();
        novaForma.tipo = TipoVendaFormaPag.Variavel;
        novaForma.valor = 0;
        novaForma.total = 0;
        this.pedido.formasPagamento.push(novaForma);
      } else if (
        this.pedido.formasPagamento.length === 1 &&
        !this.pedido.multiFormaPagamento &&
        this.premissas.podeUsarMultiFormaPagamento &&
        this.pedido.formasPagamento[0].tipo !== TipoVendaFormaPag.Variavel
      ) {
        this.pedido.formasPagamento[0].tipo = TipoVendaFormaPag.Variavel;
        this.pedido.formasPagamento[0].total = Number(
          this.pedido.valorTotalFixo === null || this.pedido.valorTotalFixo === undefined
            ? this.pedido.valorFinal
            : this.pedido.valorTotalFixo
        );
      }

      this.pedido.multiFormaPagamento = this.premissas.podeUsarMultiFormaPagamento;

      // this.verificaFormaPagamentoRepasse();

      this.buscarRespostas();

      // await this.atualizaDesconto(0, true, this.pedido.valorTotalFixo !== null && this.pedido.valorTotalFixo !== undefined && this.pedido.valorTotalFixo > 0);
      await this.atualizaDadosPedido(!this.duplicando);

      await this.buscarFrete(
        this.pedido.idFrete !== null && this.pedido.idFrete !== undefined && this.pedido.idFrete > 0
      );

      if (this.pedido.flag === 4 && this.pedido.status === StatusDoPedido.Ativo) {
        await this.atualizarDescontoPrecificacaoUF();
      }

      this.pedido.valorServico = valorServicoOriginal;
      this.pedido.valorProjeto = valorProjetoOriginal;

      if (this.pedido.status === StatusDoPedido.Ativo) {
        if (this.descontoDaAnalise && this.pedido.flag === 4) {
          this.pedido.da = 0;
          await this.usarCupomDesconto();
          // this.alterou = true;
          // this.alterouNaTela = true;
          // this.pedido.da = 0;
          // this.pedido.valorDa = this.descontoDaAnalise;
          // await this.atualizaDesconto(1, true, this.pedido.valorTotalFixo !== null && this.pedido.valorTotalFixo !== undefined && this.pedido.valorTotalFixo > 0);
        } else {
          await this.atualizaDesconto(
            1,
            this.pedido.flag === 4,
            this.pedido.valorTotalFixo !== null &&
              this.pedido.valorTotalFixo !== undefined &&
              this.pedido.valorTotalFixo > 0
          );
        }
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaPedido');
    }
  }

  buscarUltimosPrecos() {
    if (this.premissasSistema.mostrarColunasAdicionaisPreco && !this.integrador) {
      this.itens.forEach((i) => {
        if (!i.buscouUltimoPreco) {
          this.pedidoService.consultarUltimoPreco(this.pedido.cliente, i.produto, this.pedido.idCupom).subscribe(
            (resp) => {
              i.ultimoPreco = resp.valor;
              i.idCupomUltimoPreco = resp.idCupom;
              i.dataUltimoPreco = resp.data;
              i.buscouUltimoPreco = true;
            },
            (erro) => {
              i.ultimoPreco = undefined;
              i.idCupomUltimoPreco = undefined;
              i.dataUltimoPreco = undefined;
            }
          );
        }
      });
    }
  }

  verificaFormaPagamentoRepasse() {
    // verifica se buscou as formas de pagamento
    if (this.formasDePagamento != null && this.formasDePagamento != undefined && this.formasDePagamento.length > 0) {
      if (
        this.pedidoComFormaDePagamento() &&
        this.pedido.formasPagamento.some((p) => p.idFormaPag !== undefined && p.idFormaPag !== null)
      ) {
        const formas = this.pedido.formasPagamento.filter((p) => p.idFormaPag !== undefined && p.idFormaPag !== null);

        this.formaDePagamentoRepasse = this.formasDePagamento.some(
          (p) => formas.some((f) => f.idFormaPag === p.id) && p.repasse
        );

        if (!this.formaDePagamentoRepasse) {
          this.pedido.valorServico = 0;
        }
      }
    }
  }

  async alterouFormaPagamento() {
    await this.executarAlteracoesEmLote(async () => {
      this.alterou = true;
      // this.verificaFormaPagamentoRepasse();
      await this.atualizarTaxaDeCondicao();
      await this.recalculaFreteManual();
    });
  }

  pedidoComFormaDePagamento() {
    return (
      this.pedido.formasPagamento !== null &&
      this.pedido.formasPagamento !== undefined &&
      this.pedido.formasPagamento.length > 0
    );
  }

  pedidoComCondicaoDePagamento() {
    return (
      this.pedidoComFormaDePagamento() &&
      this.pedido.formasPagamento[0].idCondPag !== null &&
      this.pedido.formasPagamento[0].idCondPag !== undefined
    );
  }

  buscarRespostas() {
    if (this.respostasOriginais.length === 0) return;

    const tipoFrete = this.pedido.tipoFrete;

    this.respostas = this.respostasOriginais.filter((resposta) => resposta.tipoQuest === tipoFrete);
    const idsPerguntasComResposta = this.respostas.map((resposta) => resposta.idPergunta);

    this.perguntas = this.perguntasOriginais.filter(
      (pergunta) =>
        pergunta.tipoQuest === tipoFrete && (idsPerguntasComResposta.includes(pergunta.id) || pergunta.status)
    );

    this.respostas.forEach((resposta) => {
      const perguntaCorrespondente = this.perguntas.find((pergunta) => pergunta.id === resposta.idPergunta);

      if (perguntaCorrespondente) {
        perguntaCorrespondente.respostaSN = resposta.respostaSN;
        perguntaCorrespondente.respostaTexto = resposta.respostaTexto;
      }
    });
  }

  async buscarNomeVendedor() {
    try {
      this.nomeVendedor = '';
      this.lider = '';

      if (this.vendedorSelecionado !== undefined && this.vendedorSelecionado !== null) {
        if (this.vendedores.find((p) => p.idFuncion === this.vendedorSelecionado)) {
          this.nomeVendedor = this.vendedores.find((p) => p.idFuncion === this.vendedorSelecionado).nome;
        } else if (!this.integrador && this.vendedorSelecionado === this.usuarioLogado.id) {
          this.nomeVendedor = this.usuarioLogado.nome;
        } else {
          this.carregandoService.mostra('consultarFuncionarioPorIdSimples');
          this.nomeVendedor = (await this.funcionarioService.consultarNome(this.vendedorSelecionado).toPromise()).nome;
        }

        const dadosLider = await this.hierarquiaService.buscarSuperior(this.vendedorSelecionado).toPromise();
        if (dadosLider !== null && dadosLider !== undefined) {
          this.lider = dadosLider.nome;
        }
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('consultarFuncionarioPorIdSimples');
    }
  }

  async buscarLimDescVendedor() {
    try {
      this.limDescVendedorPedido = 0;
      this.carregandoService.mostra('buscarLimDescVendedor');
      this.limDescVendedorPedido = await this.funcionarioService
        .consultarLimitDesc(this.vendedorSelecionado)
        .toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarLimDescVendedor');
    }
  }

  async atualizaDadosPedido(naoAtualizar?) {
    this.buscarComissao();
    this.buscarTransportadoras();

    if (this.tipo !== undefined) {
      this.texto = this.tipo === 0 ? 'Orçamento' : 'Pedido';
    }

    if (this.pedido.vendaDireta && this.pedido.clienteFaturamento) {
      this.buscarClienteFaturamento();
    } else {
      this.clienteFaturamento = new Cliente();
      this.clienteFaturamento.tipo = 0;
      this.atualizaDadosClienteFaturamento();
    }

    this.definirDadosVendaDireta();

    this.buscarTiposDeEnderecoEntrega();

    if (this.editavel) {
      await this.completarEnderecoEntrega(false, !naoAtualizar);
    }

    if (this.duplicando) {
      this.pedido.status = 0;
      this.pedido.nOrcamento = this.idPedido;
      this.podeExcluir = false;
      this.editavel = true;
      this.idPedido = undefined;
      this.pedido.idCupom = undefined;
      this.pedido.idVenda = undefined;
      this.pedido.ordemEtapa = undefined;
      this.pedido.textoEtapa = '';
      this.alterou = true;
      this.pedido.data = new Date();
      this.pedido.tipoCupomDesconto = 0;
      this.pedido.cupomDesconto = null;
      this.pedido.cupomDescontoValor = null;
      this.percentualCupomDesconto = null;
      this.valorCupomDesconto = null;
      this.pedido.cupomDataHora = null;
      this.pedido.cupomUsuario = null;
      this.pedido.cupomUsuarioNome = null;
      this.pedido.voucher = undefined;
      this.pedido.dadosVoucher = undefined;
      this.pedido.valorVoucher = 0;

      await this.buscarDescontoMaximo();

      this.pedido.idDescarga = null;
      this.pedido.aliqImpRef = this.premissasUsuario.aliquotaDeImpostoReferencial;

      this.pedido.flag = 4;

      if (this.cliente.daGI === 1) {
        this.pedido.da = 1;
        this.pedido.percentual = this.cliente.acrescimoGI;
        await this.atualizaDesconto(0, false);
      } else {
        if (!this.premissas.descontoPadrao) {
          this.pedido.da = 0;
          this.pedido.valorDa = 0;
          this.pedido.percentual = 0;
          await this.atualizaDesconto(0, true);
        } else {
          this.pedido.da = 0;
          this.pedido.percentual = this.cliente.descontoMaximoGI;
          await this.atualizaDesconto(0, true);
        }
      }

      if (this.itens) {
        this.itens.forEach((p) => {
          p.idCupom = undefined;
        });
      }

      if (this.fileiras) {
        this.fileiras.forEach((p) => {
          p.cupom = undefined;
        });
      }
    } else {
      if (this.premissasSistema.usarAnaliseDeDesconto) {
        await this.buscarPossuiAnaliseDescontoEmAndamento();
      }
    }
  }

  retornaClasseTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 'badge-primary';
      case '3':
        return 'badge-secondary';
      case '4':
        return 'badge-success';
      case '5':
        return 'badge-danger';
      case '6':
        return 'badge-dark';
      case '1':
        return 'badge-info';
      case '8':
        return 'badge-warning';
      case '9':
        return 'badge-danger';

      default:
        return 'badge-info';
    }
  }

  retornaLetraTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 'P';
      case '3':
        return 'I';
      case '4':
        return 'S';
      case '5':
        return 'C';
      case '6':
        return 'E';
      case '1':
        return 'O';
      case '7':
        return 'K';
      case '8':
        return 'T';
      case '9':
        return 'B';

      default:
        return 'O';
    }
  }

  retornaOrdemTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 0;
      case '3':
        return 1;
      case '4':
        return 2;
      case '5':
        return 3;
      case '6':
        return 4;
      case '1':
        return 5;

      default:
        return 5;
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  ordenaProdutos() {
    this.carregandoService.mostra('ordenaProduto');
    this.itens = this.itens.sort((a, b) => {
      return this.compare(
        this.retornaOrdemTipoProduto(a.produtoTela.familia),
        this.retornaOrdemTipoProduto(b.produtoTela.familia),
        true
      );
    });
    this.carregandoService.esconde('ordenaProduto');
  }

  consultaPodeVerEstoque(id: number) {
    this.carregandoService.mostra('podeVerEstoque');
    this.funcionarioService.consultaPodeVerEstoque(id).subscribe(
      (resp) => {
        this.podeVerEstoque = resp;
        this.carregandoService.esconde('podeVerEstoque');
      },
      (erro) => {
        this.carregandoService.esconde('podeVerEstoque');
        console.error(erro);
        this.notificacaoService.erro('Não foi possível verificar se o usuário pode ver o estoque.');
      }
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.larguraTela = event.target.innerWidth;
  }

  getClasseColuna(): string {
    return this.larguraTela < 1337 ? 'col-4' : 'col-3';
  }

  async ngOnInit() {
    await this.buscarPremissasSistema();

    this.larguraTela = window.innerWidth;

    if (this.idPedido && !(await this.usuarioPodeAcessarOrcPed())) {
      await this.router.navigate(['/']);
    }

    this.buscarEstruturasPersonalizadas();

    this.usuarioLogado = await this.globalService.consultaUsuario();

    const userId = this.usuarioLogado.id;

    this.administrador = await this.globalService.administrador();

    this.integrador = await this.globalService.integrador();

    this.suporte = await this.globalService.suporte();

    const consultasIniciais: Promise<void>[] = [
      this.buscarUsuarioPodeCancelar(this.idPedido),
      this.buscarFormasDePagamento(),
      this.buscarPremissasOrcPed(),
      this.buscarPremissasUsuario(),
      this.buscarDesgargas()
    ];

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      consultasIniciais.push(this.buscarPrecificacoesUF());
    }

    if (!this.integrador) {
      consultasIniciais.push(this.buscarPodeAlterarCD(), this.buscarPodeAlterarVendedor());
    }

    await Promise.all(consultasIniciais);

    this.consultaPodeVerEstoque(userId);

    this.limiteDescontoUsuarioLogado = this.usuarioLogado.limDesc;

    if (this.podeAlterarVendedor) {
      this.buscarVendedores();
    }

    if (!this.integrador) {
      this.buscarPermissoesFuncionario();
    }

    this.podeConfirmarPedido = this.usuarioLogado.podeConfirmarPedido;

    this.podeEditarCancelarPedido = this.usuarioLogado.editaPedido;

    this.verCustos = this.usuarioLogado.verCustos;

    // se houver id, busca o orçamento referente
    if (this.idPedido) {
      this.editando = true;
      await this.buscarPedido();
      await this.buscarLogDisp(this.idPedido);
      this.buscarSimulacaoPedido(this.idPedido);

      if (this.premissas.usarSeguro) {
        await this.buscarSeguros();
      } else {
        this.premissas.usarSeguro = false;
      }
    } else {
      this.router.navigate(['/']);
    }

    if (this.premissasSistema.usaDescargaCif) {
      this.buscarFaixasDescarga();
    }

    this.naoValidarPedido =
      this.premissasSistema.naoValidarPedido &&
      this.premissasSistema.origensParaNaoValidarPedido.some((p) => p === this.pedido.origemGI) &&
      this.pedido.ordemEtapa === EtapaDoPedido.Editando;

    this.podeCalcular = true;

    if (this.premissasSistema.habilitarApiImposto && this.pedido.origemGI === 3 && this.pedido.impostosPendente) {
      this.alterou = true;
    }

    if (this.pedido.status === StatusDoPedido.Ativo) {
      if (this.pedido.orcamento && !this.pedido.vendaDireta) {
        this.pedido.vendaDireta = undefined;
      }

      await this.atualizaValores();
    }

    await this.funPodeVerSubstituicao();

    this.buscarTiposDeEnderecoEntrega();

    this.buscarUltimosPrecos();

    const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');

    // Wizard Initialization
    $('.wizard-pedido').bootstrapWizard({
      tabClass: 'nav nav-pills',
      nextSelector: '.btn-next',
      previousSelector: '.btn-previous',

      onNext: function (tab, navigation, index) {},

      onInit: function (tab: any, navigation: any, index: any) {
        // check number of tabs and fill the entire row
        let $total = navigation.find('li').length;
        let $wizard = navigation.closest('.wizard-pedido');

        let $first_li = navigation.find('li:first-child a').html();
        let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');
        $('.wizard-pedido .wizard-navigation').append($moving_div);

        $total = $wizard.find('.nav li').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        let $current = index + 1;

        if ($current == 1 || (mobile_device == true && index % 2 == 0)) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && index % 2 == 1)) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          transform: 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          transition: 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
        });
        $('.moving-tab').css('transition', 'transform 0s');
      },

      onTabClick: (tab: any, navigation: any, index: any) => {
        if (this.tabIndex !== this.tabAlvo) {
          this.tabIndex = this.tabAlvo;
          if (this.tabIndex === 2) {
            this.margemLucro.calcularValoresCalculadoraMargem();
          }
          return true;
        }

        return false;
      },

      onTabShow: function (tab: any, navigation: any, index: any) {
        let $total = navigation.find('li').length;
        let $current = index + 1;
        elemMainPanel.scrollTop = 0;
        const $wizard = navigation.closest('.wizard-pedido');

        // If it's the last tab then hide the last button and show the finish instead
        if ($current >= $total) {
          $($wizard).find('.btn-next').hide();
          $($wizard).find('.btn-finish').show();
        } else {
          $($wizard).find('.btn-next').show();
          $($wizard).find('.btn-finish').hide();
        }

        const button_text = navigation.find('li:nth-child(' + $current + ') a').html();

        setTimeout(function () {
          $('.wizard-pedido .moving-tab').text(button_text);
        }, 150);

        const checkbox = $('.footer-checkbox');

        if (index !== 0) {
          $(checkbox).css({
            opacity: '0',
            visibility: 'hidden',
            position: 'absolute'
          });
        } else {
          $(checkbox).css({
            opacity: '1',
            visibility: 'visible'
          });
        }
        $total = $wizard.find('.nav li').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        $current = index + 1;

        if ($current == 1 || (mobile_device == true && index % 2 == 0)) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && index % 2 == 1)) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          transform: 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          transition: 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
        });
      }
    });

    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader = new FileReader();

        reader.onload = function (e: any) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-radio"]').click(function () {
      const wizard = $(this).closest('.wizard-pedido');
      wizard.find('[data-toggle="wizard-radio"]').removeClass('active');
      $(this).addClass('active');
      $(wizard).find('[type="radio"]').removeAttr('checked');
      $(this).find('[type="radio"]').attr('checked', 'true');
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');
  }

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(([entry]) => {
      this.mostrarTotaisFixos = !entry.isIntersecting;
    });

    this.observer.observe(this.totais.nativeElement);

    $(window).resize(() => {
      $('.wizard-pedido').each(function () {
        setTimeout(() => {
          const $wizard = $(this);
          const index = $wizard.bootstrapWizard('currentIndex');
          let $total = $wizard.find('.nav li').length;
          let $li_width = 100 / $total;

          let total_steps = $wizard.find('.nav li').length;
          let move_distance = $wizard.width() / total_steps;
          let index_temp = index;
          let vertical_level = 0;

          let mobile_device = $(document).width() < 600 && $total > 3;
          if (mobile_device) {
            move_distance = $wizard.width() / 2;
            index_temp = index % 2;
            $li_width = 50;
          }

          $wizard.find('.nav li').css('width', $li_width + '%');

          let step_width = move_distance;
          move_distance = move_distance * index_temp;

          let $current = index + 1;

          if ($current == 1 || (mobile_device == true && index % 2 == 0)) {
            move_distance -= 8;
          } else if ($current == total_steps || (mobile_device == true && index % 2 == 1)) {
            move_distance += 8;
          }

          if (mobile_device) {
            let x: any = index / 2;
            vertical_level = parseInt(x);
            vertical_level = vertical_level * 38;
          }

          $wizard.find('.moving-tab').css('width', step_width);
          $('.moving-tab').css({
            transform: 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
            transition: 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
          });

          $('.moving-tab').css({
            transition: 'transform 0s'
          });
        }, 500);
      });
    });

    this.utilitarioService.rodaScriptTabEnter();
  }

  async buscarPodeAlterarCD() {
    try {
      this.carregandoService.mostra('buscarPodeAlterarCD');
      this.podeAlterarCD = await this.funcionarioService.consultaPodeAlterarCD().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPodeAlterarCD');
    }
  }

  async buscarDesgargas() {
    try {
      this.carregandoService.mostra('buscarDescargas');
      this.descargas = await this.descargaService.consultarDescargas().toPromise();
      this.descargas.unshift({ id: null, descricao: 'Sem descarga', percentual: 0 });
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarDescargas');
    }
  }

  async buscarUsuarioPodeCancelar(idCupom: string) {
    try {
      this.carregandoService.mostra('buscarUsuarioPodeCancelar');

      this.usuarioPodeCancelar = await this.pedidoService.usuarioPodeCancelar(idCupom).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarUsuarioPodeCancelar');
    }
  }

  buscarEstruturasPersonalizadas() {
    this.carregandoService.mostra('buscarEstruturasPersonalizadas');
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(
      (f) => {
        this.estruturasPersonalizadas = f;

        this.carregandoService.esconde('buscarEstruturasPersonalizadas');
      },
      (erro) => {
        this.carregandoService.esconde('buscarEstruturasPersonalizadas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async usuarioPodeAcessarOrcPed() {
    try {
      this.carregandoService.mostra('usuarioPodeAcessarOrcPed');
      return await this.pedidoService.usuarioPodeAcessarOrcPed(this.idPedido).toPromise();
    } catch (erro) {
      return false;
    } finally {
      this.carregandoService.esconde('usuarioPodeAcessarOrcPed');
    }
  }

  async buscarPremissasUsuario() {
    try {
      this.carregandoService.mostra('buscarPremissasUsuario');
      this.premissasUsuario = await this.premissasService.consultarPremissasUsuario().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasUsuario');
    }
  }

  // abre o modal de pesquisa de produtos
  pesquisarProdutos() {
    let idFornecedorPainel;

    if (this.premissas.multiFornecedores) {
      idFornecedorPainel = this.pedido.painelProduto
        ? this.pedido.painelProduto.idFornecedor
        : this.pedido.idFornecedor;
    }

    if (this.premissas.pCentroDistribuicao || this.premissas.pMultiFornecedor) {
      idFornecedorPainel = this.pedido.idFornecedor; // this.cliente.idCD;
    }

    let dialogRef;

    const config = {
      width: $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        descAcresPrecificacaoUF: this.pedido.origemGI === 2 ? undefined : this.descAcresPrecificacaoUF,
        selecionavel: true,
        produtos: this.itens,
        somenteKit: false,
        producaoPorPainel: 0,
        quantidadeDePaineis: 0,
        potenciaPainel: 0,
        potTotal: 0,
        origem: this.pedido.origemGI,
        idFornecedorPainel: idFornecedorPainel,
        semKit:
          this.pedido.origemGI === 0 ||
          (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento && this.pedido.origemGI === 2) ||
          (this.pedido.origemGI === 1 &&
            !this.premissas.adicionarVariosKitPronto &&
            this.itens.some((p) => p.produtoTela.familia === 7 && p.qt > 0)),
        somenteMSK: this.pedido.origemGI === 0 || this.pedido.origemGI === 1,
        idLoja: this.pedido.idLoja,
        cliente: this.cliente
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    };

    if (this.pedido.origemGI !== 3 && this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(ProdutosModalComponent, config);
    } else {
      dialogRef = this.dialog.open(ProdutosV2ModalComponent, config);
    }

    // quando fecha o modal
    dialogRef.afterClosed().subscribe(async (result: ItemPedido[]) => {
      if (result) {
        await this.executarAlteracoesEmLote(async () => {
          result.forEach((i) => {
            if (i.valorDa === null || i.valorDa === undefined || isNaN(i.valorDa)) {
              i.valorDa = 0;
            }
            if (i.percentual === null || i.percentual === undefined || isNaN(i.percentual)) {
              i.percentual = 0;
            }
          });

          // verifica se é para excluir algum item
          if (this.itens.some((p) => !result.some((r) => r.produtoTela.idProduto === p.produtoTela.idProduto))) {
            const itensExcluidos = this.itens.filter(
              (p) => !result.some((r) => r.produtoTela.idProduto === p.produtoTela.idProduto)
            );

            for (const it of itensExcluidos) {
              await this.excluirProduto(it);
            }
          }

          // atualiza a lista de produtos
          for (const p of result) {
            if (this.itens.some((ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto)) {
              if (this.itens.find((ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto).qt !== p.qt) {
                this.alterou = true;
                await this.excluirCupomDesconto();
              }
              this.itens.find((ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto).qt = p.qt;
              await this.atualizaValorProduto(
                this.itens.find((ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto)
              );
            } else {
              this.alterou = true;
              await this.excluirCupomDesconto();
              this.itens.push(p);
              this.buscarUltimosPrecos();
              this.ordenaProdutos();
              await this.atualizaValorProduto(p);
            }
          }

          if (this.pedido.descontoIndividual) {
            await this.atualizaDesconto(this.alterou ? 0 : 1, false);
          }
        });
      }
    });
  }

  async validaQtd(item: ItemPedido, lojaProdutos: boolean = false) {
    await this.executarAlteracoesEmLote(() => this.executarValidacaoQuantidade(item, lojaProdutos));
  }

  private async executarValidacaoQuantidade(item: ItemPedido, lojaProdutos: boolean = false) {
    let atualizouValorProduto = false;

    if (lojaProdutos) {
      if (item.qt === null || item.qt === undefined || Number.isNaN(Number(item.qt)) || Number(item.qt) < 0) {
        item.qt = item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ? item.produtoTela.valorMultiplo : 1;

        await this.atualizaValorProduto(item);
        atualizouValorProduto = true;
      } else if (Number(item.qt) > 100000) {
        item.qt =
          item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0
            ? this.utilitarioService.multiploOuMaisProximo(
                Number(item.qt),
                item.produtoTela.valorMultiplo,
                item.produtoTela.valorMultiplo,
                100000,
                'down'
              )
            : 100000;
        await this.atualizaValorProduto(item);
        atualizouValorProduto = true;
      } else if (item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0) {
        item.qt = this.utilitarioService.multiploOuMaisProximo(
          Number(item.qt),
          item.produtoTela.valorMultiplo,
          item.produtoTela.valorMultiplo,
          100000,
          'up'
        );
        await this.atualizaValorProduto(item);
        atualizouValorProduto = true;
      } else if (this.alterou) {
        await this.atualizaValorProduto(item);
        atualizouValorProduto = true;
      }
    } else {
      if (item.qt === null || item.qt === undefined || Number.isNaN(item.qt) || item.qt < 0) {
        this.alterou = true;
        await this.excluirCupomDesconto();
        item.qt = 1;
        await this.atualizaValorProduto(item);
        atualizouValorProduto = true;
      } else if (Number(item.qt) > 200000) {
        this.alterou = true;
        await this.excluirCupomDesconto();
        item.qt = 200000;
        await this.atualizaValorProduto(item);
        atualizouValorProduto = true;
      }
    }

    if (!atualizouValorProduto && item.qt !== item.qtAnterior) {
      await this.atualizaValorProduto(item);
    }

    if (!this.pedido.orcamento) {
      await this.ValidarEstoque();
    }
  }

  verificaPaineisEstrutura() {
    const quantidadeDePaineisFileiras = this.fileiras.reduce((acc, curr) => acc + curr.numPaineis * curr.fileiras, 0);

    const quantidadePaineisListaProdutos = this.itens
      .filter((p) => p.produtoTela.familia === 2)
      .reduce((acc, curr) => acc + curr.qt, 0);

    this.podeRecalcularEstrutura =
      quantidadePaineisListaProdutos !== quantidadeDePaineisFileiras && quantidadePaineisListaProdutos > 1;

    if (this.podeRecalcularEstrutura) {
      this.novaQuantidadePaineis = quantidadePaineisListaProdutos - quantidadeDePaineisFileiras;
    } else {
      this.novaQuantidadePaineis = undefined;
    }
  }

  recalcularEstrutura() {
    if (!this.podeRecalcularEstrutura || !this.fileiras.length) return;

    const ultimaFileira = this.fileiras[this.fileiras.length - 1];

    if (this.fileiras && this.fileiras.length > 1) {
      if (this.novaQuantidadePaineis > 0) {
        this.editarEstrutura(this.fileiras[0], Math.round(this.novaQuantidadePaineis / this.fileiras[0].fileiras));
      } else {
        if (
          (ultimaFileira.numPaineis * ultimaFileira.fileiras + this.novaQuantidadePaineis) / ultimaFileira.fileiras >
          1
        ) {
          this.editarEstrutura(ultimaFileira, Math.round(this.novaQuantidadePaineis / ultimaFileira.fileiras));
        } else {
          swal({
            title: 'Atenção!!',
            text: 'Não foi possível recalcular automaticamente, favor editar manualmente os layouts.',
            type: 'warning',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-info',
            confirmButtonText: 'Ok',
            buttonsStyling: false
          }).then(() => {
            this.podeRecalcularEstrutura = false;
          });
        }
      }
    } else if (this.fileiras && this.fileiras.length === 1) {
      if (this.fileiras[0].fileiras === 1) {
        this.editarEstrutura(this.fileiras[0], Math.round(this.novaQuantidadePaineis / this.fileiras[0].fileiras));
      } else {
        if (this.novaQuantidadePaineis > 0) {
          this.editarEstrutura(this.fileiras[0], Math.round(this.novaQuantidadePaineis / this.fileiras[0].fileiras));
        } else {
          if (Math.round((this.fileiras[0].numPaineis - this.novaQuantidadePaineis) / this.fileiras[0].fileiras) > 0) {
            this.editarEstrutura(this.fileiras[0], Math.round(this.novaQuantidadePaineis / this.fileiras[0].fileiras));
          } else {
            swal({
              title: 'Atenção!!',
              text: 'Não foi possível recalcular automaticamente, favor editar manualmente os layouts.',
              type: 'warning',
              showCancelButton: false,
              confirmButtonClass: 'btn btn-info',
              confirmButtonText: 'Ok',
              buttonsStyling: false
            }).then(() => {
              this.podeRecalcularEstrutura = false;
            });
          }
        }
      }
    }
  }

  async atividaDesativaDescontoIndividual() {
    this.alterou = true;
    // await this.excluirCupomDesconto();

    this.itens.forEach((p) => {
      p.valorDa = 0;
      p.percentual = 0;
      p.vTotal = Number((Number(p.pUnitario) * Number(p.qt)).toFixed(2));
    });

    await this.atualizaDesconto(0, true);
  }

  async atualizaValorProduto(item: ItemPedido, temArredondamento?, recalcularFrete: boolean = true) {
    await this.executarAlteracoesEmLote(() =>
      this.executarAtualizacaoValorProduto(item, temArredondamento, recalcularFrete)
    );
  }

  private async executarAtualizacaoValorProduto(item: ItemPedido, temArredondamento?, recalcularFrete: boolean = true) {
    let descontar = false;
    let desconto = 0;

    if (item.qt !== item.qtAnterior) {
      item.qtAnterior = item.qt;
      this.alterou = true;
      await this.excluirCupomDesconto();
      item.alterado = true;
      if (item.produtoTela.familia === 2) {
        this.verificaPaineisEstrutura();
      }
    }

    if (item.produtoTela.familia === 2 || item.produtoTela.familia === 3) {
      desconto = await this.buscarDescontoProduto(item);
      descontar = true;
      item.itemDesc.preco =
        (this.pedido.origemGI === 2 && this.premissas.usarPrecoAvulso) || this.pedido.origemGI === 3
          ? item.produtoTela.precoAvulso
          : item.produtoTela.precoVenda;
    }

    if (this.alterou || this.duplicando) {
      if ((this.pedido.origemGI === 2 && this.premissas.usarPrecoAvulso) || this.pedido.origemGI === 3) {
        item.pUnitario = descontar
          ? Number((item.produtoTela.precoAvulso - (item.produtoTela.precoAvulso * desconto) / 100).toFixed(2))
          : Number(item.produtoTela.precoAvulso.toFixed(2));
      } else {
        item.pUnitario = descontar
          ? Number((item.produtoTela.precoVenda - (item.produtoTela.precoVenda * desconto) / 100).toFixed(2))
          : Number(item.produtoTela.precoVenda.toFixed(2));
      }

      if (this.premissasSistema.usarPrecificacaoPorUF) {
        // if ((this.pedido.origemGI === 2 && this.premissas.usarPrecoAvulso) || this.pedido.origemGI === 3) {
        //   item.pUnitario = this.precificacaoUFService.calcularPrecoBase(
        //     item.pUnitario,
        //     this.premissasSistema.usarPrecificacaoPorUF ? this.descAcresPrecificacaoUF : null,
        //     this.premissasSistema.habilitarPrecificacaoPorIntegrador && this.cliente && this.pedido.origemGI === OrigemGI.LojaProdutos ? this.cliente.tipoPrecificacao : 0,
        //     this.premissasSistema.habilitarPrecificacaoPorIntegrador && this.cliente && this.pedido.origemGI === OrigemGI.LojaProdutos ? this.cliente.valorPrecificacao : 0);
        // }

        item.pUnitario = this.calcularPrecificacao(item.pUnitario);
      }
    }

    if (this.pedido.descontoIndividual) {
      item.vTotal = Number((item.pUnitario * item.qt).toFixed(2));

      const percentualCalculado = Number(((Number(item.valorDa) * 100) / Number(item.vTotal)).toFixed(4));

      if (percentualCalculado !== item.percentual) {
        item.valorDa = Number(((item.vTotal * item.percentual) / 100).toFixed(2));
      }

      item.vTotal = item.vTotal - item.valorDa;

      this.validarDescontoIndividual(item, false);
    } else {
      item.vTotal = Number((item.pUnitario * item.qt).toFixed(2));
    }

    await this.atualizaDesconto(this.alterou ? 0 : 1, false, temArredondamento);

    if (this.premissas.usarCombInvStrCon && item.alterado && item.produtoTela.familia === 3) {
      this.buscarStringBoxConectorDoInversor(item.produto, item.qt, item.qtSugerida);
    }

    item.alterado = false;

    this.validaFaixaDescarga();

    if (recalcularFrete) {
      await this.recalculaFreteManual();
    }
  }

  async buscarDescontoProduto(item: ItemPedido) {
    try {
      this.carregandoService.mostra('buscarDescontoProduto');

      if (item.itemDesc === null || item.itemDesc === undefined) item.itemDesc = new ItemDesc();

      item.itemDesc.descontos =
        item.itemDesc.descontos === null || item.itemDesc.descontos === undefined
          ? await this.produtoService.consultarDescontos(item.produtoTela.idProduto).toPromise()
          : item.itemDesc.descontos;

      if (item.itemDesc.descontos.some((p) => item.qt >= p.qtdIni && item.qt <= p.qtdFim)) {
        this.carregandoService.esconde('buscarDescontoProduto');
        return item.itemDesc.descontos.find((p) => item.qt >= p.qtdIni && item.qt <= p.qtdFim).desco;
      } else {
        this.carregandoService.esconde('buscarDescontoProduto');
        return 0;
      }
    } catch (erro) {
      this.carregandoService.esconde('buscarDescontoProduto');
      this.notificacaoService.erro(erro);
      return 0;
    }
  }

  async aumentaQtdProduto(item: ItemPedido) {
    await this.executarAlteracoesEmLote(async () => {
      const qtdMax = 10000;
      const incremento =
        this.lojaDeProdutos && item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0
          ? item.produtoTela.valorMultiplo
          : 1;

      if (item.qt + incremento <= qtdMax) {
        this.alterou = true;
        await this.excluirCupomDesconto();
        item.qt += incremento;
      }

      await this.atualizaValorProduto(item);

      if (!this.pedido.orcamento) {
        await this.ValidarEstoque();
      }
    });
  }

  async diminuiQtdProduto(item: ItemPedido) {
    await this.executarAlteracoesEmLote(async () => {
      const decremento =
        this.lojaDeProdutos && item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0
          ? item.produtoTela.valorMultiplo
          : 1;

      if (item.qt && item.qt > decremento) {
        this.alterou = true;
        await this.excluirCupomDesconto();
        item.qt -= decremento;
        await this.atualizaValorProduto(item);

        if (!this.pedido.orcamento) {
          await this.ValidarEstoque();
        }
      }
    });
  }

  async excluirProduto(item: ItemPedido, interno?: boolean) {
    await this.executarAlteracoesEmLote(async () => {
      this.alterou = true;
      await this.excluirCupomDesconto();

      if (
        /*!item.produtoTela.produtoEstrutura &&*/ !item.qtSugerida ||
        this.premissas.removerItemSugEdicao ||
        interno
      ) {
        this.itens.splice(this.itens.indexOf(item), 1);
        await this.atualizaDesconto(0, false);
      } else {
        item.qt = 0;
        await this.atualizaValorProduto(item);
      }

      if (this.premissas.usarCombInvStrCon && item.produtoTela.familia === 3) {
        this.buscarStringBoxConectorDoInversor(item.produto, 0, item.qtSugerida);
      }
    });
  }

  async buscarItensEstrutura() {
    await this.executarAlteracoesEmLote(async () => {
      this.alterou = true;
      await this.excluirCupomDesconto();
      this.calcularQtdPaineis();

      this.produtoEstruturaBloqueado = false;
      if (!this.fileiras || this.fileiras.length === 0) {
        return;
      }

      this.carregandoService.mostra('buscaItensEstrutura');

      try {
        const possuiMicroInversor = this.itens.some(
          (p) => p.produtoTela.familia === 3 && p.produtoTela.tipoInv === 1 && p.qt > 0
        );

        this.fileiras.forEach((p) => {
          p.microInversor = p.tipoInversor === 1 || possuiMicroInversor;
        });

        const fileiras = [];
        const qtdTotalPaineis = this.itens
          .filter((p) => p.produtoTela.familia === 2)
          .reduce((acc, curr) => acc + curr.qt, 0);

        this.fileiras.forEach((p) => {
          const f = Object.assign({}, p);

          delete f.logo$;
          f.qtdTotalModulosTodosLayouts = qtdTotalPaineis;
          fileiras.push(f);
        });

        const itensEstrutura = (await this.pedidoService.buscarItensEstrutura(fileiras).toPromise()) as ItemPedido[];

        if (itensEstrutura.some((p) => p.situacaoProduto === 'B')) {
          this.produtoEstruturaBloqueado = true;
          swal({
            title: 'ATENÇÃO!!!',
            html: 'Existem produtos da estrutura que estão bloqueados!!!',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning'
          }).catch(swal.noop);
          return;
        }

        const itensRemovidos = this.itens.filter(
          (p) =>
            (p.produtoTela.produtoEstrutura || p.produtoTela.familia === 6) &&
            !itensEstrutura.some((pi) => pi.produto === p.produto)
        );

        for (const item of itensRemovidos) {
          await this.excluirProduto(item, true);
        }

        for (const it of itensEstrutura) {
          if (this.itens && this.itens.some((p) => p.produto === it.produto)) {
            const item = this.itens.find((p) => p.produto === it.produto);
            item.qt = it.qt;
            item.qtSugerida = it.qtSugerida;
            item.situacaoProduto = it.situacaoProduto;
            await this.atualizaValorProduto(item);
            continue;
          }

          this.carregandoService.mostra('buscaProduto' + it.produto);

          try {
            it.produtoTela = await this.produtoService
              .consultarPorId(
                it.produto,
                null,
                null,
                this.premissas.pCentroDistribuicao || this.premissas.multiFornecedores ? this.pedido.idFornecedor : null
              )
              .toPromise();

            it.qtAnterior = it.qt;
            this.itens.push(it);
            this.buscarUltimosPrecos();
            this.ordenaProdutos();
            await this.atualizaValorProduto(it);
          } catch (erro) {
            this.notificacaoService.erro(erro);
          } finally {
            this.carregandoService.esconde('buscaProduto' + it.produto);
          }
        }

        if (this.pedido.flag === 4) {
          for (const item of this.itens.filter((p) => p.produtoTela.familia === 2 || p.produtoTela.familia === 3)) {
            await this.atualizaValorProduto(item);
          }
        }
      } catch (erro) {
        this.notificacaoService.erro(erro);
      } finally {
        this.carregandoService.esconde('buscaItensEstrutura');
      }
    });
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result: { cliente: Cliente; vendedor: any }) => {
      if (result) {
        this.alterou = true;
        this.cliente = result.cliente;
        this.buscarTiposDeEnderecoEntrega();
        this.buscarPodeAplicarVoucher();
        this.vendedorSelecionado = result.vendedor.idFuncion;

        if (this.premissasUsuario.atualizaDadosReceitaIntegrador) {
          await this.buscarClienteAtualizadoReceita();
        }

        await this.buscarNomeVendedor();
        await this.buscarLimDescVendedor();
        await this.buscarDescontoMaximo();
        await this.atualizaDesconto(0, true);
      }
    });
  }

  async buscarPodeAplicarVoucher() {
    if (this.premissas.ativarVoucher && this.cliente !== undefined && this.cliente !== null) {
      this.podeAplicarVoucher = await this.voucherService.podeAplicarVouchers(this.cliente.id).toPromise();
    }
  }

  aplicarVoucher() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(SelecionarVoucherModalComponent, {
      width: largura > 550 ? '590px' : $('body').width().toString() + 'px',
      data: {
        idCliente: this.cliente.id,
        valorTotalPedido: this.pedido.valorTotal
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result: Voucher) => {
      if (result) {
        this.pedido.voucher = result.id;
        this.pedido.dadosVoucher = result;
        if (
          this.pedido.ordemEtapa === 1 ||
          this.pedido.ordemEtapa === 38 ||
          this.premissas.podeUsarMultiFormaPagamento
        ) {
          this.alterou = true;
        }

        if (
          this.pedido.dadosVoucher.tipoVoucher === TipoVoucher.FormaPagamento &&
          this.pedido.dadosVoucher.excluirCupomDesconto &&
          this.pedido.cupomDesconto !== null &&
          this.pedido.cupomDesconto !== undefined
        ) {
          await this.excluirCupomDesconto(false);
        } else {
          await this.atualizaValores();
        }
      }
    });
  }

  async buscarVendedores() {
    if (this.administrador) {
      // || !this.usuarioLogado.verSomenteHierarquia) {
      try {
        this.carregandoService.mostra('buscarVendedores');
        const resp = await this.funcionarioService.consultarFuncionariosPedidoSimples().toPromise();
        this.vendedores = resp;
        this.carregandoService.esconde('buscarVendedores');
      } catch (erro) {
        this.carregandoService.esconde('buscarVendedores');
        this.notificacaoService.erro(erro);
      }
    } else {
      try {
        this.carregandoService.mostra('buscarVendedoresHierarquia');
        const resp = await this.hierarquiaService.consultarHierarquiaDoUsuarioLista().toPromise();
        this.vendedores = resp;
        this.carregandoService.esconde('buscarVendedoresHierarquia');
      } catch (erro) {
        this.carregandoService.esconde('buscarVendedoresHierarquia');
        this.notificacaoService.erro(erro);
      }
    }
  }

  buscarTransportadoras() {
    this.carregandoService.mostra('buscarTransportadoras');
    this.clienteService.consultarTransportadoras().subscribe(
      (trans) => {
        this.transportadoras = trans;
        this.carregandoService.esconde('buscarTransportadoras');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTransportadoras');
        this.notificacaoService.erro(erro);
      }
    );
  }

  inserirLogAcessoTela() {
    this.carregandoService.mostra('inserirLogAcessoTela');
    this.logAcessoService.InserirAcessoTela().subscribe(
      (resp) => {
        this.carregandoService.esconde('inserirLogAcessoTela');
      },
      (erro) => {
        this.carregandoService.esconde('inserirLogAcessoTela');
        this.notificacaoService.erro(erro);
      }
    );
  }

  desabilitaFormaDePagamento() {
    return !this.duplicando && (this.pedido.flag === 1 || !this.editavel);
  }

  async buscarFormasDePagamento() {
    try {
      this.carregandoService.mostra('buscaFormasDePagamento');
      this.formasDePagamento = await this.formadePagamentoService.consultar(-1).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaFormasDePagamento');
    }
  }

  desabilitaCondicaoDePagamento() {
    return !this.duplicando && (this.pedido.flag === 1 || !this.editavel);
  }

  async buscarCondicaoDePagamentoCampoDesabilitado() {
    try {
      this.carregandoService.mostra('buscarCondicaoDePagamentoCampoDesabilitado');
      if (this.pedido.formasPagamento[0].idCondPag === null || this.pedido.formasPagamento[0].idCondPag === undefined) {
        return;
      }

      const cond = await this.condicaoDePagamentoService
        .consultarPorId(this.pedido.formasPagamento[0].idCondPag)
        .toPromise();
      this.condicoesDePagamento = [cond];
      await this.atualizarTaxaDeCondicao();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarCondicaoDePagamentoCampoDesabilitado');
    }
  }

  aplicarLimitesCondicoesDePagamento(condicoesDePagamento: Array<{ disabled?: boolean } & CondicaoDePagamento> = null) {
    let houveAlteracao = false;
    const condicoesAntigas = condicoesDePagamento || this.condicoesDePagamento || [];

    const condicoesNovas = condicoesAntigas.map((cond) => {
      const foraDoLimite = this.condicaoDePagamentoService.verificaForaDoLimite(cond, this.pedido.valorTotal);

      if (foraDoLimite !== cond.disabled) {
        cond.disabled = foraDoLimite;
        houveAlteracao = true;
      }

      return { ...cond };
    });

    if (!houveAlteracao) {
      return;
    }

    this.condicoesDePagamento = condicoesNovas;

    const selecionado = this.condicoesDePagamento.find((c) => c.idCondPag == this.pedido.formasPagamento[0].idCondPag);

    if (selecionado === undefined || selecionado === null) {
      this.pedido.formasPagamento[0].idCondPag = undefined;
    } else if (selecionado.disabled) {
      this.pedido.formasPagamento[0].idCondPag = undefined;
    }
  }

  async buscarCliente(buscarDesconto: boolean = true) {
    try {
      this.carregandoService.mostra('buscaClientes');
      this.cliente = this.premissasUsuario.atualizaDadosReceitaIntegrador
        ? await this.clienteService.consultarAtualizadoReceita(this.pedido.cliente, true, true).toPromise()
        : await this.clienteService.consultarPorIdCliente(this.pedido.cliente, true).toPromise();

      this.buscarTiposDeEnderecoEntrega();
      this.buscarPodeAplicarVoucher();
      this.descontoFrete = this.cliente.descFrete;

      if (this.integrador && (!this.idPedido || this.duplicando)) {
        this.vendedorSelecionado = this.cliente.vendedor;
        await this.buscarNomeVendedor();
        await this.buscarLimDescVendedor();
      }

      if (buscarDesconto) {
        await this.buscarDescontoMaximo();
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaClientes');
    }
  }

  async buscarClienteAtualizadoReceita() {
    try {
      this.carregandoService.mostra('buscarClienteAtualizadoReceita');
      const cliente = await this.clienteService.consultarAtualizadoReceita(this.pedido.cliente, true, true).toPromise();

      this.cliente.listaCnaes = cliente.listaCnaes;
      this.cliente.optanteSimples = cliente.optanteSimples;
      this.cliente.dataSituacaoSimples = cliente.dataSituacaoSimples;
      this.cliente.optanteSimei = cliente.optanteSimei;
      this.cliente.dataSituacaoSimei = cliente.dataSituacaoSimei;
      this.cliente.dataAtualizacaoReceita = cliente.dataAtualizacaoReceita;
      this.cliente.fonteAtualizacaoReceita = cliente.fonteAtualizacaoReceita;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarClienteAtualizadoReceita');
    }
  }

  inserirFileira() {
    const nFileira: Fileira = new Fileira();
    nFileira.uf = this.pedido.ufInstalacao;
    Object.assign(nFileira, this.novaFileira);

    this.alterou = true;
    this.fileiras.push(nFileira);
    this.novaFileira = new Fileira();
    this.novaFileira.uf = this.pedido.ufInstalacao;
  }

  async excluirFileira(fileira: Fileira) {
    this.alterou = true;
    this.fileiras.splice(this.fileiras.indexOf(fileira), 1);
    await this.buscarItensEstrutura();
  }

  retornarDescontoFrete(frete, percentual) {
    return frete !== null && frete !== undefined && this.descontoFrete > percentual ? percentual : this.descontoFrete;
  }

  async removerVoucher() {
    this.pedido.voucher = undefined;
    this.pedido.valorVoucher = undefined;
    this.pedido.dadosVoucher = undefined;

    if (this.premissas.podeUsarMultiFormaPagamento) {
      this.alterou = true;
    }

    await this.atualizaValores();
  }

  async atualizaValores(
    tipoCalculo: TipoCalculoPedido = TipoCalculoPedido.Normal,
    valorParaSimular?,
    recalcularFreteManual: boolean = false
  ) {
    if (tipoCalculo === TipoCalculoPedido.Normal && this.nivelAgrupamentoCalculos > 0) {
      this.calculoAgrupadoPendente = true;
      this.recalcularFreteManualAgrupado = this.recalcularFreteManualAgrupado || recalcularFreteManual;
      return;
    }

    if (!this.podeCalcular) return;

    if (tipoCalculo !== TipoCalculoPedido.Normal) {
      return this.executarAtualizacaoValores(tipoCalculo, valorParaSimular, recalcularFreteManual);
    }

    this.calculoNormalPendente = true;
    this.recalcularFreteManualCalculoPendente = this.recalcularFreteManualCalculoPendente || recalcularFreteManual;

    if (!this.calculoNormalEmAndamento) {
      this.calculoNormalEmAndamento = true;
      this.promessaCalculoNormal = this.processarFilaCalculoNormal();
    }

    return this.promessaCalculoNormal;
  }

  private async processarFilaCalculoNormal(): Promise<any> {
    let resultado;

    try {
      // Alterações recebidas durante uma consulta viram apenas uma nova passagem com o estado mais recente.
      while (this.calculoNormalPendente) {
        this.calculoNormalPendente = false;

        const recalcularFreteManual = this.recalcularFreteManualCalculoPendente;
        this.recalcularFreteManualCalculoPendente = false;

        resultado = await this.executarAtualizacaoValores(TipoCalculoPedido.Normal, null, recalcularFreteManual);
      }

      return resultado;
    } finally {
      this.calculoNormalEmAndamento = false;
    }
  }

  private async simularValores(tipoCalculo: TipoCalculoPedido, valorParaSimular: number): Promise<number> {
    if (!this.podeCalcular) return;

    return this.executarAtualizacaoValores(tipoCalculo, valorParaSimular);
  }

  private async executarAlteracoesEmLote(acao: () => Promise<void>): Promise<void> {
    this.nivelAgrupamentoCalculos++;

    try {
      await acao();
    } finally {
      this.nivelAgrupamentoCalculos--;

      if (this.nivelAgrupamentoCalculos === 0) {
        // Somente o agrupamento mais externo publica o recálculo acumulado.
        const deveRecalcularFrete = this.recalculoFreteAgrupadoPendente;
        const deveCalcular = this.calculoAgrupadoPendente;
        const recalcularFreteManual = this.recalcularFreteManualAgrupado;
        const deveRecalcularAposClampDesconto = this.recalculoPosClampDescontoPendente;

        this.recalculoFreteAgrupadoPendente = false;
        this.calculoAgrupadoPendente = false;
        this.recalcularFreteManualAgrupado = false;
        this.recalculoPosClampDescontoPendente = false;

        if (this.podeCalcular) {
          if (deveRecalcularFrete && this.premissasSistema.recalculaFreteManual) {
            await this.buscarFrete(false, true);
          } else if (deveCalcular) {
            await this.atualizaValores(TipoCalculoPedido.Normal, null, recalcularFreteManual);
          }

          // O corte automático do desconto acima do limite permitido acontece de forma síncrona
          // (sem o diálogo de confirmação exibido para vendedores) para integrador/validação
          // automática. Como isso ocorre dentro deste mesmo lote, o recálculo acima pode ter sido
          // publicado antes do frete e da forma de pagamento terminarem de se sincronizar. Este
          // passe extra garante um total final consistente, com o mesmo estado já assentado que o
          // fluxo do vendedor obtém naturalmente pela espera do diálogo.
          if (deveRecalcularAposClampDesconto) {
            await this.atualizaValores(TipoCalculoPedido.Normal, null, recalcularFreteManual);
          }
        }
      }
    }
  }

  private async executarAtualizacaoValores(
    tipoCalculo: TipoCalculoPedido,
    valorParaSimular?,
    recalcularFreteManual: boolean = false
  ) {
    try {
      this.carregandoService.mostra('calcular');

      this.calcularPesoBruto();

      if (this.frete !== null && this.frete !== undefined) {
        this.frete.prazoTotal = Number(this.frete.prazoTotal);
      }

      let percentualFreteAvulso = null;

      if (this.premissas.bloquearTipoFreteVendaDireta && this.pedido.origemGI === 2) {
        let totalValorCif = 0;
        let totalValorFob = 0;

        this.itens.forEach((p) => {
          if (p.qt > 0) {
            totalValorCif += p.precoCif * p.qt;
            totalValorFob += p.pUnitario * p.qt;
          }
        });

        percentualFreteAvulso = totalValorCif === 0 ? 0 : (1 - totalValorFob / totalValorCif) * 100;
      }

      const qtModulos = this.itens.reduce((total, it) => {
        if (it.produtoTela.familia === 2) {
          return total + it.qt;
        }
        if (it.produtoTela.familia === 7) {
          return (
            total +
            it.produtoTela.composicao.reduce((compTotal, comp) => {
              return comp.produtoMP.familia === 2 ? compTotal + comp.qt * it.qt : compTotal;
            }, 0)
          );
        }
        return total;
      }, 0);

      this.validaFaixaDescarga();

      let dadosCalculo: DadosCalculo = {
        valorProdutos: this.pedido.valorTotal,
        valorServico:
          this.pedido.valorServico !== null && this.pedido.valorServico !== undefined
            ? Number(this.pedido.valorServico)
            : 0,
        valorDoServicoAcima: false,
        valorDa:
          tipoCalculo === TipoCalculoPedido.SimularDesconto
            ? valorParaSimular
            : this.pedido.valorDa !== null && this.pedido.valorDa !== undefined
              ? Number(this.pedido.valorDa)
              : 0,
        percentual:
          this.pedido.percentual !== null && this.pedido.percentual !== undefined ? Number(this.pedido.percentual) : 0,
        tipoFrete: this.pedido.tipoFrete,
        valorFrete: this.pedido.frete !== null && this.pedido.frete !== undefined ? Number(this.pedido.frete) : 0,
        percentualFrete:
          this.pedido.percentualFrete !== null && this.pedido.percentualFrete !== undefined
            ? Number(this.pedido.percentualFrete)
            : undefined,
        localizacao: this.pedido.tipoLocalizacao,
        da: this.pedido.da,
        percentualFreteAvulso: percentualFreteAvulso,
        frete: this.frete,
        idDescarga: this.pedido.idDescarga,
        freteManual: recalcularFreteManual ? false : this.freteManual,
        freteDigitado: recalcularFreteManual ? false : this.freteDigitado,
        msgFreteIntegrador: '',
        mostrarMsgFreteIntegrador: false,
        descontoFrete: this.descontoFrete,
        taxaCondicao: this.taxaCondicao,
        valorTaxaCond: this.valorTaxaCond,
        valorTotal: this.pedido.valorFinal,
        valorServicoEntregaEditado: this.valorServicoEntregaEditado,
        servicoEntrega: this.pedido.servicoEntrega,
        valorServicoEntrega: this.pedido.valorServicoEntrega,
        valorProjeto:
          this.pedido.valorProjeto !== null && this.pedido.valorProjeto !== undefined
            ? Number(this.pedido.valorProjeto)
            : 0,
        seguros: [...this.segurosOriginais],
        segurosManuais: [...this.segurosManuais],
        segurosSelecionados:
          this.pedido.seguros !== null && this.pedido.seguros !== undefined ? [...this.pedido.seguros] : [],
        segurosObrigatorios: [...this.segurosObrigatorios],
        segurosObrigatoriosRemovidos: [...this.segurosObrigatoriosRemovidos],
        potencia: this.potencia,
        idCupom: this.pedido.idCupom,
        valorSeguro: this.valorSeguro,
        valorLiquido: this.valorLiquido !== null && this.valorLiquido !== undefined ? Number(this.valorLiquido) : 0,
        valorProjetoLiquido:
          this.pedido.valorProjetoLiquido !== null && this.pedido.valorProjetoLiquido !== undefined
            ? Number(this.pedido.valorProjetoLiquido)
            : 0,
        voucher: this.pedido.voucher,
        dadosVoucher: this.pedido.dadosVoucher,
        valorVoucher: this.pedido.valorVoucher,
        alterou: tipoCalculo === TipoCalculoPedido.Normal ? this.alterou : true,
        origem: this.pedido.origemGI,
        pedidoFlag: this.pedido.flag,
        tipoCalculo: tipoCalculo,
        valorFinalParaSimular: tipoCalculo === TipoCalculoPedido.SimularValorFinal ? valorParaSimular : null,
        status: this.pedido.status,
        qtModulos: qtModulos,
        tipoCIF: this.pedido.tipoCIF !== null && this.pedido.tipoCIF !== undefined ? Number(this.pedido.tipoCIF) : 0,
        itens: this.itens,
        ipi: this.pedido.ipi,
        ibs: this.pedido.ibs,
        cbs: this.pedido.cbs,
        multiFormaPagamento: this.pedido.multiFormaPagamento,
        formasPagamento: this.pedido.formasPagamento,
        possuiArredondamento: this.usandoArredondamento,
        cpfCnpj: this.pedido.vendaDireta
          ? this.clienteFaturamento.tipo === 0
            ? this.clienteFaturamento.cnpj
            : this.clienteFaturamento.cpf
          : this.cliente.tipo === 0
            ? this.cliente.cnpj
            : this.cliente.cpf,
        idCd: this.pedido.idFornecedor,
        uf: this.enderecoDeEntrega.uf,
        impostos: this.pedido.impostos,
        valorImpostos: this.pedido.valorImpostos,
        impostosPendente: this.pedido.impostosPendente,
        descontoIndividual: this.pedido.descontoIndividual
      };

      dadosCalculo = await this.pedidoService.calcular(dadosCalculo).toPromise();

      if (dadosCalculo.valorDoServicoAcima) {
        swal({
          title: 'ATENÇÃO!!!',
          html:
            'Valor do serviço acima do permitido!!!<br>Limite: ' +
            ((this.pedido.valorTotal * this.premissas.limiteRepasse) / 100).toLocaleString(),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).catch(swal.noop);
      }

      switch (tipoCalculo) {
        case TipoCalculoPedido.Normal:
          {
            this.pedido.valorTotal = dadosCalculo.valorProdutos;
            this.pedido.valorServico = dadosCalculo.valorServico;
            this.pedido.valorDa = dadosCalculo.valorDa;
            this.pedido.percentual = dadosCalculo.percentual;
            this.pedido.tipoFrete = dadosCalculo.tipoFrete;
            this.pedido.frete = dadosCalculo.valorFrete;
            this.pedido.percentualFrete = dadosCalculo.percentualFrete;
            this.pedido.tipoLocalizacao = dadosCalculo.localizacao;
            this.pedido.da = dadosCalculo.da;
            this.percentualFreteAvulso = dadosCalculo.percentualFreteAvulso;
            this.pedido.idDescarga = dadosCalculo.idDescarga;
            this.freteManual = dadosCalculo.freteManual;
            this.freteDigitado = dadosCalculo.freteDigitado;
            this.descontoFrete = dadosCalculo.descontoFrete;
            this.taxaCondicao = dadosCalculo.taxaCondicao;
            this.valorTaxaCond = dadosCalculo.valorTaxaCond;
            this.pedido.valorFinal = dadosCalculo.valorTotal;
            this.valorServicoEntregaEditado = dadosCalculo.valorServicoEntregaEditado;
            this.pedido.servicoEntrega = dadosCalculo.servicoEntrega;
            this.pedido.valorServicoEntrega = dadosCalculo.valorServicoEntrega;
            this.pedido.valorProjeto = dadosCalculo.valorProjeto;
            this.seguros = [...dadosCalculo.seguros];
            this.segurosManuais = [...dadosCalculo.segurosManuais];
            this.pedido.seguros = [...dadosCalculo.segurosSelecionados];
            this.segurosObrigatorios = [...dadosCalculo.segurosObrigatorios];
            this.segurosObrigatoriosRemovidos = [...dadosCalculo.segurosObrigatoriosRemovidos];
            this.potencia = dadosCalculo.potencia;
            this.valorSeguro = dadosCalculo.valorSeguro;
            this.valorLiquido = dadosCalculo.valorLiquido;
            this.pedido.valorProjetoLiquido = dadosCalculo.valorProjetoLiquido;
            this.pedido.voucher = dadosCalculo.voucher;
            this.pedido.dadosVoucher = dadosCalculo.dadosVoucher;
            this.pedido.valorVoucher = dadosCalculo.valorVoucher;
            this.pedido.ipi = dadosCalculo.ipi;
            this.pedido.ibs = dadosCalculo.ibs;
            this.pedido.cbs = dadosCalculo.cbs;
            const subtotalJaInicializado = this.subtotalPagamentoInicializado;
            const valorAnteriorParaFormasPagamento = this.valorParaFormasPagamento;

            this.pedido.formasPagamento = dadosCalculo.formasPagamento;
            this.valorParaFormasPagamento = dadosCalculo.valorParaFormasPagamento;
            this.subtotalPagamentoInicializado = true;

            // O primeiro cálculo estabelece o subtotal; duplicações mantêm a regra de reset.
            if (subtotalJaInicializado || this.duplicando) {
              this.normalizarFormasPagamentoAposAlteracao(valorAnteriorParaFormasPagamento);
            }
            this.pedido.impostos = dadosCalculo.impostos;
            this.pedido.valorImpostos = dadosCalculo.valorImpostos;
            this.pedido.impostosPendente = dadosCalculo.impostosPendente;

            this.aplicarLimitesCondicoesDePagamento();
            this.calcularPesoBruto();

            if (this.alterou && this.pedido.valorTotalFixo !== this.pedido.valorFinal) {
              this.pedido.valorTotalFixo = null;
            }

            if (this.margemLucro) {
              this.margemLucro.calcularValoresCalculadoraMargem();
            }

            if (this.alterou) {
              this.itens.forEach((p) => {
                p.pUnitarioFinal = dadosCalculo.itens.find((i) => i.produto === p.produto).pUnitarioFinal;
              });
            }

            if (this.premissasSistema.usarModalidade && this.fretes && this.fretes.length > 0 && !this.freteManual) {
              try {
                for (const frete of this.fretes) {
                  const freteProcessado = await this.valoresFretes(frete, TipoCalculoPedido.Normal);
                  Object.assign(frete, freteProcessado);
                }

                this.fretes = this.fretes.filter((frete) => frete.valorFrete !== 0 && frete.prazoTotal !== 0);

                this.fretesOriginais = JSON.parse(JSON.stringify(this.fretes));
              } catch (erro) {
                this.notificacaoService.erro('Erro ao processar valores dos fretes');
                console.error(erro);
              }
            }

            if (this.multiFormaPagamentoComp) {
              this.changeDetectorRef.detectChanges();
              await this.multiFormaPagamentoComp.salvarTodos();
            }
          }
          break;

        case TipoCalculoPedido.SimularDesconto:
          return dadosCalculo.valorTotal;

        case TipoCalculoPedido.SimularValorFinal:
          return dadosCalculo.valorDa;

        default:
          break;
      }

      this.usandoArredondamento = false;

      this.buscaValorMarkup();
    } catch (erro) {
      console.log('erro:', erro);
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('calcular');
    }
  }

  validarPreenchimentoQuestionario(tipoSalvar: string) {
    if (
      this.tipo === 0 ||
      !this.premissas.usarQuestionarioEntrega ||
      (tipoSalvar === 'salvar' && this.naoValidarPedido)
    ) {
      return true;
    }

    const temCamposNaoPreenchidos = this.premissas.usarQuestionarioEntrega
      ? this.perguntas.some(
          (p) =>
            ((p.tipo === 0 || p.tipo === 2) && (p.respostaSN === undefined || p.respostaSN === null)) ||
            ((p.tipo === 1 || p.tipo === 2) &&
              (p.respostaTexto === undefined ||
                p.respostaTexto === null ||
                p.respostaTexto === '' ||
                !p.respostaTexto.length))
        )
      : undefined;
    return (
      !this.premissas.camposQuestionariosObrigatorio ||
      (this.premissas.camposQuestionariosObrigatorio && !temCamposNaoPreenchidos)
    );
  }

  // valida a tela de acordo com a tab atual
  valida(tipo?) {
    const validarPedido = ['confirmar', 'validar', 'salvar'].includes(tipo);

    switch (this.tabIndex) {
      case 0:
        return !this.produtoEstruturaBloqueado && this.itens.length > 0;
      case 1:
        if (!this.validarCD()) {
          return false;
        }

        // cliente
        if (this.cliente === null || this.cliente === undefined) {
          return false;
        }

        // vendedor
        if (this.vendedorSelecionado === null || this.vendedorSelecionado === undefined) {
          return false;
        }

        // vendacupom
        if (!this.validarSalvar(validarPedido)) {
          return false;
        }

        // vendaDireta
        if (!this.validarVendaDireta()) {
          return false;
        }

        // questionário de entrega
        if (tipo !== 'cancelar' && !this.validarPreenchimentoQuestionario(tipo)) {
          return false;
        }

        // endereço de entrega
        if (tipo !== 'cancelar' && !(tipo === 'salvar' && this.naoValidarPedido) && !this.validarEnderecoDeEntrega()) {
          return false;
        }

        // venda programada
        if (this.premissas.vendaProgramada && !this.estoqueLoteOk) {
          return false;
        }

        if (this.pedido.orcamento || (tipo === 'salvar' && this.naoValidarPedido)) {
          if (this.pedido.multiFormaPagamento) {
            // multi forma pagamento
            return this.validarMultiFormasPagamento();
          } else {
            return true;
          }
        } else {
          // forma de pagamento
          if (this.pedido.multiFormaPagamento) {
            // multi forma pagamento
            if (!this.validarMultiFormasPagamento()) {
              return false;
            }
          } else if (
            this.pedido.formasPagamento === null ||
            this.pedido.formasPagamento === undefined ||
            this.pedido.formasPagamento.length === 0 ||
            this.pedido.formasPagamento[0].idFormaPag === null ||
            this.pedido.formasPagamento[0].idFormaPag === undefined
          ) {
            return false;
          } else if (
            this.pedido.formasPagamento[0].idCondPag === null ||
            this.pedido.formasPagamento[0].idCondPag === undefined
          ) {
            return false;
          }

          return true;
        }
      default:
        return true;
    }
  }

  validarSalvar(validarPedido?) {
    return this.pedido.origemGI === 0 && (this.pedido.orcamento || validarPedido)
      ? this.itens !== null &&
          this.itens !== undefined &&
          ((this.premissas.regraValidacaoKitPersonalizado === 0 &&
            this.itens.some((p) => p.produtoTela.familia === 2 && p.qt > 0) &&
            this.itens.some((p) => p.produtoTela.familia === 3 && p.qt > 0)) ||
            (this.premissas.regraValidacaoKitPersonalizado === 1 &&
              (this.itens.some((p) => p.produtoTela.familia === 2 && p.qt > 0) ||
                this.itens.some((p) => p.produtoTela.familia === 3 && p.qt > 0))))
      : true;
  }

  validarMultiFormasPagamento() {
    if (this.pedido.multiFormaPagamento && this.multiFormaPagamentoComp) {
      return this.multiFormaPagamentoComp.validar();
    } else {
      return true;
    }
  }

  private normalizarFormasPagamentoAposAlteracao(valorAnterior: number): void {
    const formasPagamento = this.pedido.formasPagamento;
    const valorAtual = Number(this.valorParaFormasPagamento);

    if (
      this.usandoArredondamento ||
      !this.premissas.podeUsarMultiFormaPagamento ||
      !this.alterou ||
      Number(valorAnterior) === valorAtual ||
      !formasPagamento
    ) {
      return;
    }

    const primeiraFormaPagamento = formasPagamento[0];

    primeiraFormaPagamento.tipo = TipoVendaFormaPag.Variavel;
    primeiraFormaPagamento.idFormaPag = null;
    primeiraFormaPagamento.idCondPag = null;
    primeiraFormaPagamento.valor = 0;
    primeiraFormaPagamento.taxa = 0;
    primeiraFormaPagamento.valorTaxa = 0;
    primeiraFormaPagamento.rateio = 0;
    primeiraFormaPagamento.valorRateio = 0;
    primeiraFormaPagamento.total = 0;
    formasPagamento.splice(0, formasPagamento.length, primeiraFormaPagamento);

    if (this.multiFormaPagamentoComp) {
      this.changeDetectorRef.detectChanges();
      this.multiFormaPagamentoComp.recarregarFormasPagamentoPrimeiraForma();
    }
  }

  validarVendaDireta() {
    return (
      !this.pedido.vendaDireta || (this.pedido.vendaDireta && this.vendaDiretaComp && this.vendaDiretaComp.validar())
    );
  }

  ngOnDestroy(): void {
    if (this.observer !== undefined && this.observer !== null) {
      this.observer.disconnect();
    }
  }

  calcularQtdPaineis() {
    this.qtdPainelSugestao = 0;

    if (this.fileiras || this.fileiras.length > 0) {
      this.fileiras.forEach((p) => {
        this.qtdPainelSugestao += p.numPaineis * p.fileiras;
      });
    }
  }

  async salvarPedido(tipo) {
    // tipo frete
    if (!this.validarTipoFrete()) {
      return;
    }

    if (
      tipo === 1 &&
      (!(await this.ValidarEstoque()) || (await this.verificarSeTemProdutoBloqueado(this.pedido.idCupom)))
    ) {
      return;
    }

    if (
      this.pedido.da === 0 &&
      this.descontoMaximo !== null &&
      this.descontoMaximo !== undefined &&
      Number(this.pedido.percentual.toFixed(2)) > Number(this.descontoMaximo.toFixed(2))
    ) {
      swal({
        title: 'ATENÇÃO!!!',
        html: 'Seu limite de desconto é inferior ao informado!!!<br/>Vendedor: ' + this.nomeVendedor,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    } else {
      let mensagem =
        'Deseja realmente ' +
        (tipo === 0 || tipo === 3 || this.pedido.ordemEtapa === 38 ? 'SALVAR' : 'VALIDAR') +
        ` o ${this.texto}?`;

      if (tipo === 2) {
        mensagem = `Deseja realmente enviar o pedido para ${this.integrador ? 'o vendedor REVISAR?' : 'REVISÃO?'} `;
      }

      swal({
        title: 'ATENÇÃO!',
        text: mensagem,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          if (!(await this.validarParaSalvar(tipo == 1))) return;

          this.carregandoService.mostra('salvaPedido');

          this.ajustarPedidoParaSalvar();

          this.salvar(tipo);
        }
      });
    }
  }

  async validarParaSalvar(validarEnderecoEntrega) {
    this.pedido.foraDaRegra = false;

    if (
      (this.alterouItens() || this.premissasUsuario.travarValidarKitCustomizado) &&
      this.pedido.origemGI === 0 &&
      this.premissasUsuario.validarKitCustomizadoEdicaoPedido &&
      !(await this.validarCombinacao())
    ) {
      return false;
    }

    if (validarEnderecoEntrega) {
      if (
        this.enderecoDeEntrega.tipoEndereco === TipoEnderecoEntrega.Integrador &&
        this.pedido.cliente &&
        this.cliente
      ) {
        this.validandoPedido = true;
        await this.copiaEnderecoIntegrador(true);
        this.validandoPedido = false;
      }

      if (this.premissasUsuario.buscarEnderecoSomentePorReceita) {
        const dadosDesatualizados = await this.clienteService.forcaAtualizacaoReceita(this.pedido.cliente).toPromise();

        if (dadosDesatualizados.result) {
          const temPermissao =
            this.suporte ||
            this.administrador ||
            (await this.funcionarioService.consultaPodeAcessarCadastroIntegrador(this.usuarioLogado.id).toPromise());

          swal({
            title: 'ATENÇÃO!',
            text: 'É necessário atualizar o cadastro deste integrador na Receita Federal!',
            type: 'warning',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-info',
            cancelButtonClass: 'btn btn-danger',
            confirmButtonText: 'Prosseguir',
            buttonsStyling: false
          }).then((result) => {
            if (temPermissao) {
              this.router.navigate(['/integradores/editar', this.pedido.cliente]);
            } else {
              this.notificacaoService.erro(
                'Você não tem permissão para acessar a tela de cadastro de integradores. Por favor, entre em contato com um administrador para realizar a atualização necessária.'
              );
            }
          });

          return false;
        }
      }
    }

    return true;
  }

  ajustarPedidoParaSalvar() {
    this.pedido.seguros = this.pedido.seguros.filter((p) => this.seguros.some((s) => s.id === p.idSeguro));
    this.pedido.seguros = [
      ...this.pedido.seguros,
      ...this.segurosObrigatoriosRemovidos.filter((p) => !this.pedido.seguros.some((pp) => pp.idSeguro === p.idSeguro))
    ];

    this.pedido.vendedor = this.vendedorSelecionado;
    this.pedido.indicacao = 0;

    this.pedido.cliente = this.cliente.id;
    this.pedido.nItens = this.itens.length;
    this.pedido.troco = 0;
    this.pedido.nParcelas = 1;
    this.pedido.gTotal = 0;
    this.pedido.nCartao = '1';
    this.pedido.bc = 0;
    this.pedido.ext = 0;
    this.pedido.nECF = '0';
    this.pedido.turno = 0;
    this.pedido.nTurno = 0;
    this.pedido.status = 0;
    this.pedido.nPdv = 99;
    this.pedido.nLoja = 1;

    this.pedido.idDescarga =
      this.pedido.idDescarga === null || this.pedido.idDescarga === undefined ? null : Number(this.pedido.idDescarga);

    this.pedido.freteManual = this.freteManual;

    if (this.pedido.servicoEntrega) {
      this.pedido.valorServicoEntrega = Number(this.pedido.valorServicoEntrega);
    } else {
      this.pedido.valorServicoEntrega = 0;
    }

    this.pedido.valorDa = Number(this.pedido.valorDa);
    this.pedido.percentual = Number(this.pedido.percentual);
    this.pedido.frete = Number(this.pedido.frete);
    this.pedido.valorServico = Number(this.pedido.valorServico);
    this.pedido.valorServicoLiquido = Number(this.valorLiquido);
    if (this.pedido.entrega !== null && this.pedido.entrega !== undefined) {
      this.pedido.entrega = Number(this.pedido.entrega);
    }

    this.pedido.funcDesco = this.pedido.valorDa === 0 ? 0 : this.usuarioLogado.id;
    this.pedido.taxaDA = this.valorTaxaCond;

    if (this.premissas.usarTbFrete && this.frete !== null && this.frete !== undefined) {
      this.pedido.transportadora = this.frete.idTransportadora;
    }

    this.pedido.servicoEntregaManual = this.valorServicoEntregaEditado;

    if (this.premissas.pUsarValorProjeto) {
      this.pedido.valorProjeto = this.pedido.valorProjeto ? Number(this.pedido.valorProjeto) : 0;
      this.pedido.valorProjetoLiquido = this.pedido.valorProjetoLiquido ? Number(this.pedido.valorProjetoLiquido) : 0;
    }

    this.pedido.data = new Date();

    this.itens.forEach((it) => {
      it.nItem = this.itens.indexOf(it) + 1;
      it.cc = it.produtoTela.cc;
      it.comissao = 0;
      it.da = 0; // se tiver desconto é 0
      it.frete = 0;
      it.pCusto =
        (it.pCusto === undefined || it.pCusto === null || Number(it.pCusto) === 0) &&
        Number(it.produtoTela.precoCusto) > 0
          ? it.produtoTela.precoCusto
          : it.pCusto;
      if (!this.pedido.descontoIndividual) {
        it.percentual = 0;
        it.valorDa = 0;
      }
      it.idCupom = this.idPedido ? this.idPedido : it.idCupom;
    });
  }

  alterarResposta(pergunta: VendaPergunta) {
    let resposta = this.respostas.find((p) => p.idPergunta == pergunta.id);

    if (resposta) {
      resposta.respostaSN = pergunta.respostaSN;
      resposta.respostaTexto = pergunta.respostaTexto;
    } else {
      let resp = new VendaResposta();
      resp.idCupom = this.pedido.idCupom;
      resp.idPergunta = pergunta.id;
      resp.respostaSN = pergunta.respostaSN;
      resp.respostaTexto = pergunta.respostaTexto;

      this.respostas.push(resp);
    }
  }

  salvar(tipo) {
    this.itens.forEach((p) => {
      p.pVendaOriginal =
        (this.pedido.origemGI === 2 && this.premissas.usarPrecoAvulso) || this.pedido.origemGI === 3
          ? p.produtoTela.precoAvulso
          : p.produtoTela.precoVenda;
    });
    // p.produtoTela.precoVenda; });

    this.respostas.forEach((r) => {
      r.tipoQuest = this.pedido.tipoFrete;
    });

    if (
      this.enderecoDeEntrega !== null &&
      this.enderecoDeEntrega !== undefined &&
      this.enderecoDeEntrega.ibge !== undefined &&
      this.enderecoDeEntrega.ibge !== null
    ) {
      this.enderecoDeEntrega.ibge = Number(this.enderecoDeEntrega.ibge);
    }

    if (this.pedido.idFrete != this.frete.id) this.pedido.idFrete = this.frete.id;

    this.pedidoService
      .salvar(
        this.pedido,
        this.itens,
        this.fileiras,
        this.clienteFaturamento,
        tipo === 3 || this.pedido.orcamento,
        this.tipo === 0 || this.pedido.orcamento ? true : false,
        false,
        this.enderecoDeEntrega,
        this.respostas
      )
      .subscribe(
        (resp: any) => {
          this.idPedido = resp.idCupom;
          this.notificacaoService.sucesso(
            this.texto +
              (tipo === 0 || tipo === 3 || this.pedido.ordemEtapa === 38
                ? ' Salvo'
                : tipo === 1
                  ? ' Validado'
                  : ' Enviado') +
              ' com sucesso!!!'
          );

          if (tipo === 1 && this.premissas.pUsarEstoqueMinimo) {
            const invalidos: InvalidoEstoqueMinimo[] = this.buscarItensInvalidosEstoqueMinimo();

            if (invalidos.length > 0) {
              this.enviarAvisoEstoqueMinimo({ idCupom: resp.idCupom, itens: invalidos });
            }
          }

          this.carregandoService.esconde('salvaPedido');
          if (this.tipo !== 0) {
            const mensagem = `Deseja imprimir o ${this.texto}?`;

            swal({
              title: 'IMPRESSÃO!',
              text: mensagem,
              type: 'info',
              showCancelButton: true,
              confirmButtonClass: 'btn btn-info',
              cancelButtonClass: 'btn btn-danger',
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não',
              buttonsStyling: false
            }).then((result) => {
              if (result.value) {
                this.imprimirPedido(true);
              } else {
                this.router.navigate(['/pedidos']).then(() => {});
              }
            });
          } else {
            this.router.navigate(['/orcamentos']);
          }
        },
        (erro) => {
          this.carregandoService.esconde('salvaPedido');
          this.notificacaoService.erro(erro);

          this.definirItemSemLote(erro);
        }
      );
  }

  defineTabAlvo(alvo) {
    this.tabAlvo = alvo;
  }

  cancelarPedido() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(MotivoPerdaOrcModalComponent, {
      width: largura > 630 ? '600px' : $('body').width().toString() + 'px',
      data: { texto: this.texto },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.carregandoService.mostra('cancelaPedido');

        this.pedidoService.cancelar(this.idPedido, result).subscribe(
          (resp) => {
            this.notificacaoService.sucesso(this.texto + ' cancelado com sucesso!!!');

            this.router.navigate([this.pedido.orcamento ? '/orcamentos' : '/pedidos']).then(() => {
              this.carregandoService.esconde('cancelaPedido');
            });
          },
          (erro) => {
            this.carregandoService.esconde('cancelaPedido');
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  calcularValorTotalItensComDesconto() {
    return this.itens.reduce((acc, curr) => acc + curr.vTotal, 0);
  }

  descontoIndividualAplicadoParaTodos() {
    const distinctDescontos = Array.from(new Set(this.itens.map((p) => p.percentual)));
    return distinctDescontos.length === 1 && distinctDescontos[0] > 0 && distinctDescontos[0] <= this.descontoMaximo;
  }

  descontoIndividual(item: ItemPedido) {
    const largura = Number($('body').width());

    const valorTotalItens = this.itens.reduce((acc, curr) => acc + Number(curr.pUnitario) * Number(curr.qt), 0);
    const valorTotalItensComDesconto = this.itens.filter((p) => p !== item).reduce((acc, curr) => acc + curr.vTotal, 0);

    const dialogRef = this.dialog.open(DescontoIndividualModalComponent, {
      width: largura > 630 ? '600px' : $('body').width().toString() + 'px',
      data: {
        valor: Number(item.pUnitario) * Number(item.qt),
        desconto: item.valorDa,
        percentual: item.percentual,
        valorTotalItens: valorTotalItens,
        valorTotalItensComDesconto: valorTotalItensComDesconto,
        descontoMaximo: this.descontoMaximo,
        descontoAplicadoParaTodos: this.descontoIndividualAplicadoParaTodos()
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        if (result.aplicarParaTodos) {
          this.itens.forEach((p) => {
            p.valorDa = Number(((Number(p.pUnitario) * Number(p.qt) * Number(result.percentual)) / 100).toFixed(2));
            p.percentual = Number(result.percentual);
            p.vTotal = Number((Number(p.pUnitario) * Number(p.qt) - p.valorDa).toFixed(2));
          });

          this.alterou = true;
          await this.atualizaDesconto(0, true);
        } else {
          if (
            Number(item.valorDa) !== Number(result.desconto) ||
            Number(item.percentual) !== Number(result.percentual) ||
            Number(item.vTotal) !== Number(result.valor)
          ) {
            this.alterou = true;
            // await this.excluirCupomDesconto();

            item.valorDa = Number(result.desconto);
            item.percentual = Number(result.percentual);
            item.vTotal = Number(result.valor);

            await this.atualizaDesconto(0, true);
          }
        }
      }
    });
  }

  validarDescontoIndividual(item: ItemPedido, exibirMsg: boolean) {
    const valorTotalItens = this.itens.reduce((acc, curr) => acc + Number(curr.pUnitario) * Number(curr.qt), 0);
    const valorTotalItensComDesconto = this.itens.reduce((acc, curr) => acc + curr.vTotal, 0);

    if (this.descontoIndividualAplicadoParaTodos()) return;

    if (
      this.pedido.flag === 4 &&
      item.valorDa > 0 &&
      item.percentual > 0 &&
      100 * ((valorTotalItens - valorTotalItensComDesconto) / valorTotalItens) > this.descontoMaximo
    ) {
      const valorDaMaximo = Number(((valorTotalItens * this.descontoMaximo) / 100).toFixed(2));
      const valorDaAtual = Number((valorTotalItens - valorTotalItensComDesconto).toFixed(2));
      const diferencaDa = Number((valorDaAtual - valorDaMaximo).toFixed(2));

      if (diferencaDa === 0) return;

      const valorItemSemDesconto = Number((Number(item.qt) * Number(item.pUnitario)).toFixed(2));
      const valorItem =
        item.vTotal + diferencaDa > valorItemSemDesconto ? valorItemSemDesconto : item.vTotal + diferencaDa;
      const percentualItem = ((valorItemSemDesconto - valorItem) * 100) / valorItemSemDesconto;

      if (exibirMsg && !this.integrador) {
        swal({
          title: 'ATENÇÃO!!',
          html:
            'Desconto acima do permitido: <b>' +
            this.descontoMaximo.toLocaleString() +
            (this.nomeVendedor ? '% </b><br/>Vendedor: ' + this.nomeVendedor : ''),
          type: 'warning',
          confirmButtonClass: 'btn btn-warning',
          buttonsStyling: false,
          allowEnterKey: false
        }).then(async (result) => {
          item.percentual = percentualItem;
          item.valorDa = valorItemSemDesconto - valorItem;
          item.vTotal = valorItem;

          await this.atualizaDesconto(1, true);
        });
      } else {
        item.percentual = percentualItem;
        item.valorDa = valorItemSemDesconto - valorItem;
        item.vTotal = valorItem;

        this.atualizaDesconto(1, true);
      }
    }
  }

  async ValidarEstoque() {
    if (this.premissas.pBloqPedidoSemEstoqueDisp) {
      if (!this.exibirEstoque) {
        await this.buscarEstoque();
      }

      await this.buscarItensComposicao();

      const itensSemEstoque: string[] = this.buscarItensSemEstoqueDisp();

      if (itensSemEstoque.length > 0) {
        swal({
          title: 'ATENÇÃO!',
          html:
            'Existem itens sem estoque disponível! </br></br>' +
            (!this.integrador ? itensSemEstoque.join('</br>') : 'Entre em contato com o seu vendedor!'),
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Fechar',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
          }
        });

        return false;
      } else if (
        this.premissas.vendaProgramada &&
        this.premissas.estoqueUnicoLote &&
        !(await this.validarEstoqueLoteUnico())
      ) {
        swal({
          title: 'ATENÇÃO!',
          html:
            'Existem itens sem estoque disponível para um único lote! </br></br>' +
            (!this.integrador ? '' : 'Entre em contato com o seu vendedor!'),
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Fechar',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
          }
        });
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  async confirmarPedido(enviarAnexo) {
    // tipo frete
    if (!this.validarTipoFrete()) {
      return;
    }

    if (!(await this.ValidarEstoque()) || (await this.verificarSeTemProdutoBloqueado(this.pedido.idCupom))) {
      return;
    }

    if (this.pedido.ordemEtapa === 38) {
      if (
        this.pedido.da === 0 &&
        this.descontoMaximo !== null &&
        this.descontoMaximo !== undefined &&
        Number(this.pedido.percentual.toFixed(2)) > Number(this.descontoMaximo.toFixed(2))
      ) {
        swal({
          title: 'ATENÇÃO!!!',
          html: 'Seu limite de desconto é inferior ao informado!!!<br/>Vendedor: ' + this.nomeVendedor,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).catch(swal.noop);

        return;
      }
    }

    if (this.premissas.pUsarEstoqueMinimo) {
      const invalidos: InvalidoEstoqueMinimo[] = this.buscarItensInvalidosEstoqueMinimo();

      if (invalidos.length > 0) {
        this.enviarAvisoEstoqueMinimo({ idCupom: this.pedido.idCupom, itens: invalidos });
      }
    }

    const mensagem = 'Deseja realmente CONFIRMAR o Pedido?';
    swal({
      title: 'ATENÇÃO!',
      text: mensagem,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then(async (result) => {
      if (result.value) {
        this.carregandoService.mostra('confirmaPedido');

        this.carregandoService.esconde('confirmaPedido');

        if (enviarAnexo || (!this.integrador && this.premissas.comprovanteObrigatorio)) {
          const largura = Number($('body').width());

          const dialogRef = this.dialog.open(AnexoModalComponent, {
            width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
            data: { idCupom: this.pedido.idCupom },
            panelClass: 'modal-card'
          });

          dialogRef.afterClosed().subscribe(async (result) => {
            if (result) {
              await this.confirmar(result);
            }
          });
        } else {
          await this.confirmar(false);
        }
      }
    });
  }

  async confirmar(arquivo) {
    if (this.pedido.ordemEtapa === 38) {
      await this.salvarEConfirmar(arquivo);
      return;
    }

    this.carregandoService.mostra('confirmaPedido');

    this.pedidoService
      .confirmar(
        this.idPedido,
        this.pedido.formasPagamento[0].idFormaPag,
        this.pedido.formasPagamento[0].idCondPag,
        this.pedido.obs2,
        this.pedido.vendaDireta,
        this.clienteFaturamento,
        false,
        this.pedido.financiamento,
        arquivo,
        this.valorTaxaCond,
        this.respostas,
        this.pedido.formasPagamento,
        this.pedido.dispEstoque,
        this.pedido.dataDispEstoque,
        this.enderecoDeEntrega.nomeResponsavel,
        this.enderecoDeEntrega.telefoneResponsavel,
        this.pedido.obs
      )
      .subscribe(
        async (resp: any) => {
          this.carregandoService.esconde('confirmaPedido');
          this.notificacaoService.sucesso('Pedido Confirmado com sucesso!!!');
          this.router.navigate(['/pedidos']);
        },
        (erro) => {
          this.carregandoService.esconde('confirmaPedido');
          this.notificacaoService.erro(erro);
          this.definirItemSemLote(erro);
        }
      );
  }

  async salvarEConfirmar(arquivo) {
    if (!(await this.validarParaSalvar(true))) return;

    this.carregandoService.mostra('confirmaPedido');

    this.ajustarPedidoParaSalvar();

    this.pedidoService
      .confirmarOrcamento(
        this.pedido,
        this.itens,
        this.fileiras,
        this.pedido.vendaDireta ? this.clienteFaturamento : null,
        false,
        false,
        false,
        this.enderecoDeEntrega,
        arquivo,
        this.respostas
      )
      .subscribe(
        (resp: any) => {
          this.carregandoService.esconde('confirmaPedido');
          //
          this.notificacaoService.sucesso('Pedido Confirmado com sucesso!!!');
          this.router.navigate(['/pedidos']);
        },
        (erro) => {
          this.carregandoService.esconde('confirmaPedido');
          this.notificacaoService.erro(erro);
        }
      );
  }

  definirItemSemLote(erro) {
    this.itemSemLote = false;

    if (this.premissas.vendaProgramada && erro.error && erro.error.itemSemLote) {
      this.itemSemLote = true;

      this.itens.forEach((p) => {
        p.produtoTela.semLote = false;

        if (p.produto === erro.error.itemSemLote) {
          p.produtoTela.semLote = true;
        } else if (p.produtoTela.composicao) {
          p.produtoTela.composicao.forEach((c) => {
            c.produtoMP.semLote = false;
            if (c.proMP === erro.error.itemSemLote) {
              p.produtoTela.semLote = true;
              c.produtoMP.semLote = true;
            }
          });
        }
      });
    }
  }

  novaEstrutura() {
    let fileira = new Fileira();
    fileira.uf = this.pedido.ufInstalacao;
    if (this.premissas.multiFornecedores) {
      fileira.idFornecedorPainel = this.pedido.painelProduto.idFornecedor;
    }

    if (this.premissas.pCentroDistribuicao || this.premissas.pMultiFornecedor) {
      fileira.idFornecedorPainel = this.pedido.idFornecedor;
    }

    if (this.pedido.painelProduto !== null && this.pedido.painelProduto !== undefined) {
      fileira.larguraPainel = this.pedido.painelProduto.largura;
      fileira.comprimentoPainel = this.pedido.painelProduto.comprimento;
      fileira.alturaPainel = this.pedido.painelProduto.altura;
      fileira.referenciaPainel = this.pedido.painelProduto.referencia;
    } else {
      fileira.larguraPainel = 0;
      fileira.comprimentoPainel = 0;
      fileira.alturaPainel = 0;
      fileira.referenciaPainel = '';
    }

    fileira.qtdFileiras = this.fileiras.filter(
      (p) => p.idFornecedorEstrutura === null || p.idFornecedorEstrutura === undefined
    ).length;

    fileira.tipoInversor =
      this.fileiras === null || this.fileiras === undefined || this.fileiras.length === 0
        ? 0
        : this.fileiras[0].tipoInversor;

    fileira.microInversor =
      fileira.tipoInversor === 1 ||
      this.itens.some((p) => p.produtoTela.familia === 3 && p.produtoTela.tipoInv === 1 && p.qt > 0);

    const qtdTotalPaineis = this.itens
      .filter((p) => p.produtoTela.familia === 2)
      .reduce((acc, curr) => acc + curr.qt, 0);

    fileira.qtdTotalModulosTodosLayouts = qtdTotalPaineis;

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(CadastrarEstruturaComponent, {
      width: largura > 1500 ? '1400px' : $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        fileira,
        fornecedoresUtilizados: this.fileiras.map((f) => f.fornecedor)
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    // quando fecha o modal
    dialogRef.afterClosed().subscribe((result: Fileira) => {
      if (result) {
        result.larguraPainel = this.pedido.painelProduto.largura;
        result.comprimentoPainel = this.pedido.painelProduto.comprimento;
        result.alturaPainel = this.pedido.painelProduto.altura;
        result.referenciaPainel = this.pedido.painelProduto.referencia;
        result.fileiras = Number(result.fileiras);
        result.numPaineis = Number(result.numPaineis);
        result.orientacao = result.orientacao;
        result.telhado = Number(result.telhado);

        if (this.premissas.multiFornecedores) {
          result.idFornecedorPainel = this.pedido.painelProduto.idFornecedor;
        }

        if (this.premissas.pCentroDistribuicao || this.premissas.pMultiFornecedor) {
          result.idFornecedorPainel = this.pedido.idFornecedor;
        }

        const qtdTotalPaineis = this.itens
          .filter((p) => p.produtoTela.familia === 2)
          .reduce((acc, curr) => acc + curr.qt, 0);

        result.qtdTotalModulosTodosLayouts = qtdTotalPaineis;

        this.carregandoService.mostra('atualizarFileiras');
        this.pedidoService.atualizarFileira(result).subscribe(
          async (resp) => {
            this.fileiras.push(resp);

            this.fileiras.forEach((forn: any) => {
              if (forn.idFornecedorEstrutura !== null && forn.idFornecedorEstrutura !== undefined) {
                forn.logo$ = this.fornecedorEstruturaService
                  .consultarImagemPorId(forn.idFornecedorEstrutura)
                  .map((m) =>
                    m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('')
                  )
                  .toPromise();
                forn.logo$.then((p) => {
                  forn.buscouImagem = true;
                });
              }
            });

            this.alterou = true;
            await this.excluirCupomDesconto();
            await this.buscarItensEstrutura();
            this.verificaPaineisEstrutura();
            this.carregandoService.esconde('atualizarFileiras');
          },
          (erro) => {
            this.carregandoService.esconde('atualizarFileiras');
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  editarEstrutura(fileira: Fileira, novaQuantidadePaineis?: number) {
    if (this.premissas.multiFornecedores) {
      fileira.idFornecedorPainel = this.pedido.painelProduto.idFornecedor;
    }

    if (this.premissas.pCentroDistribuicao || this.premissas.pMultiFornecedor) {
      fileira.idFornecedorPainel = this.pedido.idFornecedor;
    }

    if (this.pedido.painelProduto !== null && this.pedido.painelProduto !== undefined) {
      fileira.larguraPainel = this.pedido.painelProduto.largura;
      fileira.comprimentoPainel = this.pedido.painelProduto.comprimento;
      fileira.alturaPainel = this.pedido.painelProduto.altura;
      fileira.referenciaPainel = this.pedido.painelProduto.referencia;
    } else {
      fileira.larguraPainel = 0;
      fileira.comprimentoPainel = 0;
      fileira.alturaPainel = 0;
      fileira.referenciaPainel = '';
    }

    const qtdTotalPaineis = this.itens
      .filter((p) => p.produtoTela.familia === 2)
      .reduce((acc, curr) => acc + curr.qt, 0);

    fileira.qtdTotalModulosTodosLayouts = qtdTotalPaineis;

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(CadastrarEstruturaComponent, {
      width: largura > 1500 ? '1400px' : $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        fileira: Object.assign({}, fileira),
        fornecedoresUtilizados: this.fileiras.length === 1 ? [] : this.fileiras.map((f) => f.fornecedor),
        novaQuantidadePaineis
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    // quando fecha o modal
    dialogRef.afterClosed().subscribe((result: Fileira) => {
      if (result) {
        const recalcular =
          fileira.fileiras !== Number(result.fileiras) ||
          fileira.numPaineis !== Number(result.numPaineis) ||
          fileira.orientacao !== result.orientacao ||
          fileira.telhado !== Number(result.telhado) ||
          fileira.fornecedor !== result.fornecedor ||
          fileira.idFornecedorEstrutura !== result.idFornecedorEstrutura;

        fileira.fileiras = Number(result.fileiras);
        fileira.numPaineis = Number(result.numPaineis);
        fileira.opcaoOrientacao = result.opcaoOrientacao;
        fileira.opcaoTelhado = result.opcaoTelhado;
        fileira.orientacao = result.orientacao;
        fileira.telhado = Number(result.telhado);
        fileira.fornecedor = result.fornecedor;
        fileira.idFornecedorEstrutura = result.idFornecedorEstrutura;
        fileira.microInversor =
          fileira.tipoInversor === 1 ||
          this.itens.some((p) => p.produtoTela.familia === 3 && p.produtoTela.tipoInv === 1 && p.qt > 0);

        this.carregandoService.mostra('atualizarFileira');
        this.pedidoService.atualizarFileira(result).subscribe(
          async (resp) => {
            fileira.valorTotal = resp.valorTotal;
            fileira.itens = resp.itens;
            fileira.telhadoDescricao = resp.telhadoDescricao;
            fileira.fornecedorDescricao = resp.fornecedorDescricao;
            if (recalcular) {
              this.alterou = true;
              await this.excluirCupomDesconto();
              await this.buscarItensEstrutura();
            }
            this.verificaPaineisEstrutura();

            this.fileiras.forEach((forn: any) => {
              if (forn.idFornecedorEstrutura !== null && forn.idFornecedorEstrutura !== undefined) {
                forn.logo$ = this.fornecedorEstruturaService
                  .consultarImagemPorId(forn.idFornecedorEstrutura)
                  .map((m) =>
                    m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('')
                  )
                  .toPromise();
                forn.logo$.then((p) => {
                  forn.buscouImagem = true;
                });
              }
            });

            this.carregandoService.esconde('atualizarFileira');
          },
          (erro) => {
            this.carregandoService.esconde('atualizarFileira');
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  detalhesDoProduto(produto: Produto) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(DetalheProdutoModalComponent, {
      width: $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        produto: produto,
        origemGI: this.pedido.origemGI,
        buscarClassificacao: this.pedido.origemGI === OrigemGI.LojaProdutos
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  imprimirPedido(interno?) {
    this.carregandoService.mostra('imprimirPedido');

    this.relatorioService.pedido(this.idPedido).subscribe(
      (resp) => {
        this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
        this.utilitarioService.openBlobModal(
          resp,
          this.idPedido,
          interno === null || interno === undefined ? null : '/pedidos'
        );
        this.carregandoService.esconde('imprimirPedido');
      },
      (erro) => {
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement['result'];
          this.carregandoService.esconde('imprimirPedido');
          this.notificacaoService.erro(text);
        });

        // Start reading the blob as text.
        reader.readAsText(erro.error);
      }
    );
  }

  buscarClienteFaturamento() {
    this.carregandoService.mostra('buscarClienteFaturamento');

    this.pedidoService
      .consultarClienteVendaDireta(this.duplicando ? this.idCupomDuplicado : this.pedido.idCupom)
      .subscribe(
        (cli) => {
          this.clienteFaturamento = cli;
          if (this.duplicando) {
            this.clienteFaturamento.salvar = true;
          }
          this.atualizaDadosClienteFaturamento();
          this.buscarTiposDeEnderecoEntrega();
          this.definirDadosVendaDireta();
        },
        (erro) => {
          this.carregandoService.esconde('buscarClienteFaturamento');
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarClienteBanco() {
    if (
      !this.editavel ||
      (this.clienteFaturamento.tipo === 0 && !this.clienteFaturamento.cnpj) ||
      (this.clienteFaturamento.tipo === 1 && !this.clienteFaturamento.cpf)
    ) {
      return;
    }

    this.carregandoService.mostra('buscarClienteBanco');

    this.clienteService
      .consultarPorDoc(
        this.clienteFaturamento.tipo === 0 ? this.clienteFaturamento.cnpj : this.clienteFaturamento.cpf,
        this.clienteFaturamento.tipo
      )
      .subscribe(
        (cli) => {
          this.clienteFaturamento = cli;
          this.atualizaDadosClienteFaturamento();
          this.buscarTiposDeEnderecoEntrega();
          this.definirDadosVendaDireta();
        },
        (erro) => {
          this.carregandoService.esconde('buscarClienteBanco');
          this.notificacaoService.erro(erro);
        }
      );
  }

  atualizaDadosClienteFaturamento() {
    this.buscouClienteFaturamento = true;
    this.estadoSelecionado =
      this.clienteFaturamento !== null && this.clienteFaturamento !== undefined
        ? this.estados.find((s) => s === this.clienteFaturamento.uf)
        : undefined;

    this.buscarCidades();

    this.carregandoService.esconde('buscarClienteFaturamento');
  }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra('buscaEnderecoPorCep');
    this.viaCepService.obterEndereco(this.clienteFaturamento.cep).subscribe(
      (viaCep: ViaCep) => {
        this.clienteFaturamento.bairro = viaCep.bairro;
        this.clienteFaturamento.rua = viaCep.logradouro;
        this.estadoSelecionado = viaCep.uf;
        this.clienteFaturamento.ibge = viaCep.ibge;

        this.buscarCidades();

        this.focalizaNumero();

        this.carregandoService.esconde('buscaEnderecoPorCep');
      },
      (erro) => {
        this.carregandoService.esconde('buscaEnderecoPorCep');
        this.notificacaoService.erro('Não foi possível acessar o serviço de CEP!');
      }
    );
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra('buscaCidades');
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe(
      (ibges: Ibge[]) => {
        this.cidades = ibges;

        if (nomeCidade) {
          this.cidadeSelcionado = this.cidades.find(
            (s) =>
              this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) ===
              this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())
          )
            ? this.cidades.find(
                (s) =>
                  this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) ===
                  this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())
              ).cod
            : undefined;
        } else {
          this.cidadeSelcionado = this.cidades.find((s) => s.cod === this.clienteFaturamento.ibge)
            ? this.cidades.find((s) => s.cod === this.clienteFaturamento.ibge).cod
            : '';
        }

        this.carregandoService.esconde('buscaCidades');
      },
      (erro) => {
        this.carregandoService.esconde('buscaCidades');
      }
    );
  }

  focalizaNumero() {
    $('#numero').focus();
  }

  async adicionarItensSemLayout() {
    $('#botaoProximo').click();

    await this.pesquisarProdutos();
  }

  validaCupomDesconto(naoAvisar?) {
    if (this.tipoCupomDesconto === 0) {
      if (this.usuarioLogado.limDesc < Number(this.percentualCupomDesconto)) {
        if (!naoAvisar && !this.integrador) {
          swal({
            title: 'ATENÇÃO!!',
            html:
              'Desconto acima do permitido: <b>' +
              this.usuarioLogado.limDesc.toLocaleString() +
              '% </b><br/>Vendedor: ' +
              this.usuarioLogado.nome,
            type: 'warning',
            confirmButtonClass: 'btn btn-warning',
            buttonsStyling: false,
            allowEnterKey: false
          }).then((result) => {});
        }

        this.percentualCupomDesconto = Number(this.usuarioLogado.limDesc);
      }

      if (Number(this.percentualCupomDesconto) < this.limDescVendedorPedido) {
        if (!naoAvisar) {
          swal({
            title: 'ATENÇÃO!!',
            html: 'Desconto abaixo do permitido: <b>' + this.limDescVendedorPedido.toLocaleString() + '% </b>',
            type: 'warning',
            confirmButtonClass: 'btn btn-warning',
            buttonsStyling: false,
            allowEnterKey: false
          }).then((result) => {});
        }

        this.percentualCupomDesconto = Number(this.limDescVendedorPedido);
      }
    } else {
      const valorMaximo = Number(((this.pedido.valorTotal * this.usuarioLogado.limDesc) / 100).toFixed(2));
      const valorMinimo = Number(((this.pedido.valorTotal * this.limDescVendedorPedido) / 100).toFixed(2));

      if (valorMaximo < Number(this.valorCupomDesconto)) {
        if (!naoAvisar && !this.integrador) {
          swal({
            title: 'ATENÇÃO!!',
            html:
              'Desconto acima do permitido: <b>R$ ' +
              valorMaximo.toLocaleString() +
              ' </b><br/>Vendedor: ' +
              this.usuarioLogado.nome,
            type: 'warning',
            confirmButtonClass: 'btn btn-warning',
            buttonsStyling: false,
            allowEnterKey: false
          }).then((result) => {});
        }

        this.valorCupomDesconto = Number(valorMaximo);
      }

      if (Number(this.valorCupomDesconto) < valorMinimo) {
        if (!naoAvisar) {
          swal({
            title: 'ATENÇÃO!!',
            html: 'Desconto abaixo do permitido: <b>R$ ' + valorMinimo.toLocaleString() + ' </b>',
            type: 'warning',
            confirmButtonClass: 'btn btn-warning',
            buttonsStyling: false,
            allowEnterKey: false
          }).then((result) => {});
        }

        this.valorCupomDesconto = Number(valorMinimo);
      }
    }
  }

  alterouTipoCupomDesconto() {
    this.alterou = true;
    this.percentualCupomDesconto = Number(this.percentualCupomDesconto);
    this.valorCupomDesconto = Number(this.valorCupomDesconto);
    this.validaCupomDesconto();
  }

  async excluirCupomDesconto(validar = true) {
    if (this.pedido.cupomDesconto === null) {
      this.percentualCupomDesconto = null;
      this.valorCupomDesconto = null;
      return;
    }

    if (validar && this.premissasSistema.manterCupomDesconto) {
      // await this.atualizaDesconto(0, true);
      return;
    }

    this.alterou = true;
    this.percentualCupomDesconto = null;
    this.valorCupomDesconto = null;
    this.pedido.cupomDesconto = null;
    this.pedido.cupomDescontoValor = null;
    this.pedido.cupomDataHora = null;
    this.pedido.cupomUsuario = null;
    this.pedido.cupomUsuarioNome = null;
    await this.buscarDescontoMaximo();
    this.textoCupomExcluido =
      'Cupom excluído. Salve o ' + (this.tipo === 0 ? 'Orçamento' : 'Pedido') + ' para concluir!!!';
    this.textoCupomAplicado = '';

    await this.atualizaDesconto(0, true);
  }

  adicionarCupomDesconto() {
    this.percentualCupomDesconto = 0;
    this.valorCupomDesconto = 0;
    this.tipoCupomDesconto = 0;
  }

  buscarComissao() {
    this.carregandoService.mostra('buscarComissao');

    this.comissaoService.consultarPorFuncionario(this.vendedorSelecionado).subscribe(
      (com) => {
        this.comissao = com;
        this.carregandoService.esconde('buscarComissao');
      },
      (erro) => {
        this.carregandoService.esconde('buscarComissao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  mostrarComissao() {
    const valorFinalComissao =
      this.pedido.da === 0
        ? Number(this.pedido.valorTotal) - Number(this.pedido.valorDa)
        : Number(this.pedido.valorTotal) + Number(this.pedido.valorDa);

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ComissoesModalComponent, {
      // passa os produtos já selecionados
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        origemGI: this.pedido.origemGI,
        valorTotal: valorFinalComissao,
        comissao: this.comissao,
        valorComissao: this.calcularComissao(valorFinalComissao)
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  calcularComissao(valorFinalComissao) {
    if (!this.comissao || this.comissao === null || !this.comissao.itens) {
      return '0';
    }

    const perc = this.pedido.da === 0 ? this.pedido.percentual : 0;

    let item;

    if (this.pedido.origemGI === 1) {
      item = { valor: this.comissao.percKitPronto };
    } else {
      if (this.pedido.da === 0 && perc > 0) {
        item = this.comissao.itens.find((p) => perc >= p.inicio && perc <= p.fim);
      } else {
        item = this.comissao.itens.reduce((maior, item) => (item.valor > maior.valor ? item : maior));
      }
    }

    const valorComissao = (valorFinalComissao * (!item || item === null ? 0 : item.valor)) / 100;

    return valorComissao.toFixed(2);
  }

  async atualizaDesconto(tipo, valida, veioDaSimulacao?) {
    let valortotal = 0;
    this.itens.forEach((p) => (valortotal += Number(p.qt) * Number(p.pUnitario)));

    if (this.pedido.valorTotal.toFixed(2) !== valortotal.toFixed(2)) {
      this.alterouValorProdutos = true;
    }

    this.pedido.valorTotal = Number(valortotal.toFixed(2));

    if (this.pedido.flag === 4) {
      if (this.pedido.descontoIndividual) {
        this.pedido.valorDa = Number(
          (this.pedido.valorTotal - this.itens.reduce((acc, curr) => acc + curr.vTotal, 0)).toFixed(2)
        );
        tipo = 1;
      }

      if (tipo === 0) {
        if (!this.pedido.percentual) {
          this.pedido.valorDa = 0;
          this.pedido.percentual = 0;
        }
        if (valida && this.pedido.da === 0 && this.pedido.percentual > this.descontoMaximo) {
          if (!this.integrador && !this.validandoPedido) {
            let texto = this.premissas.descClienteSobreporVendedor
              ? `Desconto acima do permitido: <b> <br/> INTEGRADOR: ${this.cliente.descontoMaximoGI}%`
              : `Desconto acima do permitido: <b> ${this.descontoMaximo.toLocaleString()}% </b><br/>Vendedor: ${this.nomeVendedor} ${this.limDescVendedorPedido}% <br/> Integrador: ${this.cliente.nome} ${this.cliente.descontoMaximoGI}%`;

            if (this.pedido.cupomDesconto != null) {
              texto += ` <br/>Cupom de Desconto: ${this.pedido.cupomDesconto}%`;
            }

            swal({
              title: 'ATENÇÃO!!',
              html: texto,
              type: 'warning',
              confirmButtonClass: 'btn btn-warning',
              buttonsStyling: false,
              allowEnterKey: false
            }).then(async (result) => {
              this.pedido.percentual = this.descontoMaximo;
              this.pedido.valorDa = Number(
                ((Number(this.pedido.valorTotal) * this.pedido.percentual) / 100).toFixed(2)
              );
              await this.atualizaValores();
            });
          } else {
            this.pedido.percentual = this.descontoMaximo;
            this.pedido.valorDa = Number(((Number(this.pedido.valorTotal) * this.pedido.percentual) / 100).toFixed(2));

            if (this.nivelAgrupamentoCalculos > 0) {
              this.recalculoPosClampDescontoPendente = true;
            }

            await this.atualizaValores();
          }

          return;
        } else {
          // contra prova
          const percentualCalculado = (this.pedido.valorDa * 100) / Number(this.pedido.valorTotal);
          const valorDaMaximo = Number(((Number(this.pedido.valorTotal) * this.descontoMaximo) / 100).toFixed(2));
          const percentualAtual = veioDaSimulacao
            ? percentualCalculado === 0
              ? 0
              : Number(percentualCalculado.toFixed(4)) === 0
                ? 0.0001
                : Number(percentualCalculado.toFixed(4))
            : Number(this.pedido.valorDa) <= valorDaMaximo
              ? Number(percentualCalculado.toFixed(2))
              : percentualCalculado;

          if (percentualAtual !== this.pedido.percentual || this.alterouValorProdutos) {
            this.pedido.valorDa = Number(((Number(this.pedido.valorTotal) * this.pedido.percentual) / 100).toFixed(2));
          }
        }
      } else {
        if (!this.pedido.valorDa) {
          this.pedido.percentual = 0;
          this.pedido.valorDa = 0;
        }

        const percentualCalculado = (this.pedido.valorDa * 100) / Number(this.pedido.valorTotal);
        const valorDaMaximo = Number(((Number(this.pedido.valorTotal) * this.descontoMaximo) / 100).toFixed(2));

        this.pedido.percentual = veioDaSimulacao
          ? percentualCalculado === 0
            ? 0
            : Number(percentualCalculado.toFixed(4)) === 0
              ? 0.0001
              : Number(percentualCalculado.toFixed(4))
          : Number(this.pedido.valorDa) <= valorDaMaximo
            ? Number(percentualCalculado.toFixed(2))
            : percentualCalculado;

        if (this.pedido.descontoIndividual) {
          if (
            this.pedido.valorDa === valorDaMaximo ||
            this.utilitarioService.compararDescontos(Number(this.pedido.percentual), Number(this.descontoMaximo))
          ) {
            this.pedido.percentual = this.descontoMaximo;
          }
        }

        // if (this.pedido.percentual > this.descontoMaximo && Number(this.pedido.valorDa) <= valorDaMaximo){
        //     this.pedido.percentual = percentualCalculado > this.descontoMaximo ? this.descontoMaximo : percentualCalculado;
        // }

        if (
          valida &&
          this.pedido.da === 0 &&
          this.pedido.percentual !== this.descontoMaximo &&
          Number(this.pedido.valorDa) > valorDaMaximo
        ) {
          if (!this.integrador && !this.validandoPedido) {
            let txt = this.premissas.descClienteSobreporVendedor
              ? `Desconto acima do permitido: <b> <br/> INTEGRADOR: ${this.cliente.descontoMaximoGI}% <br/> VENDEDOR: ${this.limDescVendedorPedido}%`
              : `Desconto acima do permitido: <b> ${this.descontoMaximo.toLocaleString()}% </b><br/>Vendedor: ${this.nomeVendedor} ${this.limDescVendedorPedido}% <br/> Integrador: ${this.cliente.nome} ${this.cliente.descontoMaximoGI}%`;

            if (this.valorCupomDesconto != null) {
              txt += ` <br/>Cupom de Desconto: R$ ${this.valorCupomDesconto}`;
            }

            swal({
              title: 'ATENÇÃO!!',
              html: txt,
              type: 'warning',
              confirmButtonClass: 'btn btn-warning',
              buttonsStyling: false,
              allowEnterKey: false
            }).then(async (result) => {
              this.pedido.percentual = this.descontoMaximo;
              this.pedido.valorDa = Number(
                ((Number(this.pedido.valorTotal) * this.pedido.percentual) / 100).toFixed(2)
              );

              if (this.pedido.descontoIndividual) {
                this.itens.forEach((p) => this.validarDescontoIndividual(p, false));
                // this.atualizaDesconto(1, true);
              }

              await this.atualizaValores();
            });
          } else {
            this.pedido.percentual = this.descontoMaximo;
            this.pedido.valorDa = Number(((Number(this.pedido.valorTotal) * this.pedido.percentual) / 100).toFixed(2));

            if (this.pedido.descontoIndividual) {
              this.itens.forEach((p) => this.validarDescontoIndividual(p, false));
              // this.atualizaDesconto(1, true);
            }

            if (this.nivelAgrupamentoCalculos > 0) {
              this.recalculoPosClampDescontoPendente = true;
            }

            await this.atualizaValores();
          }

          return;
        }
      }

      await this.atualizaValores();
    }
  }

  async trocouVendedor() {
    await this.buscarNomeVendedor();
    await this.buscarLimDescVendedor();
    await this.buscarDescontoMaximo();
    await this.atualizaDesconto(0, true);
  }

  gerarXML() {
    // início
    let xml = '<checkout>';

    // cliente - início
    xml += '<sender>';

    xml += '<name>' + this.cliente.nome + '</name><email>' + this.cliente.email + '</email>';
    xml +=
      '<phone><areaCode>' +
      this.utilitarioService.removeMascara(this.cliente.cel).substring(0, 1) +
      '</areaCode><number>' +
      this.utilitarioService.removeMascara(this.cliente.cel).substring(2) +
      '</number></phone>';

    xml +=
      '<documents><document><type>' +
      (this.cliente.tipo === 0 ? 'CNPJ' : 'CPF') +
      '</type><value>' +
      (this.cliente.tipo === 0 ? this.cliente.cnpj : this.cliente.cpf) +
      '</value></document></documents>';

    // cliente - fim
    xml += '</sender>';

    // moeda
    xml += '<currency>BRL</currency>';

    // items - início
    xml += '<items>';

    this.itens.forEach((item) => {
      // item - início
      xml += '<item>';

      xml += '<id>' + item.produtoTela.idProduto + '</id>';
      xml += '<description>' + item.produtoTela.descricao + '</description>';
      xml += '<amount>' + item.pUnitario + '</amount>';
      xml += '<quantity>' + item.qt + '</quantity>';
      xml += '<weight>0</weight><shippingCost>0</shippingCost>';

      // item - fim
      xml += '</item>';
    });

    // items - fim
    xml += '</items>';

    // redirecturl
    xml += '<redirectURL></redirectURL>';

    // desconto
    xml += '<extraAmount>' + Number(this.pedido.valorDa) * -1 + '</extraAmount>';

    // referência
    xml += '<reference>' + this.pedido.idCupom + '</reference>';

    // shipping - início
    xml += '<shipping>';

    // address - início
    xml += '<address>';

    xml += '<street>' + this.cliente.rua + '</street>';
    xml += '<number>' + this.cliente.n + '</number>';
    xml += '<complement>' + this.cliente.compl + '</complement>';
    xml += '<district>' + this.cliente.bairro + '</district>';
    xml += '<city>' + this.cliente.cidade + '</city>';
    xml += '<state>' + this.cliente.uf + '</state>';
    xml += '<country>BRA</country>';
    xml += '<postalCode>' + this.utilitarioService.removeMascara(this.cliente.cep) + '</postalCode>';

    // address - fim
    xml += '</address>';

    // tipo
    xml += '<type>1</type>';

    // valor frete
    xml += '<cost>' + this.pedido.frete + '</cost>';

    xml += '<addressRequired>true</addressRequired>';

    // shipping - fim
    xml += '</shipping>';

    // timeout
    xml += '<timeout>25</timeout>';

    // tempo
    xml += '<maxAge>999999999</maxAge>';

    // usos
    xml += '<maxUses>999</maxUses>';

    // receiver - início
    xml += '<receiver>';

    xml += '<email>angelo.machiaveli@gmail.com</email>';

    // receiver - fim
    xml += '</receiver>';

    // recover
    xml += '<enableRecover>false</enableRecover>';

    // fim
    xml += '</checkout>';
  }

  async aplicarCupomDesconto() {
    this.usarCupomDesconto();
  }

  async salvarCupomDesconto(aplicar: boolean, validarCupomMenor: boolean) {
    if (
      validarCupomMenor &&
      (this.tipoCupomDesconto === 0
        ? Number(this.percentualCupomDesconto)
        : (Number(this.valorCupomDesconto) * 100) / Number(this.pedido.valorTotal)) < this.pedido.cupomDesconto
    ) {
      swal({
        title: 'Atenção!!',
        text: 'Já existe um cupom com valor maior, deseja realmente salvar um novo cupom com valor inferior?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          await this.salvarCupomDesconto(false, false);
        } else {
          this.percentualCupomDesconto = this.pedido.cupomDesconto;
          this.valorCupomDesconto = this.pedido.cupomDescontoValor;
          this.tipoCupomDesconto = this.pedido.tipoCupomDesconto;
        }
      });
    } else {
      this.calculadoraMargem.visivel = false;

      if (this.tipoCupomDesconto === 0) {
        if (this.usuarioLogado.limDesc < Number(this.percentualCupomDesconto)) {
          if (!this.integrador) {
            swal({
              title: 'ATENÇÃO!!',
              html:
                'Desconto acima do permitido: <b>' +
                this.usuarioLogado.limDesc.toLocaleString() +
                '% </b><br/>Vendedor: ' +
                this.usuarioLogado.nome,
              type: 'warning',
              confirmButtonClass: 'btn btn-warning',
              buttonsStyling: false,
              allowEnterKey: false
            }).then((result) => {});
          }

          this.percentualCupomDesconto = Number(this.usuarioLogado.limDesc);
        } else {
          this.pedido.tipoCupomDesconto = 0;
          this.pedido.cupomDescontoValor = null;
          this.pedido.cupomDesconto = Number(this.percentualCupomDesconto);

          if (aplicar || this.pedido.percentual > this.pedido.cupomDesconto) {
            this.pedido.percentual = this.pedido.cupomDesconto;
            this.descontoMaximo = this.pedido.cupomDesconto;

            this.alterou = true;
            await this.atualizaDesconto(0, true);
          }

          this.pedido.cupomUsuarioNome = this.usuarioLogado.nome;
          this.pedido.cupomDataHora = new Date();
          this.pedido.cupomUsuario = this.usuarioLogado.id;

          this.textoCupomAplicado = `Cupom adicionado. Salve o ${this.tipo === 0 ? 'Orçamento' : 'Pedido'} para concluir!!!`;
          this.textoCupomExcluido = '';

          this.carregandoService.esconde('salvarCupomDesconto');
        }
      } else {
        const valorMaximo = Number(((this.pedido.valorTotal * this.usuarioLogado.limDesc) / 100).toFixed(2));

        if (valorMaximo < Number(this.valorCupomDesconto)) {
          if (!this.integrador) {
            swal({
              title: 'ATENÇÃO!!',
              html:
                'Desconto acima do permitido: <b>R$' +
                valorMaximo.toLocaleString() +
                ' </b><br/>Vendedor: ' +
                this.usuarioLogado.nome,
              type: 'warning',
              confirmButtonClass: 'btn btn-warning',
              buttonsStyling: false,
              allowEnterKey: false
            }).then((result) => {});
          }

          this.valorCupomDesconto = Number(valorMaximo);
        } else {
          this.pedido.tipoCupomDesconto = 1;
          this.pedido.cupomDescontoValor = Number(this.valorCupomDesconto);
          this.pedido.cupomDesconto = (Number(this.valorCupomDesconto) * 100) / Number(this.pedido.valorTotal);

          if (aplicar || this.pedido.percentual > this.pedido.cupomDesconto) {
            this.pedido.percentual = this.pedido.cupomDesconto;
            this.descontoMaximo = this.pedido.cupomDesconto;

            this.alterou = true;
            await this.atualizaDesconto(0, true);
          }

          this.pedido.cupomUsuarioNome = this.usuarioLogado.nome;
          this.pedido.cupomDataHora = new Date();
          this.pedido.cupomUsuario = this.usuarioLogado.id;

          this.textoCupomAplicado = `Cupom adicionado. Salve o ${this.tipo === 0 ? 'Orçamento' : 'Pedido'} para concluir!!!`;
          this.textoCupomExcluido = '';

          this.carregandoService.esconde('salvarCupomDesconto');
        }
      }
    }
  }

  async usarCupomDesconto() {
    if (this.tipoCupomDesconto === 0) {
      this.pedido.percentual = this.pedido.cupomDesconto;
      this.descontoMaximo = this.pedido.cupomDesconto;

      this.alterou = true;
      await this.atualizaDesconto(0, true);
    } else {
      this.pedido.valorDa = this.pedido.cupomDescontoValor;
      this.pedido.cupomDesconto = (Number(this.pedido.cupomDescontoValor) * 100) / Number(this.pedido.valorTotal);
      this.pedido.percentual = this.pedido.cupomDesconto;
      this.descontoMaximo = this.pedido.cupomDesconto;

      this.alterou = true;
      await this.atualizaDesconto(0, true);
    }
  }

  detalhesDaEstrutura(itens) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(DetalheEstruturaModalComponent, {
      width: largura > 850 ? '800px' : $('body').width().toString() + 'px',
      data: {
        itens: itens
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  calcularTotalLayout() {
    let soma = 0;

    this.fileiras.forEach((fileira) => {
      soma += fileira.valorTotal;
    });
    return soma;
  }

  configurarLayout() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(LayoutModalComponent, {
      width: largura > 850 ? '800px' : $('body').width().toString() + 'px',
      data: {
        painel: this.pedido.painel,
        fase: this.pedido.fase,
        tensao: this.pedido.tensao
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.pedido.painel = result.painelSelecionado.idProduto;
        this.pedido.painelProduto = result.painelSelecionado;
        this.pedido.fase = result.faseSelecionada;
        this.pedido.tensao = result.tensaoSelecionada;
        if (!this.configurouLayout) {
          this.novaEstrutura();
        }
        this.configurouLayout = true;

        this.verificaPaineisEstrutura();
      }
    });
  }

  async alteraFrete() {
    await this.executarAlteracoesEmLote(async () => {
      if (this.premissasSistema.usaDescargaCif) {
        if (this.pedido.tipoFrete === 1) {
          this.pedido.tipoCIF = 0;
          this.tipoCIFFlag = null;
        } else if (this.pedido.tipoFrete === 0 && this.pedido.tipoCIF == 0 && this.tipoCIFFlag == null) {
          this.pedido.tipoCIF = null;
        } else if (this.pedido.tipoFrete === 0 && this.pedido.tipoCIF != null && this.tipoCIFFlag != null) {
          this.tipoCIFFlag = this.pedido.tipoCIF;
        }
      }

      if (this.premissasSistema.excluirCupomDescontoAoMudarTipoFrete) {
        await this.excluirCupomDesconto();
      }

      if (this.pedido.tipoFrete === 1) {
        this.pedido.idFrete = 0;
      }

      await this.buscarFrete();
    });
  }

  async alterouTipoFrete() {
    await this.executarAlteracoesEmLote(async () => {
      this.alterou = true;
      this.alterouNaTela = true;
      this.freteManual = false;

      await this.defineEnderecoEntregaFob();

      await this.alteraFrete();
      this.avaliarMensagemDescarga();
    });
  }

  async defineEnderecoEntregaFob() {
    if (this.pedido.tipoFrete === 1 && !this.premissasSistema.mostrarEnderecoEntregaFob) {
      this.enderecoDeEntrega.tipoEndereco = this.pedido.vendaDireta
        ? TipoEnderecoEntrega.VendaDireta
        : TipoEnderecoEntrega.Integrador;
      await this.alterouTipoDeEnderecoEntrega();

      this.enderecoDeEntrega.nomeResponsavel = this.enderecoDeEntrega.nome;
      this.enderecoDeEntrega.telefoneResponsavel = this.enderecoDeEntrega.celular;
    }
  }

  async recalculaFreteManual() {
    if (this.premissasSistema.recalculaFreteManual) {
      if (this.nivelAgrupamentoCalculos > 0) {
        this.recalculoFreteAgrupadoPendente = true;
        this.calculoAgrupadoPendente = true;
        return;
      }

      await this.buscarFrete(false, true);
    }
  }

  async buscarFrete(verificaFreteSelecionado: boolean = false, recalculaFreteManual: boolean = false) {
    if (this.nivelAgrupamentoCalculos > 0) {
      // Esta busca explícita já atende qualquer atualização de frete adiada pelo lote atual.
      this.recalculoFreteAgrupadoPendente = false;
    }

    try {
      this.carregandoService.mostra('buscarFrete');

      let excluirCupomDesconto = false;

      if (this.premissasSistema.usarModalidade && !this.freteManual) {
        let fretesBanco: Frete[];

        fretesBanco =
          (await this.freteService
            .listarPorIbge(
              this.enderecoDeEntrega !== null && this.enderecoDeEntrega !== undefined
                ? this.enderecoDeEntrega.ibge
                : this.cliente.ibge,
              this.premissas.pCentroDistribuicao || this.premissas.pMultiFornecedor
                ? this.pedido.idFornecedor
                : undefined
            )
            .toPromise()) || [];

        // if (verificaFreteSelecionado && !fretesBanco.some(b => b.id === this.pedido.idFrete)) {
        //   const freteSelecionado: Frete = await this.freteService.consultarPorIdFrete(this.pedido.idFrete).toPromise();

        //   if (!fretesBanco.includes(freteSelecionado)) {
        //     fretesBanco.push(freteSelecionado);
        //   }
        // }

        this.fretes = fretesBanco.filter((f) => f.valorFrete !== 0 && f.prazoTotal !== 0);

        this.fretesOriginais = JSON.parse(JSON.stringify(this.fretes));

        this.verModalidades = this.fretes !== null && this.fretes !== undefined && this.fretes.length > 0;

        if (this.verModalidades) {
          this.frete =
            this.pedido.idFrete !== null && this.pedido.idFrete !== undefined
              ? this.fretes.find((f) => f.id === this.pedido.idFrete) ||
                this.fretes.filter((f) => f.valorFrete !== 0 && f.prazoTotal !== 0 && f.modalidadePadrao)[0] ||
                this.fretes.find((f) => f.valorFrete !== 0 && f.prazoTotal !== 0)[0] ||
                new Frete()
              : this.fretes.some((f) => f.somenteFOB)
                ? this.fretes.find((f) => f.somenteFOB)
                : this.fretes.filter((f) => f.valorFrete !== 0 && f.prazoTotal !== 0 && f.modalidadePadrao)[0] ||
                  this.fretes.find((f) => f.valorFrete !== 0 && f.prazoTotal !== 0)[0] ||
                  new Frete();

          for (let f of this.fretes) {
            f = await this.valoresFretes(f, TipoCalculoPedido.Normal);
          }
        }
      }

      if (!this.verModalidades) {
        this.frete = await this.freteService
          .buscarPorIbge(
            this.enderecoDeEntrega !== null && this.enderecoDeEntrega !== undefined
              ? this.enderecoDeEntrega.ibge
              : this.cliente.ibge,
            this.premissas.pCentroDistribuicao || this.premissas.multiFornecedores
              ? this.pedido.idFornecedor
              : undefined
          )
          .toPromise();
      }

      if (this.alterou) {
        if (this.pedido.idFrete != this.frete.id && this.premissasSistema.excluirCupomDescontoAoMudarValorFrete) {
          excluirCupomDesconto = true;
        }

        if (!this.frete.id && this.fretes.some((f) => f.valorFrete !== 0 && f.prazoTotal !== 0)) {
          this.frete = this.fretes.find((f) => f.valorFrete !== 0 && f.prazoTotal !== 0);
          this.pedido.idFrete = this.frete.id;
        }

        this.validarTipoFrete();

        if (this.pedido.tipoFrete === undefined) {
          this.pedido.tipoFrete = 0;
        }

        this.freteDigitado = this.freteManualInicial && !this.alterouNaTela;
        this.freteManualInicial =
          (this.premissas.pFreteManualAvulso && this.pedido.origemGI === 2) ||
          (this.freteManualInicial && this.primeiraAlteracao && !this.alterouNaTela)
            ? true
            : false;

        this.pedido.entrega = this.frete.prazoTotal;

        this.primeiraAlteracao = false;
      }

      await this.buscarPerguntasEntrega();
      await this.buscarRespostas();

      await this.atualizaValores(TipoCalculoPedido.Normal, null, recalculaFreteManual);

      if (
        this.pedido.tipoFrete === 0 &&
        !this.podeAlterarCD &&
        this.premissas.pCentroDistribuicao &&
        this.premissasSistema.habilitarCDPorCidade &&
        this.ibgeEntrega &&
        this.ibgeEntrega.cd !== this.pedido.idFornecedor &&
        this.ibgeEntrega.cod !== this.cidadeOriginal
      ) {
        swal({
          title: 'ATENÇÃO!!!',
          html: 'Este produto não atende à nova cidade escolhida. Refaça o pedido com a cidade desejada. Temos outros produtos disponíveis. Caso precise, entre em contato com seu consultor.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        });
      }

      if (excluirCupomDesconto) {
        await this.excluirCupomDesconto(false);
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarFrete');
    }
  }

  validarTipoFrete(): boolean {
    if (
      ((this.frete !== undefined && this.frete !== null && this.frete.somenteFOB === 1) ||
        (this.integrador && this.premissas.pFreteManualAvulso && this.pedido.origemGI === 2)) &&
      this.pedido.tipoFrete === 0
    ) {
      swal({
        title: 'ATENÇÃO!!!',
        html: 'O endereço escolhido não permite entrega CIF!<br/>Escolha outro endereço ou selecione FOB (retirada)!!!',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);

      return false;
    }

    return true;
  }

  async valoresFretes(frete: Frete, tipoCalculo: TipoCalculoPedido = TipoCalculoPedido.Normal) {
    frete.valorFrete = frete.valorFrete == null || frete.valorFrete == undefined ? 0 : frete.valorFrete;

    frete.prazoTotal = frete.prazoTotal != null && true ? Number(frete.prazoTotal) : 0;

    let percentualFreteAvulso = null;

    if (this.premissas.bloquearTipoFreteVendaDireta && this.pedido.origemGI === 2) {
      let totalValorCif = 0;
      let totalValorFob = 0;

      this.itens.forEach((p) => {
        if (p.qt > 0) {
          totalValorCif += p.precoCif * p.qt;
          totalValorFob += p.pUnitario * p.qt;
        }
      });

      percentualFreteAvulso = totalValorCif === 0 ? 0 : (1 - totalValorFob / totalValorCif) * 100;
    }

    const qtModulos = this.itens.reduce((total, it) => {
      if (it.produtoTela.familia === 2) {
        return total + it.qt;
      }
      if (it.produtoTela.familia === 7) {
        return (
          total +
          it.produtoTela.composicao.reduce((compTotal, comp) => {
            return comp.produtoMP.familia === 2 ? compTotal + comp.qt * it.qt : compTotal;
          }, 0)
        );
      }
      return total;
    }, 0);

    let dadosCalculo: DadosCalculo = {
      valorProdutos: this.pedido.valorTotal,
      valorServico:
        this.pedido.valorServico !== null && this.pedido.valorServico !== undefined
          ? Number(this.pedido.valorServico)
          : 0,
      valorDoServicoAcima: false,
      valorDa: this.pedido.valorDa !== null && this.pedido.valorDa !== undefined ? Number(this.pedido.valorDa) : 0,
      percentual:
        this.pedido.percentual !== null && this.pedido.percentual !== undefined ? Number(this.pedido.percentual) : 0,
      tipoFrete: this.pedido.tipoFrete,
      valorFrete: frete.valorFrete !== null && frete.valorFrete !== undefined ? Number(frete.valorFrete) : 0,
      percentualFrete:
        frete.id === this.pedido.idFrete &&
        this.pedido.percentualFrete !== null &&
        this.pedido.percentualFrete !== undefined
          ? Number(this.pedido.percentualFrete)
          : undefined,
      localizacao: this.pedido.tipoLocalizacao,
      da: this.pedido.da,
      percentualFreteAvulso: percentualFreteAvulso,
      frete: frete,
      idDescarga: this.pedido.idDescarga,
      freteManual: this.freteManual,
      freteDigitado: this.freteDigitado,
      msgFreteIntegrador: '',
      mostrarMsgFreteIntegrador: false,
      descontoFrete: this.descontoFrete,
      taxaCondicao: this.taxaCondicao,
      valorTaxaCond: this.valorTaxaCond,
      valorTotal: this.pedido.valorFinal,
      valorServicoEntregaEditado: this.valorServicoEntregaEditado,
      servicoEntrega: this.pedido.servicoEntrega,
      valorServicoEntrega: this.pedido.valorServicoEntrega,
      valorProjeto:
        this.pedido.valorProjeto !== null && this.pedido.valorProjeto !== undefined
          ? Number(this.pedido.valorProjeto)
          : 0,
      seguros: [...this.seguros],
      segurosManuais: [...this.segurosManuais],
      segurosSelecionados:
        this.pedido.seguros !== null && this.pedido.seguros !== undefined ? [...this.pedido.seguros] : [],
      segurosObrigatorios: [...this.segurosObrigatorios],
      segurosObrigatoriosRemovidos: [...this.segurosObrigatoriosRemovidos],
      potencia: this.potencia,
      idCupom: this.pedido.idCupom,
      valorSeguro: this.valorSeguro,
      valorLiquido: this.valorLiquido !== null && this.valorLiquido !== undefined ? Number(this.valorLiquido) : 0,
      valorProjetoLiquido:
        this.pedido.valorProjetoLiquido !== null && this.pedido.valorProjetoLiquido !== undefined
          ? Number(this.pedido.valorProjetoLiquido)
          : 0,
      voucher: this.pedido.voucher,
      dadosVoucher: this.pedido.dadosVoucher,
      valorVoucher: this.pedido.valorVoucher,
      alterou: true,
      origem: this.pedido.origemGI,
      pedidoFlag: this.pedido.flag,
      tipoCalculo: tipoCalculo,
      valorFinalParaSimular: null,
      status: this.pedido.status,
      qtModulos: qtModulos,
      tipoCIF: this.pedido.tipoCIF !== null && this.pedido.tipoCIF !== undefined ? this.pedido.tipoCIF : null,
      itens: this.itens,
      multiFormaPagamento: false,
      formasPagamento: this.pedido.formasPagamento,
      ipi: this.pedido.ipi,
      ibs: this.pedido.ibs,
      cbs: this.pedido.cbs,
      possuiArredondamento: this.usandoArredondamento,
      cpfCnpj: this.pedido.vendaDireta
        ? this.clienteFaturamento.tipo === 0
          ? this.clienteFaturamento.cnpj
          : this.clienteFaturamento.cpf
        : this.cliente.tipo === 0
          ? this.cliente.cnpj
          : this.cliente.cpf,
      idCd: this.pedido.idFornecedor,
      uf: this.enderecoDeEntrega.uf,
      impostos: this.pedido.impostos,
      valorImpostos: this.pedido.valorImpostos,
      descontoIndividual: this.pedido.descontoIndividual
    };

    try {
      this.carregandoService.mostra('calcular');
      const resultado = await this.pedidoService.calcular(dadosCalculo).toPromise();
      frete.valorFrete = Number(resultado.valorFrete);
    } catch (erro) {
      this.notificacaoService.erro(erro);
      frete.valorFrete = 0;
    } finally {
      this.carregandoService.esconde('calcular');
      return frete;
    }
  }

  async selecionarFreteModalidade(frete: Frete) {
    this.frete = frete;
    this.pedido.idFrete = frete.id;
    this.pedido.entrega = frete.prazoTotal;
    this.alterou = true;

    await this.buscarPerguntasEntrega();
    await this.atualizaValores();
  }

  visualizarTermo() {
    this.carregandoService.mostra('termosDeUso');

    this.pedidoService.baixarTermo().subscribe(
      (resp) => {
        this.utilitarioService.openBlobModal(resp);

        this.carregandoService.esconde('termosDeUso');
      },
      (erro) => {
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement['result'];
          this.carregandoService.esconde('termosDeUso');
          this.notificacaoService.erro(text);
        });

        // Start reading the blob as text.
        reader.readAsText(erro.error);
      }
    );

    return false;
  }

  nomeArquivoEstrutura(fileira) {
    if (fileira.fornecedor === undefined || fileira.fornecedor === null) {
      return 'semestrutura';
    } else {
      switch (fileira.fornecedor) {
        case 0:
          return 'alfix';
        case 1:
          return 'photoenergy';
        case 2:
          return 'gosolar';
        case 3:
          return 'fotus';
        case 4:
        case 10:
          return 'romagnole';
        case 5:
          return 'brassunny';
        case 6:
          return 'ssm';
        case 7:
          return 'lbsolar';
        case 8:
          return 'viener';
        case 9:
          return 'ccm';
        case 11:
          return 'bellesystem';
        case 12:
          return 'pratyc';
        case 13:
          return 'e3';
        case 14:
          return 'solargroup';
        case 15:
        case 16:
        case 17:
          return 'vertys';
        case 18:
          return 'k2';
      }
    }
  }

  async atualizarTaxaDeCondicao() {
    if (this.pedido.multiFormaPagamento || !this.pedidoComCondicaoDePagamento()) {
      this.taxaCondicao = 0;
    } else {
      this.taxaCondicao = this.pedido.formasPagamento[0].taxa;
    }
    await this.atualizaValores();
  }

  private async atualizarValoresAposAlteracaoEndereco() {
    await this.executarAlteracoesEmLote(async () => {
      await this.atualizarDescontoPrecificacaoUF();
      await this.buscarFrete();

      if (this.premissasSistema.limparCupomDescontoAoAlterarCidadeEntrega) {
        await this.excluirCupomDesconto();
      }
    });
  }

  async copiaEnderecoVendaDireta() {
    this.enderecoDeEntrega = new VendaEntrega();
    this.enderecoDeEntrega.tipoEndereco = TipoEnderecoEntrega.VendaDireta;
    this.enderecoDeEntrega.rua = this.clienteFaturamento.rua !== undefined ? this.clienteFaturamento.rua : '';
    this.enderecoDeEntrega.numero = this.clienteFaturamento.n !== undefined ? this.clienteFaturamento.n : '';
    this.enderecoDeEntrega.bairro = this.clienteFaturamento.bairro !== undefined ? this.clienteFaturamento.bairro : '';
    this.enderecoDeEntrega.cidade = this.clienteFaturamento.cidade !== undefined ? this.clienteFaturamento.cidade : '';
    this.enderecoDeEntrega.cep = this.clienteFaturamento.cep !== undefined ? this.clienteFaturamento.cep : '';
    this.enderecoDeEntrega.uf = this.clienteFaturamento.uf !== undefined ? this.clienteFaturamento.uf : '';
    this.enderecoDeEntrega.complemento =
      this.clienteFaturamento.compl !== undefined ? this.clienteFaturamento.compl : '';
    this.enderecoDeEntrega.ibge =
      this.clienteFaturamento.ibge !== undefined ? Number(this.clienteFaturamento.ibge) : undefined;

    this.enderecoDeEntrega.tipo = this.clienteFaturamento.tipo;
    this.enderecoDeEntrega.cpfCnpj =
      this.clienteFaturamento.tipo === 1 ? this.clienteFaturamento.cpf : this.clienteFaturamento.cnpj;
    this.enderecoDeEntrega.rgIe =
      this.clienteFaturamento.tipo === 1 ? this.clienteFaturamento.rg : this.clienteFaturamento.inscEst;
    this.enderecoDeEntrega.nome = this.clienteFaturamento.nome;
    this.enderecoDeEntrega.celular = this.clienteFaturamento.cel;
    this.enderecoDeEntrega.email = this.clienteFaturamento.email;

    this.ibgeEntrega = this.enderecoDeEntrega.ibge
      ? await this.ibgeService.buscarCidadePorCodIGBE(this.enderecoDeEntrega.ibge.toString()).toPromise()
      : undefined;

    this.alterou = true;
    this.freteManual = false;
    this.gerarEnderecoEntregaCompleto();
    await this.atualizarValoresAposAlteracaoEndereco();
  }

  async alterouTipoCif() {
    await this.executarAlteracoesEmLote(async () => {
      this.alterou = true;
      this.alterouNaTela = true;
      this.freteManual = false;
      this.tipoCIFFlag = this.pedido.tipoCIF;

      // if (this.pedido.tipoCIF === 0 && this.premissasSistema.excluirCupomDescontoAoMudarLocalizacao) {
      //   await this.excluirCupomDesconto();
      // }

      if (this.premissasSistema.excluirCupomDescontoAoMudarTipoFreteCif) {
        await this.excluirCupomDesconto();
      }

      await this.alteraFrete();
      this.avaliarMensagemDescarga();
    });
  }

  async copiaEnderecoIntegrador(naoAtualizar?) {
    const ibgeAnterior = Number(this.enderecoDeEntrega.ibge || 0);
    const ufAnterior = this.enderecoDeEntrega.uf;

    this.enderecoDeEntrega.tipoEndereco = TipoEnderecoEntrega.Integrador;
    this.enderecoDeEntrega.rua = this.cliente.rua;
    this.enderecoDeEntrega.numero = this.cliente.n;
    this.enderecoDeEntrega.bairro = this.cliente.bairro;
    this.enderecoDeEntrega.cidade = this.cliente.cidade;
    this.enderecoDeEntrega.cep = this.cliente.cep;
    this.enderecoDeEntrega.uf = this.cliente.uf;
    this.enderecoDeEntrega.complemento = this.cliente.compl;
    this.enderecoDeEntrega.ibge = Number(this.cliente.ibge);

    this.enderecoDeEntrega.tipo = this.cliente.tipo;
    this.enderecoDeEntrega.cpfCnpj = this.cliente.tipo === 1 ? this.cliente.cpf : this.cliente.cnpj;
    this.enderecoDeEntrega.rgIe = this.cliente.tipo === 1 ? this.cliente.rg : this.cliente.inscEst;
    this.enderecoDeEntrega.nome = this.cliente.nome;
    this.enderecoDeEntrega.celular = this.cliente.cel;
    this.enderecoDeEntrega.email = this.cliente.email;

    if (!naoAtualizar) {
      this.alterou = true;
    }

    this.gerarEnderecoEntregaCompleto();

    const mudouLocalEntrega =
      ibgeAnterior !== Number(this.enderecoDeEntrega.ibge || 0) || ufAnterior !== this.enderecoDeEntrega.uf;

    // Ao validar, alterações anteriores do pedido não indicam uma mudança no endereço.
    if (mudouLocalEntrega || (!naoAtualizar && this.alterou)) {
      this.ibgeEntrega = this.enderecoDeEntrega.ibge
        ? await this.ibgeService.buscarCidadePorCodIGBE(this.enderecoDeEntrega.ibge.toString()).toPromise()
        : undefined;

      await this.atualizarValoresAposAlteracaoEndereco();
    }
  }

  adicionarEnderecoEntrega() {
    const novoEnderecoDeEntrega =
      this.enderecoDeEntrega.tipoEndereco === TipoEnderecoEntrega.Personalizado
        ? Object.assign({}, this.enderecoDeEntrega)
        : new VendaEntrega();

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(VendaEnderecoModalComponent, {
      width: largura > 1100 ? '1000px' : $('body').width().toString() + 'px',
      data: {
        enderecoEntrega: novoEnderecoDeEntrega,
        mostrarDadosPessoa: this.tipo !== 0,
        validarDadosPessoa: this.tipo !== 0,
        msgEnderecoAdicional: this.premissas.msgEnderecoAdicional
      },
      panelClass: 'modal-card',
      maxHeight: '95vh'
    });
    dialogRef.afterClosed().subscribe(async (result: VendaEntrega) => {
      if (result) {
        this.enderecoDeEntrega = result;

        this.ibgeEntrega = this.enderecoDeEntrega.ibge
          ? await this.ibgeService.buscarCidadePorCodIGBE(this.enderecoDeEntrega.ibge.toString()).toPromise()
          : undefined;

        this.alterou = true;
        this.mostraMsgEnderecoAdicional = true;

        this.gerarEnderecoEntregaCompleto();
        await this.atualizarValoresAposAlteracaoEndereco();
      }
    });
  }

  calcularPesoBruto() {
    this.pesoBruto = 0;
    this.potencia = 0;
    this.itens.forEach((element: ItemPedido) => {
      this.pesoBruto += element.produtoTela.peso ? element.produtoTela.peso * element.qt : 0;
      if (element.produtoTela.familia === 2 || element.produtoTela.familia === 7) {
        this.potencia += (element.produtoTela.potencia * element.qt) / 1000;
      }
    });
    this.valorKwp = this.potencia > 0 ? this.pedido.valorFinal / (this.potencia * 1000) : 0;
  }

  async alterouPraQuemVaiFaturar() {
    await this.executarAlteracoesEmLote(async () => {
      this.alterou = true;

      if (!this.pedido.vendaDireta) {
        this.clienteFaturamento = undefined;
        // this.editandoVendaDireta = false;

        if (this.cliente !== undefined && this.enderecoDeEntrega.tipoEndereco === TipoEnderecoEntrega.VendaDireta) {
          await this.completarEnderecoEntrega(true, true);
        }

        await this.defineEnderecoEntregaFob();

        if (this.pedido.origemGI === 3 && this.premissasSistema.habilitarApiImposto) {
          await this.atualizaValores();
        }
      } else {
        this.definirDadosVendaDireta();
        // this.editandoVendaDireta = true;
      }

      this.buscarTiposDeEnderecoEntrega();
    });
  }

  async retornoVendaDireta(cliente: Cliente) {
    // this.editandoVendaDireta = false;

    if (!this.editavel) {
      return;
    }

    await this.executarAlteracoesEmLote(async () => {
      if (cliente) {
        this.clienteFaturamento = cliente;

        if (!this.validarVendaDireta()) {
          return;
        }

        if (!this.clienteFaturamento.salvar) {
          this.alterou = true;
        }

        this.clienteFaturamento.salvar = true;

        if (this.enderecoDeEntrega.tipoEndereco !== TipoEnderecoEntrega.VendaDireta) {
          await this.completarEnderecoEntrega(false, true);
        } else {
          await this.copiaEnderecoVendaDireta();
        }

        await this.defineEnderecoEntregaFob();

        if (this.pedido.origemGI === 3 && this.premissasSistema.habilitarApiImposto) {
          await this.atualizaValores();
        }
      } else {
        if (
          this.clienteFaturamento === null ||
          this.clienteFaturamento === undefined ||
          this.clienteFaturamento.cep === null ||
          this.clienteFaturamento.cep === undefined
        ) {
          this.pedido.vendaDireta = false;
          this.clienteFaturamento = undefined;
        }
      }

      this.buscarTiposDeEnderecoEntrega();
    });
  }

  async retornoEnderecoEntrega(result: VendaEntrega) {
    if (result) {
      this.enderecoDeEntrega = result;

      this.ibgeEntrega = this.enderecoDeEntrega.ibge
        ? await this.ibgeService.buscarCidadePorCodIGBE(this.enderecoDeEntrega.ibge.toString()).toPromise()
        : undefined;

      this.alterou = true;
      this.mostraMsgEnderecoAdicional = true;

      this.gerarEnderecoEntregaCompleto();
      await this.atualizarValoresAposAlteracaoEndereco();
    }

    this.editandoEnderecoEntrega = false;
  }

  definirDadosVendaDireta() {
    // this.dadosVendaDireta.clienteFaturamento = this.clienteFaturamento === null || this.clienteFaturamento === undefined ? new Cliente() : Object.assign({}, this.clienteFaturamento);

    if (this.clienteFaturamento === null || this.clienteFaturamento === undefined) {
      this.clienteFaturamento = new Cliente();
    }
  }

  async abrirDadosVendaDireta(tipo) {
    if (tipo === 1) {
      if (!this.pedido.vendaDireta) {
        await this.executarAlteracoesEmLote(async () => {
          this.alterou = true;
          this.clienteFaturamento = undefined;

          if (this.cliente !== undefined && this.enderecoDeEntrega.tipoEndereco === TipoEnderecoEntrega.VendaDireta) {
            await this.completarEnderecoEntrega(true, true);
          }

          if (this.pedido.origemGI === 3 && this.premissasSistema.habilitarApiImposto) {
            await this.atualizaValores();
          }
        });

        return;
      }
    }

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(VendaDiretaModalComponent, {
      width: largura > 1100 ? '1000px' : $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        clienteFaturamento:
          this.clienteFaturamento === null || this.clienteFaturamento === undefined
            ? new Cliente()
            : Object.assign({}, this.clienteFaturamento)
      },
      panelClass: 'modal-card',
      maxHeight: '95vh'
    });
    dialogRef.afterClosed().subscribe(async (result: Cliente) => {
      if (result) {
        await this.executarAlteracoesEmLote(async () => {
          this.clienteFaturamento = result;

          if (this.clienteFaturamento.cep === null || this.clienteFaturamento.cep === undefined) {
            this.pedido.vendaDireta = false;
          } else {
            if (!this.clienteFaturamento.salvar) {
              this.alterou = true;
            }

            this.clienteFaturamento.salvar = true;

            if (this.enderecoDeEntrega.tipoEndereco !== TipoEnderecoEntrega.VendaDireta) {
              await this.completarEnderecoEntrega(false, true);
            } else {
              await this.copiaEnderecoVendaDireta();
            }
          }

          if (this.pedido.origemGI === 3 && this.premissasSistema.habilitarApiImposto) {
            await this.atualizaValores();
          }
        });
      } else {
        if (
          this.clienteFaturamento === null ||
          this.clienteFaturamento === undefined ||
          this.clienteFaturamento.cep === null ||
          this.clienteFaturamento.cep === undefined
        ) {
          this.pedido.vendaDireta = false;
          this.clienteFaturamento = undefined;
        }
      }
    });
  }

  buscaEnderecoCompleto() {
    return (
      this.clienteFaturamento.rua +
      ', ' +
      this.clienteFaturamento.n +
      ' ' +
      this.clienteFaturamento.bairro +
      ' ' +
      this.clienteFaturamento.cidade +
      ' ' +
      this.clienteFaturamento.uf +
      ' - ' +
      this.clienteFaturamento.cep +
      ' - ' +
      this.clienteFaturamento.compl
    );
  }

  buscarStringBoxConectorDoInversor(idInversor, qtdInversor, inversorSugerido) {
    if (qtdInversor === null || qtdInversor === undefined) qtdInversor = 0;

    if (this.pedido.origemGI === 0) {
      this.carregandoService.mostra('buscarStringBoxConectorDoInversor');

      let idFornecedorPainel;

      if (this.premissas.multiFornecedores) {
        idFornecedorPainel = this.pedido.painelProduto.idFornecedor;
      }

      if (this.premissas.pCentroDistribuicao || this.premissas.pMultiFornecedor) {
        idFornecedorPainel = this.pedido.idFornecedor;
      }

      this.pedidoService
        .buscarStringBoxConectorDoInversor(idInversor, qtdInversor, this.pedido.painel, idFornecedorPainel)
        .subscribe(
          async (produtos) => {
            try {
              await this.executarAlteracoesEmLote(async () => {
                for (const p of produtos) {
                  if (this.itens.some((i) => i.produto === p.produto)) {
                    const item = this.itens.find((i) => i.produto === p.produto);
                    if (qtdInversor == 0) {
                      await this.excluirProduto(item, !inversorSugerido || this.premissas.removerItemSugEdicao);
                    } else if (item.qt !== p.qt) {
                      item.qt = p.qt;
                      await this.atualizaValorProduto(item);
                    }
                  } else if (qtdInversor > 0) {
                    this.itens.push(p);
                    this.buscarUltimosPrecos();
                    this.alterou = true;
                    await this.excluirCupomDesconto();
                    await this.atualizaValorProduto(p);
                  }
                }
              });
            } finally {
              this.carregandoService.esconde('buscarStringBoxConectorDoInversor');
            }
          },
          (erro) => {
            this.carregandoService.esconde('buscarStringBoxConectorDoInversor');
            this.notificacaoService.erro(erro);
          }
        );
    }
  }

  async alterarValorTotal() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(InserirValorModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        valorArredondamento: this.valorArredondamento,
        valorSemDesconto: await this.simularValores(TipoCalculoPedido.SimularDesconto, 0),
        valorAnterior:
          this.pedido.valorTotalFixo !== null && this.pedido.valorTotalFixo !== undefined
            ? Number(this.pedido.valorTotalFixo)
            : Number(this.pedido.valorFinal),
        valorMinimo:
          this.pedido.da === 0
            ? await this.simularValores(
                TipoCalculoPedido.SimularDesconto,
                (Number(this.pedido.valorTotal) * this.descontoMaximo) / 100
              )
            : Number(this.pedido.valorFinal)
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        // antigo
        let novoDesconto = await this.simularValores(TipoCalculoPedido.SimularValorFinal, Number(result));
        if (novoDesconto < 0) {
          swal({
            title: 'ATENÇÃO!!!',
            html: 'Não foi possível chegar no valor especificado!!!',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning'
          }).catch(swal.noop);
        } else {
          this.alterou = true;
          this.pedido.valorDa = Number(novoDesconto.toFixed(2));
          this.usandoArredondamento = true;
          await this.atualizaDesconto(1, true, true);
          // novo
          this.pedido.valorTotalFixo = Number(result);

          if (this.pedido.multiFormaPagamento) {
            this.pedido.formasPagamento = await this.calcularFormasDePagamento(
              this.pedido.formasPagamento,
              this.valorParaFormasPagamento,
              this.pedido.valorTotalFixo
            );
          }
        }
      }
    });
  }

  buscarPerguntasEntrega(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarPerguntasEntrega');

      this.questionarioService.consultarLista().subscribe(
        (perg) => {
          this.perguntasOriginais = perg;

          this.carregandoService.esconde('buscarPerguntasEntrega');
          resolve();
        },
        (erro) => {
          this.carregandoService.esconde('buscarPerguntasEntrega');
          this.notificacaoService.erro(erro);
          reject();
        }
      );
    });
  }

  selecionarSegurosObrigatorios(
    pedido: Pedido,
    segurosObrigatorios: VendaSeguro[],
    segurosManuais: VendaSeguro[],
    segurosObrigatoriosRemovidos: VendaSeguro[],
    seguros: Seguro[]
  ) {
    if (
      !pedido ||
      (pedido &&
        (pedido.seguros === undefined || pedido.seguros === null || pedido.seguros.length === 0 || pedido.flag === 1))
    )
      return;

    const kwpPedido = this.potencia;

    if (pedido.seguros) {
      pedido.seguros = pedido.seguros.filter((p) => !segurosObrigatorios.some((x) => x.idSeguro === p.idSeguro));
    } else {
      this.pedido.seguros = [];
    }

    segurosObrigatorios = seguros
      .filter(
        (p) =>
          kwpPedido <= p.obgAte &&
          p.obgAte != 0 &&
          !pedido.seguros.some((x) => x.idSeguro === p.id) &&
          !segurosManuais.some((x) => x.idSeguro === p.id) &&
          !segurosObrigatoriosRemovidos.some((x) => x.idSeguro === p.id)
      )
      .map((p) => ({ idSeguro: p.id, idCupom: pedido.idCupom, valor: 0, obrigatorioRemovido: false }));

    if (pedido.flag !== 1) {
      pedido.seguros = [...segurosObrigatorios, ...pedido.seguros];
    }
  }

  selecionarSegurosManuais(pedido: Pedido, seguros: Seguro[]) {
    return seguros
      .filter((p) => pedido.valorFinal >= p.manualAPartirDe)
      .map((p) => ({
        idSeguro: p.id,
        idCupom: pedido.idCupom,
        obrigatorioRemovido: false,
        valor: pedido.seguros.find((x) => x.idSeguro === p.id)
          ? pedido.seguros.find((x) => x.idSeguro === p.id).valor
          : 0
      }));
  }

  calcularValorSeguro(percSeguro, pedido: Pedido, alterou: boolean): number {
    const valorPedido = pedido.valorFinal - (!alterou && this.premissas.calcCondPagNoFinal ? Number(pedido.taxaDA) : 0);

    if (this.premissas.regraCalculos === 0) {
      return (percSeguro / 100) * valorPedido;
    } else {
      return valorPedido / (1 - percSeguro / 100) - valorPedido;
    }
  }

  async selecionarSeguro(seguro: Seguro, $event?) {
    this.alterou = true;
    if (!this.permissoesPedidoFuncionario.podeEditarSeguro) {
      if (
        this.verificaSeSeguroObrigatorio(seguro) ||
        (this.integrador && this.verificaSeSeguroManual(seguro, this.segurosManuais))
      ) {
        if ($event) {
          $event.target.checked = this.verificaSeSeguroObrigatorio(seguro);
        }

        return;
      }

      if (
        this.pedido.seguros.map((p) => p.idSeguro).includes(seguro.id) &&
        !this.segurosObrigatorios.map((p) => p.idSeguro).includes(seguro.id)
      ) {
        this.pedido.seguros = [...this.pedido.seguros.filter((p) => p.idSeguro !== seguro.id)];
        await this.atualizaValores();
      } else {
        this.pedido.seguros.push({
          idSeguro: seguro.id,
          idCupom: this.pedido.idCupom,
          valor: 0,
          obrigatorioRemovido: false
        });
        await this.atualizaValores();

        if ($event) {
          $event.target.checked = false;
        }
      }
    } else {
      if (this.pedido.seguros.map((p) => p.idSeguro).includes(seguro.id)) {
        this.pedido.seguros = [...this.pedido.seguros.filter((p) => p.idSeguro !== seguro.id)];

        if (this.verificaSeSeguroObrigatorio(seguro)) {
          this.segurosObrigatoriosRemovidos.push({
            idSeguro: seguro.id,
            idCupom: this.pedido.idCupom,
            valor: 0,
            obrigatorioRemovido: true
          });
        }
        await this.atualizaValores();
      } else {
        this.pedido.seguros.push({
          idSeguro: seguro.id,
          idCupom: this.pedido.idCupom,
          valor: 0,
          obrigatorioRemovido: false
        });

        if (this.verificaSeSeguroObrigatorio(seguro)) {
          this.segurosObrigatoriosRemovidos = [
            ...this.segurosObrigatoriosRemovidos.filter((p) => p.idSeguro !== seguro.id)
          ];
        }
        await this.atualizaValores();

        if ($event) {
          $event.target.checked = false;
        }
      }
    }
  }

  calcularTotalValorSeguro(pedido: Pedido, seguros: Seguro[], segurosManuais: VendaSeguro[], alterou: boolean) {
    if (!pedido) return 0;

    seguros.forEach((seguro) => {
      if (this.verificaSeSeguroManual(seguro, segurosManuais)) {
        if (!seguro.valor && segurosManuais.find((p) => p.idSeguro === seguro.id)) {
          seguro.valor = segurosManuais.find((p) => p.idSeguro === seguro.id).valor;
        }
      } else {
        seguro.valor = Number(this.calcularValorSeguro(seguro.percentual, pedido, alterou).toFixed(2));
      }
    });

    if (pedido && (pedido.seguros === undefined || pedido.seguros === null || pedido.seguros.length === 0)) return 0;

    pedido.seguros.forEach((seguro) => {
      const seguroFind = seguros.find((p) => p.id === seguro.idSeguro);

      seguro.valor = seguroFind ? seguroFind.valor : seguro.valor;
    });

    return pedido.seguros.reduce((acc, curr) => {
      return acc + curr.valor;
    }, 0);
  }

  verificaSeSeguroObrigatorio(seguro: Seguro): boolean {
    return this.segurosObrigatorios.some((p) => p.idSeguro === seguro.id);
  }

  verificaSeSeguroManual(seguro: Seguro, segurosManuais: VendaSeguro[]): boolean {
    return segurosManuais.some((p) => p.idSeguro === seguro.id);
  }

  verificaSeSeguroSelecionado(seguro: Seguro): boolean {
    return this.pedido.seguros && this.pedido.seguros.some((p) => p.idSeguro === seguro.id);
  }

  abrirModalValorManual(seguro: Seguro) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(AlterarValorSeguroModalComponent, {
      width: largura > 350 ? '380px' : $('body').width().toString() + 'px',
      data: { idSeguro: seguro.id, valorSeguro: seguro.valor },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.seguros.find((p) => p.id === result.idSeguro).valor = result.valorSeguro;
        await this.atualizaValores();
      }
    });
  }

  buscarItensInvalidosEstoqueMinimo(): InvalidoEstoqueMinimo[] {
    if (!this.premissas.pUsarEstoqueMinimo) {
      return [];
    }

    let invalidos: InvalidoEstoqueMinimo[] = [];

    this.itens
      .filter((p) => p.qt > 0)
      .map((item: ItemPedido) => {
        if (item.produtoTela.familia === 7) {
          this.itensComposicao
            .filter((c) => c.proKit === item.produto)
            .map((itemComposicao: ProdutoKit) => {
              const disponivel =
                itemComposicao.produtoMP.qtEstoque - itemComposicao.produtoMP.qtReserva - item.qt * itemComposicao.qt;

              if (disponivel <= itemComposicao.produtoMP.qtEstoqueMinimo) {
                invalidos.push({
                  descricao: itemComposicao.produtoMP.descricaoAtual,
                  qtDisponivel: disponivel,
                  qtEstoqueMinimo: itemComposicao.produtoMP.qtEstoqueMinimo
                });
              }
            });
        } else {
          const disponivel = item.produtoTela.qtEstoque - item.produtoTela.qtReserva - item.qt;

          if (disponivel <= item.qtEstoqueMinimo) {
            invalidos.push({
              descricao: item.det1,
              qtDisponivel: disponivel,
              qtEstoqueMinimo: item.qtEstoqueMinimo
            });
          }
        }
      });

    return invalidos;
  }

  buscarItensSemEstoqueDisp(): string[] {
    let invalidos = [];

    this.itens
      .filter((p) => p.qt > 0)
      .map((item: ItemPedido) => {
        if (item.produtoTela.familia === 7) {
          this.itensComposicao
            .filter((c) => c.proKit === item.produto)
            .map((itemComposicao: ProdutoKit) => {
              const resto =
                itemComposicao.produtoMP.qtEstoque - itemComposicao.produtoMP.qtReserva - item.qt * itemComposicao.qt;

              if (resto < 0) {
                invalidos.push(itemComposicao.produtoMP.descricaoAtual);
              }
            });
        } else {
          const resto = item.produtoTela.qtEstoque - item.produtoTela.qtReserva - item.qt;

          if (resto < 0) {
            invalidos.push(item.produtoTela.descricao);
          }
        }
      });

    return invalidos;
  }

  abrirModalMultiFormasPagamento() {
    if (this.pedido.formasPagamento === null || this.pedido.formasPagamento === undefined) {
      this.pedido.formasPagamento = [];
    }

    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(MultiFormaPagamentoModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        formasPagamentoMulti: this.pedido.formasPagamento,
        valorSubTotalPedido: this.pedido.valorTotal,
        valorPedido: this.pedido.valorFinal,
        editavel: !this.integrador && this.editavel,
        pCentroDistribuicao: this.premissas.pCentroDistribuicao,
        pMultiFornecedor: this.premissas.pMultiFornecedor,
        idCD: this.pedido.idFornecedor
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result && result.alterou) {
        this.pedido.formasPagamento = result.formasPagamento;
        this.alterou = true;
        await this.atualizaMultiFormasPagamento();
      }
    });
  }

  resetarFormasPagamento() {
    if (this.pedido.multiFormaPagamento) {
      this.pedido.formasPagamento = [];
    } else {
      this.pedido.formasPagamento = [];
      // this.pedido.formasPagamento.push(new VendaFormaPag());
    }

    this.alterou = true;
    this.atualizaValores();
  }

  enviarAvisoEstoqueMinimo(dados) {
    this.carregandoService.mostra('enviarAvisoEstoqueMinimo');
    this.produtoService.enviarAvisoEstoqueMinimo(dados).subscribe(
      (f) => {
        this.carregandoService.esconde('enviarAvisoEstoqueMinimo');
      },
      (erro) => {
        this.carregandoService.esconde('enviarAvisoEstoqueMinimo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  validarEnderecoDeEntrega() {
    if (this.tipo === 0) {
      // || this.pedido.tipoFrete === 1) {
      return this.enderecoDeEntrega && this.enderecoDeEntrega.uf && this.enderecoDeEntrega.cidade;
    } else {
      return (
        (this.enderecoDeEntrega.tipoEndereco !== TipoEnderecoEntrega.Personalizado ||
          (this.vendaEntregaComp !== null && this.vendaEntregaComp !== undefined && this.vendaEntregaComp.validar())) &&
        this.enderecoDeEntrega !== null &&
        this.enderecoDeEntrega !== undefined &&
        this.enderecoDeEntrega.cep !== null &&
        this.enderecoDeEntrega.cep !== undefined &&
        (this.enderecoDeEntrega.antigo ||
          (this.enderecoDeEntrega.tipo !== null &&
            this.enderecoDeEntrega.tipo !== undefined &&
            this.enderecoDeEntrega.cpfCnpj !== null &&
            this.enderecoDeEntrega.cpfCnpj !== undefined &&
            this.enderecoDeEntrega.cpfCnpj !== '' &&
            (this.enderecoDeEntrega.tipo === 1 ||
              !this.premissas.inscricaoEstadualObg ||
              (this.enderecoDeEntrega.rgIe !== null &&
                this.enderecoDeEntrega.rgIe !== undefined &&
                this.enderecoDeEntrega.rgIe !== '')) &&
            this.enderecoDeEntrega.nome !== null &&
            this.enderecoDeEntrega.nome !== undefined &&
            this.enderecoDeEntrega.nome !== '' &&
            (!this.premissasSistema.nomeTelResponsavelObgPedido ||
              (this.pedido.tipoFrete === 1 && !this.premissasSistema.mostrarEnderecoEntregaFob) ||
              (this.premissasSistema.nomeTelResponsavelObgPedido &&
                this.enderecoDeEntrega.nomeResponsavel !== null &&
                this.enderecoDeEntrega.nomeResponsavel !== undefined &&
                this.enderecoDeEntrega.nomeResponsavel !== '' &&
                this.enderecoDeEntrega.telefoneResponsavel !== null &&
                this.enderecoDeEntrega.telefoneResponsavel !== undefined &&
                this.enderecoDeEntrega.telefoneResponsavel !== '' &&
                this.enderecoDeEntrega.telefoneResponsavel
                  .replace('(', '')
                  .replace(')', '')
                  .replace('-', '')
                  .replace(new RegExp('_', 'g'), '')
                  .trim() !== ''))))
      );
    }
  }

  possuiModulo(modulo: Number) {
    return this.premissas.modulosAtivos.some((p) => p === modulo);
  }

  exibirObservacoes() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(ObservacoesModalComponent, {
      width: largura > 1050 ? '1000px' : $('body').width().toString() + 'px',
      data: { idCupom: this.pedido.idCupom, pedido: this.pedido },
      panelClass: 'modal-card'
    });
  }

  anexos() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(PedidoAnexoComponent, {
      width: this.integrador && largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        idPedido: this.pedido.idCupom,
        podeEditar: true
      },
      panelClass: 'modal-card'
    });
    dialogRef.afterClosed().subscribe(() => {});
  }

  alterarApelido() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(PedidoApelidoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        idCupom: this.pedido.idCupom,
        apelido: this.pedido.comprador,
        editavel: true
      },
      panelClass: 'modal-card'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.pedido.comprador = result;
      }
    });
  }

  calcularEstoqueLote() {
    this.carregandoService.mostra('calcularEstoqueLote');

    this.pedidoService
      .calcularEstoqueLote(this.itens, this.pedido.idFornecedor, this.pedido.idCupom, this.pedido.orcamento)
      .subscribe(
        (resp: any) => {
          if (resp.data <= new Date()) {
            this.pedido.dispEstoque = true;
            this.pedido.dataDispEstoque = null;
          } else {
            this.pedido.dispEstoque = false;
            this.pedido.dataDispEstoque = resp.data;
          }

          this.estoqueLoteOk = true;
          this.carregandoService.esconde('calcularEstoqueLote');
        },
        (erro) => {
          this.estoqueLoteOk = false;

          this.carregandoService.esconde('calcularEstoqueLote');
          this.notificacaoService.erro(erro);
        }
      );
  }

  async validarEstoqueLoteUnico() {
    try {
      this.carregandoService.mostra('validarEstoqueLoteUnico');
      await this.pedidoService
        .calcularEstoqueLote(this.itens, this.pedido.idFornecedor, this.pedido.idCupom, this.pedido.orcamento)
        .toPromise();
      return true;
    } catch (erro) {
      return false;
    } finally {
      this.carregandoService.esconde('validarEstoqueLoteUnico');
    }
  }

  async validarCombinacao() {
    try {
      this.carregandoService.mostra('validarCombinacao');
      await this.pedidoService.validarCombinacao(this.itens).toPromise();
      this.carregandoService.esconde('validarCombinacao');
      return true;
    } catch (erro) {
      this.carregandoService.esconde('validarCombinacao');

      this.notificacaoService.erro(erro);

      if (!this.integrador && !this.premissasUsuario.travarValidarKitCustomizado) {
        const result = await swal({
          title: 'Atenção!!',
          text: 'Combinação está fora do padrão. Deseja continuar mesmo assim?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false
        });

        if (result.value) {
          this.pedido.foraDaRegra = true;
        }

        return result.value;
      } else {
        return false;
      }
    }
  }

  async buscarPodeAlterarVendedor() {
    try {
      this.carregandoService.mostra('buscarPodeAlterarVendedor');
      this.podeAlterarVendedor = await this.funcionarioService.consultarPodeAlterarVendedor().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPodeAlterarVendedor');
    }
  }

  trocarDeLote(produto: Produto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(TrocarDeLoteModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { idProduto: produto.idProduto, idFornecedor: this.pedido.idFornecedor, idCupom: this.pedido.idCupom },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.pedido.dispEstoque = result.dispEstoque;
        this.pedido.dataDispEstoque = result.dataDispEstoque;
      }
    });
  }

  buscarDescricaoTelhado(fileira: Fileira) {
    switch (fileira.telhado) {
      case 8:
        return this.estruturasPersonalizadas.textoFibrometal;

      case 12: {
        return this.estruturasPersonalizadas.textoEstruturaCalhetao;
      }

      case 13:
        return this.estruturasPersonalizadas.textoEstruturaCarport;

      default:
        return fileira.telhadoDescricao;
    }
  }

  async verificarSeTemProdutoBloqueado(idcupom) {
    try {
      this.carregandoService.mostra('verificarSeTemProdutoBloqueado');
      const produtosBloqueados = await this.produtoService.consultarProdutosBloqueadosPorIdCupom(idcupom).toPromise();
      if (produtosBloqueados.length > 0) {
        this.produtosBloqueados = produtosBloqueados;
        this.notificacaoService.aviso('Há produtos indisponíveis no pedido');
        return true;
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('verificarSeTemProdutoBloqueado');
    }
  }

  async buscarProdutosBloqueados(idcupom: string): Promise<ProdutoBloqueado[]> {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarProdutosBloqueados');
      this.pedidoService.consultarProdutosBloqueados(idcupom).subscribe(
        (resp: any) => {
          this.produtosBloqueados = resp;
          this.carregandoService.esconde('buscarProdutosBloqueados');
          resolve(resp);
        },
        (erro) => {
          this.carregandoService.esconde('buscarProdutosBloqueados');
          this.notificacaoService.erro(erro);
          reject([]);
        }
      );
    });
  }

  async completarEnderecoEntrega(restaurar: boolean, marcarComoAlterado: boolean) {
    if (restaurar) {
      this.enderecoDeEntrega = new VendaEntrega();
      this.enderecoDeEntrega.tipoEndereco = TipoEnderecoEntrega.NaoInformado;

      this.carregandoService.mostra('buscarCidadePorCodIGBE');
      this.ibgeService.buscarCidadePorCodIGBE(this.pedido.ibgeInstalacao).subscribe(
        (cidade) => {
          if (cidade) {
            this.enderecoDeEntrega.ibge = Number(cidade.cod);
            this.enderecoDeEntrega.uf = cidade.uf;
            this.enderecoDeEntrega.cidade = cidade.cidade;
          }

          this.gerarEnderecoEntregaCompleto();
          this.completarEnderecoEntrega(false, true);
          this.carregandoService.esconde('buscarCidadePorCodIGBE');
        },
        (erro) => {
          this.gerarEnderecoEntregaCompleto();
          this.completarEnderecoEntrega(false, true);
          this.carregandoService.esconde('buscarCidadePorCodIGBE');
        }
      );

      return;
    }

    if (this.enderecoDeEntrega === undefined || this.enderecoDeEntrega === null) {
      return;
    }

    if (this.enderecoDeEntrega.tipoEndereco !== TipoEnderecoEntrega.NaoInformado) {
      return;
    }

    switch (this.premissasSistema.tipoEnderecoEntregaPadrao) {
      case 1:
        if (this.pedido.cliente && this.cliente) {
          await this.copiaEnderecoIntegrador(!marcarComoAlterado);
        }
        break;
      case 2:
        if (this.pedido.vendaDireta && this.clienteFaturamento) {
          await this.copiaEnderecoVendaDireta();
        }
        break;
      case 3:
        // if (this.pedido.cliente && this.cliente) {
        //   if (this.enderecoDeEntrega.cidade === this.cliente.cidade && this.enderecoDeEntrega.uf === this.cliente.uf) {
        //     await this.copiaEnderecoIntegrador(!marcarComoAlterado);
        //   }
        // }
        break;
      default:
        this.gerarEnderecoEntregaCompleto();
        break;
    }

    if (marcarComoAlterado) {
      this.alterou = true;
      if (this.premissasSistema.limparCupomDescontoAoAlterarCidadeEntrega) {
        await this.excluirCupomDesconto();
      }
    }
  }

  gerarEnderecoEntregaCompleto() {
    if (this.enderecoDeEntrega === null || this.enderecoDeEntrega === undefined) {
      this.enderecoEntregaCompleto = '';
      this.pedido.obs2 = this.enderecoEntregaCompleto;
      return;
    }

    const componentes: string[] = [];

    if (this.enderecoDeEntrega.rua) {
      componentes.push(this.enderecoDeEntrega.rua);
    }

    if (this.enderecoDeEntrega.numero) {
      componentes.push(this.enderecoDeEntrega.numero);
    }

    if (this.enderecoDeEntrega.bairro) {
      componentes.push(this.enderecoDeEntrega.bairro);
    }

    if (this.enderecoDeEntrega.cidade) {
      componentes.push(`${this.enderecoDeEntrega.cidade}/${this.enderecoDeEntrega.uf}`);
    }

    if (this.enderecoDeEntrega.cep) {
      componentes.push(`CEP ${this.enderecoDeEntrega.cep}`);
    }

    if (this.enderecoDeEntrega.complemento) {
      componentes.push(this.enderecoDeEntrega.complemento);
    }

    this.enderecoEntregaCompleto = componentes.join(', ');
    this.pedido.obs2 = this.enderecoEntregaCompleto;
  }

  public readonly TipoEnderecoEntrega = TipoEnderecoEntrega;

  mostrarEstoqueDoProduto(produto: Produto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(EstoqueProdutoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { produto, idFornecedor: this.pedido.idFornecedor },
      panelClass: 'modal-card'
    });
  }

  async buscarPrecificacoesUF() {
    try {
      this.carregandoService.mostra('buscarPrecificacoesUF');
      this.precificacoesUF = await this.precificacaoUFService.consultar().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPrecificacoesUF');
    }
  }

  async atualizarDescontoPrecificacaoUF(temArredondamento?) {
    if (this.premissasSistema.usarPrecificacaoPorUF && this.pedido.origemGI !== 2) {
      await this.executarAlteracoesEmLote(async () => {
        this.descAcresPrecificacaoUF = this.precificacoesUF.some((p) => p.uf === this.enderecoDeEntrega.uf)
          ? this.precificacoesUF.find((p) => p.uf === this.enderecoDeEntrega.uf)
          : { percentual: 0, uf: '', tipoDa: 0 };

        for (const item of this.itens) {
          await this.atualizaValorProduto(
            item,
            this.pedido.valorTotalFixo !== null &&
              this.pedido.valorTotalFixo !== undefined &&
              this.pedido.valorTotalFixo > 0,
            false
          );
        }

        this.pedido.valorTotal = this.itens.reduce((acc, curr) => acc + Number(curr.pUnitario) * Number(curr.qt), 0);

        await this.atualizaDesconto(this.alterou ? 0 : 1, true, temArredondamento);
      });
    }
  }

  async buscarLogDisp(idCupom: string) {
    try {
      this.carregandoService.mostra('buscarLogDisp');

      const log = await this.pedidoService.consultarLogVendaCupom(idCupom).toPromise();

      if (log !== null && log !== undefined) {
        if (log.campo === 'DispEstoque') {
          this.textoUltLogDispEstoque = `${log.nomeUsuario}, ${log.valorNovo === '1' ? 'ativou' : 'desativou'} a chave Disponível`;
        } else if (log.campo === 'DataDispEstoque') {
          this.textoUltLogDispEstoque = `${log.nomeUsuario}, mudou a data da Disponibilidade para: ${log.valorNovo}`;
        }
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarLogDisp');
    }
  }

  exibirLogsDisp() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(LogsVendaCupomModalComponent, {
      width: largura > 800 ? '1100px' : $('body').width().toString() + 'px',
      data: { idCupom: this.idPedido },
      panelClass: 'modal-card'
    });
  }

  calcularPrecificacao(precoUnitario: number) {
    const precoBase = precoUnitario;

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      precoUnitario = this.precificacaoUFService.calcularPrecificacaoUF(precoBase, this.descAcresPrecificacaoUF);
    }

    if (
      this.premissasSistema.habilitarPrecificacaoPorIntegrador &&
      this.cliente &&
      this.pedido.origemGI === OrigemGI.LojaProdutos
    ) {
      precoUnitario = this.precificacaoUFService.calcularPrecificacaoIntegrador(
        precoUnitario,
        precoBase,
        this.cliente.tipoPrecificacao,
        this.cliente.valorPrecificacao
      );
    }

    return precoUnitario;
  }

  async buscarDescontoMaximo(idCliente?: number) {
    try {
      this.carregandoService.mostra('buscarDescontoMaximo');

      let idClienteDesconto = idCliente;

      if (this.integrador) {
        idClienteDesconto = this.usuarioLogado.id;
      } else if (idClienteDesconto === undefined || idClienteDesconto === null) {
        idClienteDesconto = this.cliente.id;
      }

      this.descontoMaximo = await this.pedidoService
        .calcularDescontoMaximo(idClienteDesconto, this.vendedorSelecionado, this.pedido.da, this.pedido.cupomDesconto)
        .toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarDescontoMaximo');
    }
  }

  async calcularFormasDePagamento(formas, valorParaFormas, valorTotal) {
    try {
      this.carregandoService.mostra('calcularFormasDePagamento');

      return await this.pedidoService.calcularFormasDePagamento(formas, valorParaFormas, valorTotal).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('calcularFormasDePagamento');
    }
  }

  async funPodeVerSubstituicao() {
    const result = await this.pedidoService.podeVerSubstituicao(this.pedido.nOrcamento).toPromise();

    this.podeVerSubstituicao = result && this.pedido.idEtapa != null && !this.integrador;
  }

  async alterouTipoDesconto() {
    this.alterou = true;
    this.alterouNaTela = true;
    this.pedido.percentual = 0;
    await this.buscarDescontoMaximo();
    await this.atualizaDesconto(0, false);
  }

  podeAplicarCupomDesconto() {
    return (
      this.limiteDescontoUsuarioLogado > 0 &&
      this.editavel &&
      this.pedido.flag === 4 &&
      this.pedido.tipoCupomDesconto === this.tipoCupomDesconto &&
      ((this.pedido.tipoCupomDesconto === 0 &&
        Number(this.percentualCupomDesconto) > 0 &&
        Number(this.pedido.cupomDesconto) === Number(this.percentualCupomDesconto)) ||
        (this.pedido.tipoCupomDesconto === 1 &&
          Number(this.valorCupomDesconto) > 0 &&
          Number(this.pedido.cupomDescontoValor) === Number(this.valorCupomDesconto)))
    );
  }

  podeSalvarCupomDesconto() {
    return (
      this.limiteDescontoUsuarioLogado > 0 &&
      this.editavel &&
      this.pedido.flag === 4 &&
      ((this.tipoCupomDesconto === 0 && Number(this.percentualCupomDesconto) > 0) ||
        (this.tipoCupomDesconto === 1 && Number(this.valorCupomDesconto) > 0))
    );
  }

  validarCD() {
    return (
      // this.pedido.tipoFrete === 1 ||
      this.podeAlterarCD ||
      !this.premissas.pCentroDistribuicao ||
      (this.premissas.pCentroDistribuicao && !this.premissasSistema.habilitarCDPorCidade) ||
      (this.premissas.pCentroDistribuicao &&
        this.premissasSistema.habilitarCDPorCidade &&
        this.enderecoDeEntrega &&
        this.enderecoDeEntrega.ibge !== null &&
        this.enderecoDeEntrega.ibge !== undefined &&
        ((this.ibgeEntrega && this.ibgeEntrega.cd === this.pedido.idFornecedor) ||
          (this.enderecoDeEntrega && Number(this.enderecoDeEntrega.ibge) === Number(this.cidadeOriginal))))
    );
  }

  buscaValorMarkup() {
    // this.carregandoService.mostra('buscaValorMarkup');

    const objeto: {
      itens: ItemPedido[];
      valorTotal: number;
      valorFinal: number;
      subTotal: number;
      aliqImpRef: number;
      da: number;
      valorDa: number;
      valorFrete: number;
      taxaDa: number;
      valorRepasse: number;
      idCupom: string;
      idFornecedor: number;
      mostraValoresServico: boolean;
    } = {
      itens: this.itens,
      valorTotal: this.pedido.valorTotal,
      valorFinal:
        this.pedido.valorTotalFixo === null || this.pedido.valorTotalFixo === undefined
          ? this.pedido.valorFinal
          : this.pedido.valorTotalFixo,
      subTotal: 0,
      aliqImpRef: this.pedido.aliqImpRef,
      da: this.pedido.da,
      valorDa: this.pedido.valorDa,
      valorFrete: this.pedido.frete,
      taxaDa: this.valorTaxaCond,
      valorRepasse: this.valorLiquido,
      idCupom: this.pedido.idCupom,
      idFornecedor: this.pedido.idFornecedor,
      mostraValoresServico: true
    };

    this.carregandoService.mostra('calculoIndicador');

    this.indicadorService.calculoIndicador(objeto).subscribe(
      async (data) => {
        this.cor = data.text;

        if (this.mostrarValoresServico !== data.mostraValoresServico) {
          this.mostrarValoresServico = data.mostraValoresServico;

          if (this.alterou && !this.mostrarValoresServico) {
            this.pedido.valorServico = 0;
            this.valorLiquido = 0;
            await this.atualizaValores();
          }
        }

        this.carregandoService.esconde('calculoIndicador');
      },
      (erro) => {
        this.cor = erro.error.text;
        this.carregandoService.esconde('calculoIndicador');
      }
    );
  }

  podeAlinharPraDireita() {
    // total
    let qtd = 1;

    // valor serviço
    if (
      (this.pedido.origemGI !== 2 || (this.pedido.origemGI === 2 && this.premissasSistema.usarRemessaMenuAvulso)) &&
      ((this.integrador && this.cliente !== null && this.cliente !== undefined && this.cliente.podeVerValorServico) ||
        !this.integrador)
    ) {
      qtd++;
    }

    // valor projeto
    if (this.premissas.pUsarValorProjeto) {
      qtd++;
    }

    // sub-total
    if (!this.integrador) {
      qtd++;
    }

    // impostos
    if (this.pedido.origemGI === 2 && this.premissasSistema.usarIPISeparado && !this.integrador) {
      qtd++;
    }

    return qtd > 3;
  }

  alterouItens() {
    return (
      this.jsonItensBanco !==
      JSON.stringify(
        this.itens.map((p) => {
          return { idProduto: p.produto, qt: p.qt };
        })
      )
    );
  }

  montarImpostosTotal(): any[] {
    return Object.values<any>(
      this.pedido.impostos.reduce((accumulator, currentItem) => {
        const key = currentItem.imposto;
        if (accumulator[key]) {
          accumulator[key].valor += currentItem.valor;
        } else {
          accumulator[key] = {
            imposto: currentItem.imposto.toUpperCase(),
            valor: currentItem.valor,
            soma: currentItem.soma
          };
        }
        return accumulator;
      }, {})
    ); /*.filter(p => p.valor > 0)*/
  }

  buscarImpostosDoItem(idProduto) {
    return this.pedido && this.pedido.impostos ? this.pedido.impostos.filter((p) => p.idProduto === idProduto) : [];
  }

  selecionarLotes() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(VendaItemLotesModalComponent, {
      width: largura > 1050 ? '1000px' : $('body').width().toString() + 'px',
      data: {
        idCupom: this.pedido.idCupom,
        somenteLeitura: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  fazerSimulacaoFinanciamento(visualizar: boolean = false) {
    if (visualizar && this.infoSimulacaoPedido) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['financiamento/edit-simulacao', this.infoSimulacaoPedido.id])
      );
      window.open(url, '_blank');
      return;
    }

    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(NovaSimulacaoModalComponent, {
      width: largura > 1000 ? '80%' : $('body').width().toString() + 'px',
      data: {
        cliente: this.cliente,
        temDadosPessoais: this.pedido.vendaDireta,
        dadosPessoais: this.clienteFaturamento,
        potencia: this.potencia,
        pedido: this.pedido
      },
      panelClass: 'modal-card',
      maxHeight: '100vh'
    });

    dialogRef.afterClosed().subscribe((result: GiFinSimulacaoModel) => {
      if (result) {
        this.infoSimulacaoPedido = result;
        const url = this.router.serializeUrl(this.router.createUrlTree(['financiamento/edit-simulacao', result.id]));
        window.open(url, '_blank');
      }
    });
  }

  get integradorBloqueadoFinanciamento(): boolean {
    return !!this.cliente && this.cliente.podeVerFinanciamento === false;
  }

  async buscarSimulacaoPedido(idCupom: string) {
    // Integrador bloqueado para financiamento: o botão não é exibido, então não há o que buscar.
    if (this.integradorBloqueadoFinanciamento) {
      this.infoSimulacaoPedido = null;
      return;
    }

    this.carregandoService.mostra('buscarSimulacaoPedido');

    try {
      this.infoSimulacaoPedido = (await this.simulacaoService.buscarSimulacaoPedido(idCupom).toPromise()).result;
      this.carregandoService.esconde('buscarSimulacaoPedido');
    } catch (erro) {
      this.infoSimulacaoPedido = null;
      this.carregandoService.esconde('buscarSimulacaoPedido');
    }
  }

  buscarTiposDeEnderecoEntrega() {
    this.tiposDeEnderecoEntrega = [];

    if (this.cliente) {
      this.tiposDeEnderecoEntrega.push({ id: TipoEnderecoEntrega.Integrador, nome: 'Integrador' });
    }

    if (this.pedido.vendaDireta && this.clienteFaturamento !== null && this.clienteFaturamento !== undefined) {
      this.tiposDeEnderecoEntrega.push({ id: TipoEnderecoEntrega.VendaDireta, nome: 'Cliente Final' });
    }

    if (this.premissas.cadastrarEnderecoEntrega) {
      this.tiposDeEnderecoEntrega.push({ id: TipoEnderecoEntrega.Personalizado, nome: 'Personalizado' });
    }
  }

  async alterouTipoDeEnderecoEntrega() {
    switch (this.enderecoDeEntrega.tipoEndereco) {
      case TipoEnderecoEntrega.Integrador:
        this.alterouNaTela = true;
        await this.copiaEnderecoIntegrador();
        break;

      case TipoEnderecoEntrega.VendaDireta:
        this.alterouNaTela = true;
        await this.copiaEnderecoVendaDireta();
        break;

      case TipoEnderecoEntrega.Personalizado:
        this.alterouNaTela = true;
        this.editandoEnderecoEntrega = true;
        this.enderecoDeEntrega = new VendaEntrega();
        this.enderecoDeEntrega.tipoEndereco = TipoEnderecoEntrega.Personalizado;
        // this.adicionarEnderecoEntrega();
        break;

      default:
        break;
    }

    this.alterou = true;
  }

  teste() {
    (this.enderecoDeEntrega.tipoEndereco !== TipoEnderecoEntrega.Personalizado || this.vendaEntregaComp.validar()) &&
      this.enderecoDeEntrega !== null &&
      this.enderecoDeEntrega !== undefined &&
      this.enderecoDeEntrega.cep !== null &&
      this.enderecoDeEntrega.cep !== undefined &&
      (this.enderecoDeEntrega.antigo ||
        (this.enderecoDeEntrega.tipo !== null &&
          this.enderecoDeEntrega.tipo !== undefined &&
          this.enderecoDeEntrega.cpfCnpj !== null &&
          this.enderecoDeEntrega.cpfCnpj !== undefined &&
          this.enderecoDeEntrega.cpfCnpj !== '' &&
          (this.enderecoDeEntrega.tipo === 1 ||
            !this.premissas.inscricaoEstadualObg ||
            (this.enderecoDeEntrega.rgIe !== null &&
              this.enderecoDeEntrega.rgIe !== undefined &&
              this.enderecoDeEntrega.rgIe !== '')) &&
          this.enderecoDeEntrega.nome !== null &&
          this.enderecoDeEntrega.nome !== undefined &&
          this.enderecoDeEntrega.nome !== '' &&
          (!this.premissasSistema.nomeTelResponsavelObgPedido ||
            (this.premissasSistema.nomeTelResponsavelObgPedido &&
              this.enderecoDeEntrega.nomeResponsavel !== null &&
              this.enderecoDeEntrega.nomeResponsavel !== undefined &&
              this.enderecoDeEntrega.nomeResponsavel !== '' &&
              this.enderecoDeEntrega.telefoneResponsavel !== null &&
              this.enderecoDeEntrega.telefoneResponsavel !== undefined &&
              this.enderecoDeEntrega.telefoneResponsavel !== '' &&
              this.enderecoDeEntrega.telefoneResponsavel
                .replace('(', '')
                .replace(')', '')
                .replace('-', '')
                .replace(new RegExp('_', 'g'), '')
                .trim() !== ''))));

    console.log(
      '(this.enderecoDeEntrega.tipoEndereco !== TipoEnderecoEntrega.Personalizado || this.vendaEntregaComp.validar()):',
      this.enderecoDeEntrega.tipoEndereco !== TipoEnderecoEntrega.Personalizado || this.vendaEntregaComp.validar()
    );
    console.log(
      'this.enderecoDeEntrega !== null && this.enderecoDeEntrega !== undefined && this.enderecoDeEntrega.cep !== null && this.enderecoDeEntrega.cep !== undefined:',
      this.enderecoDeEntrega !== null &&
        this.enderecoDeEntrega !== undefined &&
        this.enderecoDeEntrega.cep !== null &&
        this.enderecoDeEntrega.cep !== undefined
    );
    console.log('this.enderecoDeEntrega.antigo:', this.enderecoDeEntrega.antigo);
    console.log('endereco:', this.enderecoDeEntrega);
  }

  possuiRepasse() {
    return this.pedido.valorServico === null ||
      this.pedido.valorServico === undefined ||
      Number(this.pedido.valorServico) === 0
      ? null
      : true;
  }
}
